var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorld5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2000,
    height: 857,
    xmlns: "http://www.w3.org/2000/svg",
    strokeLinejoin: "round",
    strokeWidth: 0.2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    d: "m1383,261.6l1.5,1.8l-2.9,0.8l-2.4,1.1l-5.9,0.8l-5.3,1.3l-2.4,2.8l1.9,2.7l1.4,3.2l-2,2.7l0.8,2.5l-0.9,2.3l-5.2,-0.2l3.1,4.2l-3.1,1.7l-1.4,3.8l1.1,3.9l-1.8,1.8l-2.1,-0.6l-4,0.9l-0.2,1.7l-4.1,0l-2.3,3.7l0.8,5.4l-6.6,2.7l-3.9,-0.6l-0.9,1.4l-3.4,-0.8l-5.3,1l-9.6,-3.3l3.9,-5.8l-1.1,-4.1l-4.3,-1.1l-1.2,-4.1l-2.7,-5.1l1.6,-3.5l-2.5,-1l0.5,-4.7l0.6,-8l5.9,2.5l3.9,-0.9l0.4,-2.9l4,-0.9l2.6,-2l-0.2,-5.1l4.2,-1.3l0.3,-2.2l2.9,1.7l1.6,0.2l3,0l4.3,1.4l1.8,0.7l3.4,-2l2.1,1.2l0.9,-2.9l3.2,0.1l0.6,-0.9l-0.2,-2.6l1.7,-2.2l3.3,1.4l-0.1,2l1.7,0.3l0.9,5.4l2.7,2.1l1.5,-1.4l2.2,-0.6l2.5,-2.9l3.8,0.5l5.4,0z",
    fill: "#cbd6f4",
    id: "AF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Angola",
    d: "m1121.2,572l0.6,2l-0.7,3.1l0.9,3l-0.9,2.4l0.4,2.2l-11.7,-0.1l-0.8,20.5l3.6,5.2l3.6,4l-10.4,2.6l-13.5,-0.9l-3.8,-3l-22.7,0.2l-0.8,0.5l-3.3,-2.9l-3.6,-0.2l-3.4,1.1l-2.7,1.2l-0.5,-4l0.9,-5.7l2,-5.9l0.3,-2.7l1.9,-5.8l1.4,-2.6l3.3,-4.2l1.9,-2.9l0.6,-4.7l-0.3,-3.7l-1.6,-2.3l-1.5,-3.9l-1.3,-3.8l0.3,-1.4l1.7,-2.5l-1.6,-6.2l-1.2,-4.3l-2.8,-4.1l0.6,-1.2l2.3,-0.9l1.7,0.1l2,-0.7l16.7,0.1l1.3,4.7l1.6,3.9l1.3,2.1l2.1,3.3l3.8,-0.5l1.8,-0.9l3.1,0.9l0.9,-1.6l1.5,-3.7l3.5,-0.3l0.3,-1.1l2.9,0l-0.5,2.3l6.8,-0.1l0.1,4.1l1.1,2.4l-0.9,3.9l0.4,4l1.8,2.4l-0.4,7.6l1.4,-0.6l2.4,0.2l3.5,-1l2.6,0.4z",
    fill: "#cbd6f4",
    id: "svg_1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Angola",
    d: "m1055.3,539l-1.5,-4.8l2.3,-2.8l1.7,-1.1l2.1,2.2l-2,1.4l-1,1.6l-0.2,2.8l-1.4,0.7z",
    fill: "#cbd6f4",
    id: "svg_2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1088,228l0.4,1.2l1.4,-0.6l1.2,1.7l1.3,0.7l0.6,2.3l-0.5,2.2l1,2.7l2.3,1.5l0.1,1.7l-1.7,0.9l-0.1,2.1l-2.2,3.1l-0.9,-0.4l-0.2,-1.4l-3.1,-2.2l-0.7,-3l0.1,-4.4l0.5,-1.9l-0.9,-1l-0.5,-2.1l1.9,-3.1z",
    fill: "#cbd6f4",
    id: "AL"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1296.2,336.7l1.3,5.1l-2.8,0l0,4.2l1.1,0.9l-2.4,1.3l0.2,2.6l-1.3,2.6l0,2.6l-1,1.4l-16.9,-3.2l-2.7,-6.6l-0.3,-1.4l0.9,-0.4l0.4,1.8l4.2,-1l4.6,0.2l3.4,0.2l3.3,-4.4l3.7,-4.1l3,-4l1.3,2.2z",
    fill: "#cbd6f4",
    id: "AE"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Argentina",
    d: "m669.1,851.7l-3,-0.2l-5,0l-6,-13.6l3.1,2.8l4.3,4.6l7.8,3.7l7.3,1.5l-0.8,3l-4.4,0.3l-3.3,-2.1z",
    fill: "#cbd6f4",
    id: "svg_3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Argentina",
    d: "m638.6,644.7l11.3,10.4l4.6,1l7.3,4.8l5.9,2.5l1.1,2.8l-4.2,9.8l5.8,1.7l6.3,1l4.2,-1l4.3,-5l0.3,-5.6l2.6,-1.3l3.2,3.8l0.4,5.1l-4.2,3.5l-3.3,2.6l-5.3,6.3l-6,8.7l-0.5,5.2l-0.4,6.6l1.2,6.4l-0.9,1.4l0.4,4.1l0.3,3.4l7.8,5.5l0.2,4.4l3.9,2.8l0.3,3.1l-3.3,8.2l-7,3.5l-10.2,1.3l-6,-0.7l2.1,3.9l0.1,4.7l1.8,3.2l-2.5,2.3l-5.1,0.9l-5.6,-2.4l-1.5,1.7l2.5,6.3l4,1.9l2.3,-2l2.5,3.3l-4.2,2l-2.9,4l1.2,6.3l-0.1,3.4l-4.8,0l-3,3.2l0.1,4.8l6.5,4.6l5.2,1.2l0.2,5.7l-4.6,3.5l-0.6,7.3l-3.5,2.4l-0.9,2.9l4.2,6.5l4.6,3.5l-2.1,-0.3l-4.9,-1l-12.1,-0.8l-3.5,-3.6l-1.9,-4.6l-3.1,0.4l-2.6,-2.3l-3.1,-6.5l2.7,-2.8l0.1,-3.9l-1.8,-3.2l0.7,-5.4l-1.1,-8.3l-1.8,-3.7l1.8,-1.2l-1.4,-2.4l-2.8,-1.2l0.8,-2.7l-3.1,-2.4l-3.7,-7.3l1.7,-1.3l-3.3,-7.8l-0.8,-6.5l-0.2,-5.7l2.5,-2.3l-3.3,-6.3l-1.6,-5.8l3,-4.2l-1.4,-5.4l1.6,-6.2l-1.4,-5.9l-1.6,-1.2l-4.9,-11.1l2.1,-6.6l-1.7,-6.2l0.9,-5.9l2.6,-6l3.3,-4l-2,-2.5l0.8,-2.1l-1.6,-10.7l5.6,-3.1l1.2,-6.7l-0.9,-1.6l4,-5.8l7.5,1.6l3.7,4.6l1.6,-5.2l6.4,0.3l1,1.4z",
    fill: "#cbd6f4",
    id: "svg_4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1230.8,253l-1.8,0.2l-2.8,-3.7l-0.2,-1l-2.3,0l-1.9,-1.7l-1,0.1l-2.4,-1.8l-4.2,-1.6l-0.1,-3.1l-1.3,-2.2l7,-1l1.4,1.6l2.2,1.1l-0.7,1.6l3.2,2.2l-1.1,2.1l2.6,1.7l2.5,1l0.9,4.5z",
    fill: "#cbd6f4",
    id: "AM"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Australia",
    d: "m1743,763.6l3.7,2.2l3.3,-0.9l4.9,-1.2l2.8,0.4l-4.5,7.6l-3.3,2.1l-4,5.2l-0.6,-1.8l-6.6,4.4l-0.8,-0.3l-3,-0.2l0.5,-5.4l2,-4.2l0.6,-5.6l2,-2.9l3,0.6z",
    fill: "#cbd6f4",
    id: "svg_5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Australia",
    d: "m1793.5,590.2l1.2,5l4,-2.4l1.4,2.7l2.3,2.5l-1.1,2.9l0.2,5.5l0.2,3.2l1.3,0.8l0.4,5.5l-1.2,3.3l0.8,4.3l5.4,3.4l3.2,3l3.2,2.8l-1.1,1.6l2.3,4l0.5,7l2.6,-1.4l1.5,2.7l1.6,-0.9l-0.7,6.8l2.9,3.9l1.9,2.4l2.8,5.2l0,5.2l-1,3.7l-1.8,3.9l0.7,5.5l-2.5,5.7l-2.1,3l-3.8,5.7l-1.5,3.7l-3.1,4.6l-5,5.8l-5.5,3.2l-4.4,4.9l-3.3,3.2l-4.4,5.5l-3.7,3.2l-3.9,4.8l-3.1,4.4l-0.8,2.1l-4.3,2.2l-6.1,0.2l-6.3,2.7l-3.8,2.4l-4.8,2.8l-2.7,-2.9l-2.6,-1.1l2.6,-3.3l-3.5,1.2l-7.2,4.6l-3.6,-1.7l-2.4,-1l-2.8,-0.5l-4.1,-1.8l-1.3,-4l1.5,-4.8l0.4,-3.3l-1.4,-2.6l-4.7,-0.7l3.2,-3.2l0.9,-4.7l-4.7,4.4l-5.3,1.2l4.5,-3.5l2.5,-3.7l3.5,-3.2l1.6,-4.7l-6.8,5.4l-4.3,2.2l-4.3,5.1l-3,-2.6l1.7,-3.4l-1.4,-4.7l-1.8,-2.4l1.6,-1.5l-5.3,-3.9l-3.8,-0.1l-4,-3.2l-9.9,0.6l-7.9,2.3l-6.9,2.2l-5,-0.4l-7,3.3l-5.3,1.4l-2.3,3.4l-3,2.6l-4.7,0.2l-3.6,0.5l-4.2,-1.1l-4.2,0.7l-3.8,0.3l-4.5,3.4l-1.5,-0.3l-3.4,1.8l-3.4,2l-3.8,-0.2l-3.5,0l-4.1,-4.1l-2.4,-1.2l1.5,-3.7l2.9,-0.9l1.5,-1.4l0.6,-2.3l2.3,-4.5l0.7,-3.8l-0.7,-6.5l0.2,-3.7l1.4,-3.6l-0.9,-4.2l0.3,-1.9l-1.7,-2.6l0.7,-5l-1.9,-5.1l-0.1,-2.7l1.8,2.8l-0.5,-6l2.3,1.9l1.1,2.5l0.6,-3.3l-1.6,-5.1l-0.1,-2l-0.8,-1.9l1.3,-3.7l1.5,-1.6l1.3,-3.2l0.1,-3.8l3.1,-4.6l-0.4,4.9l3.1,-4.4l4.9,-2.2l3.2,-2.7l4.7,-2.4l2.6,-0.5l1.4,0.8l4.8,-2.4l3.5,-0.7l1.1,-1.4l1.5,-0.6l3.1,0.2l6.2,-1.9l3.5,-2.9l2,-3.4l3.9,-3.2l0.7,-2.6l0.7,-3.5l4.9,-5.5l1.4,5.6l2.6,-1.3l-1.5,-3l2.3,-3.1l2.2,1.4l1.5,-4.9l3.5,-3.2l1.8,-2.5l2.9,-1.1l0.4,-1.8l2.3,0.7l0.4,-1.6l2.6,-0.9l2.8,-0.9l3.7,3l2.6,3.8l3.5,0l3.5,0.6l-0.7,-3.5l3.5,-5.1l2.7,-1.7l-0.6,-1.6l2.9,-3.7l3.7,-2.3l2.7,0.8l4.9,-1.2l0.3,-3.3l-3.9,-2.1l3.1,-0.9l3.6,1.6l2.7,2.6l4.5,1.6l1.7,-0.6l3.3,2l3.5,-1.9l2,0.6l1.5,-1.3l2.2,3.2l-2,3.5l-2.5,2.6l-1.9,0.2l0.3,2.5l-2.2,3.2l-2.5,3.2l0.2,1.8l3.8,3.6l4,2l2.5,2.2l3.3,3.8l1.6,0l2.6,1.7l0.5,2l4.9,2.1l4.1,-2.2l1.8,-3.4l1.7,-2.9l1.3,-3.5l2.6,-5.1l-0.2,-3.1l0.7,-1.9l-0.1,-3.6l1.4,-4.9l1.3,-1.3l-0.6,-2.1l1.8,-3.4l1.5,-3.5l0.4,-1.9l2.3,-2.4l1.3,3.2l-0.1,4l1.3,0.8l-0.1,2.7l1.6,3.2l-0.1,3.7l-0.6,2.3z",
    fill: "#cbd6f4",
    id: "svg_6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1070.6,190.8l-0.3,0.8l0.7,2.1l-0.2,2.6l-2.8,0l1.1,1.4l-1.3,4l-0.9,1.1l-4.4,0.1l-2.4,1.5l-4.2,-0.5l-7.3,-1.7l-1.3,-2.1l-4.9,1.1l-0.5,1.2l-3.1,-0.9l-2.6,-0.2l-2.3,-1.2l0.7,-1.5l-0.2,-1.1l1.4,-0.3l2.7,1.7l0.6,-1.7l4.4,0.3l3.5,-1.1l2.4,0.2l1.7,1.3l0.4,-1.1l-1,-4.1l1.7,-0.8l1.6,-2.9l3.8,2.1l2.6,-2.6l1.7,-0.5l4,1.9l2.3,-0.3l2.4,1.2z",
    fill: "#cbd6f4",
    id: "AT"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Azerbaijan",
    d: "m1229,253.2l-3.8,-0.9l-3.2,-2.9l-1.2,-2.5l1,-0.1l1.9,1.7l2.3,0l0.2,1l2.8,3.7z",
    fill: "#cbd6f4",
    id: "svg_7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Azerbaijan",
    d: "m1235.3,236.2l2.5,-2.6l3.5,3.3l3.6,4.6l2.5,0.3l1.9,1.7l-4.2,0.5l0.1,5l-0.4,2.2l-1.7,1.5l0.8,3.1l-1.3,0.4l-3.9,-3.4l1.2,-3.1l-1.9,-1.9l-1.9,0.5l-5.3,4.7l-0.9,-4.5l-2.5,-1l-2.6,-1.7l1.1,-2.1l-3.2,-2.2l0.7,-1.6l-2.2,-1.1l-1.4,-1.6l1.1,-1.1l4.2,1.9l2.9,0.3l0.6,-0.7l-3.3,-3.5l1.2,-0.8l1.5,0.2l4.3,3.8l2.4,0.5l0.6,-1.6z",
    fill: "#cbd6f4",
    id: "svg_8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1154.9,530.4l-0.6,0.1l0,-0.3l-2,-6.1l-0.01,-0.06l-0.09,-1.04l-1.4,-2.9l3.5,0.5l1.7,-3.7l3.1,0.4l0.3,2.5l1.2,1.5l0,2.1l-1.4,1.3l-2.3,3.4l-2,2.3z",
    fill: "#cbd6f4",
    id: "BI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1016.5,177.1l-0.4,4.2l-1.3,0.2l-0.4,3.5l-4.4,-2.9l-2.5,0.5l-3.5,-2.9l-2.4,-2.5l-2.2,-0.1l-0.8,-2.2l3.9,-1.2l3.6,0.5l4.5,-1.3l3.1,2.7l2.8,1.5z",
    fill: "#cbd6f4",
    id: "BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1006.7,427l-0.2,2.1l1.3,3.8l-1.1,2.6l0.6,1.7l-2.8,4l-1.7,2l-1.1,4l0.2,4.1l-0.3,10.3l-4.7,0.8l-1.4,-4.4l0.3,-14.8l-1.2,-1.3l-0.2,-3.2l-2,-2.2l-1.7,-1.9l0.7,-3.4l2,-0.7l1.1,-2.8l2.8,-0.6l1.2,-1.9l1.9,-1.9l2,0l4.3,3.7z",
    fill: "#cbd6f4",
    id: "BJ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m988.5,406l-0.5,3.1l0.8,2.9l3.1,4.2l0.2,3.1l6.5,1.5l-0.1,4.4l-1.2,1.9l-2.8,0.6l-1.1,2.8l-2,0.7l-4.9,-0.1l-2.6,-0.5l-1.8,1l-2.5,-0.5l-9.8,0.3l-0.2,3.7l0.8,4.8l-3.9,-1.6l-2.6,0.2l-2,1.6l-2.5,-1.3l-1,-2.2l-2.5,-1.4l-0.4,-3.7l1.6,-2.7l-0.2,-2.2l4.5,-5.3l0.9,-4.4l1.5,-1.6l2.7,0.9l2.4,-1.3l0.8,-1.7l4.3,-2.8l1.1,-2l5.3,-2.7l3.1,-0.9l1.4,1.2l3.6,0z",
    fill: "#cbd6f4",
    id: "BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1500.6,360.3l0.6,4.6l-2.1,-1l1.1,5.2l-2.1,-3.3l-0.8,-3.3l-1.5,-3.1l-2.8,-3.7l-5.2,-0.3l0.9,2.7l-1.2,3.5l-2.6,-1.3l-0.6,1.2l-1.7,-0.7l-2.2,-0.6l-1.6,-5.3l-2.6,-4.8l0.3,-3.9l-3.7,-1.7l0.9,-2.3l3,-2.4l-4.6,-3.4l1.2,-4.4l4.9,2.8l2.7,0.3l1.2,4.5l5.4,0.9l5.1,-0.1l3.4,1.1l-1.6,5.4l-2.4,0.4l-1.2,3.6l3.6,3.4l0.3,-4.2l1.5,0l4.4,10.2z",
    fill: "#cbd6f4",
    id: "BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1132.6,221.6l-2.3,2.6l-1.3,4.5l2.1,3.6l-4.6,-0.8l-5,2l0.3,3.2l-4.6,0.6l-3.9,-2.3l-4,1.8l-3.8,-0.2l-0.8,-4.2l-2.8,-2.1l0.7,-0.8l-0.6,-0.8l0.6,-2l1.8,-2l-2.8,-2.7l-0.7,-2.4l1.1,-1.4l1.8,2.6l1.9,-0.4l4,0.9l7.6,0.4l2.3,-1.6l5.9,-1.5l4,2.3l3.1,0.7z",
    fill: "#cbd6f4",
    id: "BG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1083,214.3l1.9,-0.1l-1.1,2.8l2.7,2.5l-0.5,2.9l-1.1,0.3l-0.9,0.6l-1.6,1.5l-0.4,3.5l-4.8,-2.4l-2.1,-2.7l-2.1,-1.4l-2.5,-2.4l-1.3,-1.9l-2.7,-3l0.8,-2.6l2,1.5l1,-1.4l2.3,-0.1l4.5,1.1l3.5,-0.1l2.4,1.4z",
    fill: "#cbd6f4",
    id: "BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1141.6,162.7l-3.9,-0.2l-0.8,0.6l1.5,2l2,4l-4.1,0.3l-1.3,1.4l0.3,3.1l-2.1,-0.6l-4.3,0.3l-1.5,-1.5l-1.7,1.1l-1.9,-0.9l-3.9,-0.1l-5.7,-1.5l-4.9,-0.5l-3.8,0.2l-2.4,1.6l-2.3,0.3l-0.5,-2.8l-1.9,-2.8l2.8,-1.3l-0.4,-2.4l-1.7,-2.3l-0.6,-2.7l4.7,0l4.8,-2.3l0.5,-3.4l3.6,-2l-1,-2.7l2.7,-1l4.6,-2.3l5.3,1.5l0.9,1.5l2.4,-0.7l4.8,1.4l1.1,2.9l-0.7,1.6l3.8,4l2.1,1.1l0,1.1l3.4,1.1l1.7,1.6l-1.6,1.3z",
    fill: "#cbd6f4",
    id: "BY"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m487.8,399.8l-1.7,0l1.3,-7.2l0.7,-5.1l0.1,-1l0.7,-0.3l0.9,0.8l2.5,-3.9l1.1,-0.1l-0.1,1l1,0l-0.3,1.8l-1.3,2.7l0.4,1l-0.9,2.3l0.3,0.6l-1,3.3l-1.3,1.7l-1.1,0.2l-1.3,2.2z",
    fill: "#cbd6f4",
    id: "BZ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m662.5,631.4l-0.3,-2l-5.4,-3.3l-5.2,-0.1l-9.6,1.9l-2.1,5.6l0.2,3.5l-1.5,7.7l-1,-1.4l-6.4,-0.3l-1.6,5.2l-3.7,-4.6l-7.5,-1.6l-4,5.8l-3.9,0.9l-3.1,-8.9l-3.7,-7.2l1.1,-6.2l-3.2,-2.7l-1.2,-4.6l-3.2,-4.4l2.9,-6.9l-2.9,-5.4l1.1,-2.2l-1.2,-2.4l1.9,-3.2l-0.3,-5.4l0,-4.6l1.1,-2.1l-5.5,-10.4l4.2,0.6l2.9,-0.2l1.1,-1.9l4.8,-2.6l2.9,-2.4l7.3,-1.1l-0.4,4.8l0.9,2.5l-0.3,4.3l6.5,5.7l6.4,1.1l2.3,2.4l3.9,1.3l2.5,1.8l3.5,0l3.4,1.9l0.5,3.7l1.2,1.9l0.3,2.7l-1.7,0.1l2.8,7.5l10.7,0.3l-0.5,3.7l0.8,2.5l3.2,1.8l1.7,4l-0.6,5.1l-1.3,2.8l0.8,3.6l-1.6,1.4z",
    fill: "#cbd6f4",
    id: "BO"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m665.8,489.6l3.1,0.6l0.6,-1.4l-1,-1.2l0.6,-1.9l2.3,0.6l2.7,-0.7l3.2,1.4l2.5,1.3l1.7,-1.7l1.3,0.2l0.8,1.8l2.7,-0.4l2.2,-2.5l1.8,-4.7l3.4,-5.9l2,-0.3l1.3,3.6l3,11.2l3.1,1.1l0.1,4.4l-4.3,5.3l1.7,1.9l10.1,1l0.2,6.5l4.3,-4.2l7.1,2.3l9.5,3.9l2.8,3.7l-0.9,3.6l6.6,-2l11,3.4l8.5,-0.2l8.4,5.3l7.4,7.2l4.4,1.8l4.8,0.3l2.1,2l2,8.2l1.1,3.9l-2.1,10.6l-2.7,4.2l-7.7,8.9l-3.4,7.3l-4,5.5l-1.4,0.2l-1.3,4.7l0.9,12l-1.1,9.9l-0.3,4.2l-1.6,2.6l-0.5,8.6l-5.2,8.3l-0.5,6.7l-4.3,2.7l-1.1,3.9l-6,0l-8.5,2.4l-3.7,2.9l-6,1.9l-6.1,5.1l-4.1,6.4l-0.3,4.8l1.3,3.5l-0.3,6.5l-0.8,3.1l-3.4,3.6l-4.5,11.3l-4,5l-3.2,3.1l-1.5,6.1l-2.9,3.6l-2.1,-3.6l1.8,-3.1l-3.8,-4.3l-4.8,-3.6l-6.3,-4.1l-1.9,0.2l-6.3,-5l-3.4,0.7l6,-8.7l5.3,-6.3l3.3,-2.6l4.2,-3.5l-0.4,-5.1l-3.2,-3.8l-2.6,1.3l0.7,-3.7l0.3,-3.8l-0.3,-3.6l-2.1,-1.1l-2,1l-2.1,-0.3l-0.8,-2.4l-1.1,-5.9l-1.2,-1.9l-3.9,-1.8l-2.2,1.3l-5.9,-1.3l-0.4,-8.7l-2,-3.5l1.6,-1.4l-0.8,-3.6l1.3,-2.8l0.6,-5.1l-1.7,-4l-3.2,-1.8l-0.8,-2.5l0.5,-3.7l-10.7,-0.3l-2.8,-7.5l1.7,-0.1l-0.3,-2.7l-1.2,-1.9l-0.5,-3.7l-3.4,-1.9l-3.5,0l-2.5,-1.8l-3.9,-1.3l-2.3,-2.4l-6.4,-1.1l-6.5,-5.7l0.3,-4.3l-0.9,-2.5l0.4,-4.8l-7.3,1.1l-2.9,2.4l-4.8,2.6l-1.1,1.9l-2.9,0.2l-4.2,-0.6l-3.2,1.1l-2.6,-0.7l-0.1,-9.7l-4.4,3.7l-5,-0.1l-2.3,-3.5l-3.8,-0.3l1,-2.8l-3.3,-3.9l-2.6,-5.8l1.5,-1.1l-0.2,-2.8l3.4,-1.8l-0.7,-3.5l1.4,-2.2l0.3,-3l6.3,-4.4l4.6,-1.2l0.8,-1l5.1,0.3l2.2,-17.6l0.1,-2.8l-0.9,-3.6l-2.6,-2.4l0.1,-4.7l3.2,-1l1.1,0.7l0.2,-2.5l-3.3,-0.7l0,-4l11,0.2l1.9,-2.3l1.6,2.1l1,3.8l1.1,-0.8l3.1,3.4l4.4,-0.4l1.1,-2l4.2,-1.5l2.4,-1.1l0.7,-2.7l4.1,-1.8l-0.3,-1.4l-4.8,-0.5l-0.7,-4.1l0.3,-4.3l-2.5,-1.6l1.1,-0.6l4.1,0.8l4.5,1.6l1.7,-1.5l4.1,-1l6.4,-2.4l2.1,-2.5l-0.7,-1.8l3,-0.2l1.2,1.4l-0.8,2.9l2,0.9l1.2,3l-1.6,2.3l-1,5.4l1.4,3.3l0.3,3l3.5,3l2.8,0.3l0.6,-1.3l1.8,-0.3l2.6,-1.1l1.8,-1.7l3.2,0.6l1.3,-0.3z",
    fill: "#cbd6f4",
    id: "BR"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1633.1,472.8l2.2,-2.4l4.6,-3.6l-0.1,3.2l-0.1,4.1l-2.7,-0.2l-1.1,2.2l-2.8,-3.3z",
    fill: "#cbd6f4",
    id: "BN"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1488.8,323.5l2.6,2.1l0.5,3.9l-4.5,0.2l-4.7,-0.4l-3.2,1l-5.5,-2.5l-0.4,-1.2l2.6,-4.8l2.6,-1.6l4.3,1.4l2.9,0.2l2.8,1.7z",
    fill: "#cbd6f4",
    id: "BT"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1127.6,615.7l1.9,5.1l1.1,1.2l1.6,3.7l6.1,7l2.3,0.7l-0.1,2.3l1.5,4.1l4.3,1l3.4,2.9l-8.1,4.7l-5.2,4.8l-2,4.3l-1.8,2.4l-3,0.5l-1.2,3.1l-0.6,2l-3.6,1.4l-4.5,-0.3l-2.5,-1.8l-2.3,-0.7l-2.8,1.4l-1.5,3.1l-2.7,1.9l-2.8,2.9l-4,0.7l-1.1,-2.3l0.6,-3.9l-3,-6.1l-1.4,-1l0.6,-18.7l5.5,-0.2l0.8,-22.9l4.2,-0.2l8.7,-2.3l2,2.7l3.7,-2.5l1.7,0l3.2,-1.5l1,0.5z",
    fill: "#cbd6f4",
    id: "BW"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1121.3,446.5l3.9,2.5l3.1,2.6l0.1,2.1l3.9,3.3l2.4,2.8l1.4,3.8l4.3,2.6l0.9,2l-1.8,0.7l-3.7,-0.1l-4.2,-0.7l-2.1,0.5l-0.9,1.6l-1.8,0.2l-2.2,-1.4l-6.3,3.2l-2.6,-0.6l-0.8,0.5l-1.6,3.9l-4.3,-1.3l-4.1,-0.6l-3.6,-2.4l-4.7,-2.2l-3,2.1l-2.2,3.2l-0.5,4.5l-3.6,-0.3l-3.9,-1.1l-3.3,3.4l-3,6l-0.6,-1.9l-0.3,-2.9l-2.6,-2.1l-2.1,-3.3l-0.5,-2.3l-2.7,-3.4l0.5,-1.9l-0.6,-2.7l0.4,-5l1.4,-1.1l2.8,-6.5l4.6,-0.5l1,-1.7l1,0.2l1.4,1.4l7.1,-2.4l2.4,-2.5l2.9,-2.3l-0.6,-2.2l1.6,-0.6l5.5,0.4l5.2,-3l4,-7l2.8,-2.6l3.6,-1.1l0.7,2.7l3.3,4l0,2.7l-0.8,2.6l0.4,2l1.9,1.9l0.5,0.3z",
    fill: "#cbd6f4",
    id: "CF"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canada",
    d: "m665.9,203.6l3.4,0.9l4.7,-0.2l-3.3,2.6l-2,0.4l-5.5,-2.7l-0.6,-2.1l2.5,-1.9l0.8,3z",
    fill: "#cbd6f4",
    id: "svg_9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canada",
    d: "m680.3,187.6l-2.4,0.1l-5.8,-1.9l-3.5,-3l1.9,-0.5l5.9,1.6l4.2,2.6l-0.3,1.1z",
    fill: "#cbd6f4",
    id: "svg_10"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canada",
    d: "m372.4,191.3l-3.1,0.9l-6.3,-2.8l0,-2.2l-2.9,-2.2l0.3,-1.8l-4.3,-1.1l0.6,-3.4l1.5,-1.4l4.1,1.3l2.4,1l4.1,0.6l0.2,2.2l0.4,2.9l3.2,2.6l-0.2,3.4z",
    fill: "#cbd6f4",
    id: "svg_11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canada",
    d: "m711.5,177.8l-5,5.4l3.9,-2.1l2.9,1.4l-2.4,2.1l3.8,1.7l2.8,-1.5l4.3,1.9l-2.8,4.6l3.8,-1.1l-0.3,3.3l0.5,3.9l-3.6,5.6l-2.4,0.2l-2.9,-1.2l2.5,-5.1l-1.2,-0.8l-7.3,5.4l-3,-0.2l4.4,-3l-4.4,-1.5l-5.5,0.4l-9.6,-0.2l-0.2,-1.8l3.8,-2.3l-1.7,-1.6l5.4,-3.8l8.2,-9.9l4.2,-3.5l5,-2.1l2.1,0.2l-1.5,1.7l-3.8,3.9z",
    fill: "#cbd6f4",
    id: "svg_12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canada",
    d: "m351.5,156.4l1.5,0.8l5,-0.5l-7.2,6.9l0.3,5l-1.9,0l-0.7,-2.8l0.5,-2.9l-0.8,-1.9l1.3,-2.7l2,-1.9z",
    fill: "#cbd6f4",
    id: "svg_13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canada",
    d: "m634.9,108.9l-3.6,3l-1.7,-0.5l-0.1,-1.7l0.4,-0.4l2.8,-1.7l1.7,0.1l0.5,1.2z",
    fill: "#cbd6f4",
    id: "svg_14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canada",
    d: "m625.2,105.7l-7.2,3.2l-3,-0.2l0,-1.5l5,-2.7l6,0.1l-0.8,1.1z",
    fill: "#cbd6f4",
    id: "svg_15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canada",
    d: "m622.1,88.9l-0.9,2.5l2.7,-0.9l1.5,1.5l3.5,2l3.8,1.7l-1.4,2.7l3.5,-0.4l1.9,1.9l-5,1.8l-5.9,-1.4l-0.8,-2.6l-6.3,3.1l-8.2,2.9l0.7,-3.3l-6.3,0.5l5.7,-2.8l3.6,-4.5l5.1,-5.1l2.8,0.4z",
    fill: "#cbd6f4",
    id: "svg_16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canada",
    d: "m667,80.6l-4.9,0.3l0.7,-2.7l3.8,-3.1l4.3,-0.7l2.3,1.5l-1.5,2.3l-0.9,0.8l-3.8,1.6z",
    fill: "#cbd6f4",
    id: "svg_17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canada",
    d: "m592.5,69.9l-4.1,1.9l-4.2,-1.6l-3.9,0.5l-3.4,-2.4l5,-1.7l4.9,-2.3l3,1.5l1.6,1l0.4,1l0.7,2.1z",
    fill: "#cbd6f4",
    id: "svg_18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canada",
    d: "m645.5,212.5l-2.2,-3.6l2.9,-8.5l-1.6,-1.8l-3.7,1l-1.1,-1.6l-5.5,4.7l-3.2,4.9l-2.8,2.9l-2.5,1l-1.7,0.3l-1.1,1.5l-9.3,0l-7.8,0.1l-2.7,1.1l-6.8,4.4l0,-0.1l-0.9,-0.4l-2,0.9l-1.9,1.3l-1.8,-1.1l-4.7,0.8l-3.9,0.9l-1.9,0.8l-2.3,2.1l1.8,0.7l1.7,-0.4l0.3,0l-0.3,1.9l-4.8,0.7l-2.8,0.8l-1.7,1l-2.6,-0.6l-1.6,0.3l-2.9,1.8l-4.6,2l-2.7,-0.4l2,-2.2l3.7,-3.5l4.1,-2.1l1.1,-1.8l0.9,-3l3.8,-3.5l0.9,-4l1.1,3.9l3.8,0.9l2.4,-2.1l-1.4,-4.8l-0.9,-2l-4,-1.2l-3.8,-0.7l-3.9,0l-3.4,-0.8l-0.4,-1.4l-1.4,0.9l-1.2,-0.2l1.9,-2.1l-1.8,-0.8l1.9,-2.4l-1.2,-1.8l1.7,-1.8l-5.2,-0.9l-0.1,-3.6l-0.8,-0.8l-3.3,-0.2l-4.1,-1.2l-1.5,0.8l-1.8,1.5l-3.3,1l-3.1,2.5l-5.4,-1.7l-4.4,0.8l-3.9,-1.9l-4.6,-1l-3.3,-0.4l-1,-1l0.9,-3.4l-1.7,0l-1.3,2.4l-10.2,0l-17,0l-16.8,0l-14.9,0l-14.8,0l-14.7,0l-15.1,0l-4.8,0l-14.7,0l-14.1,0l-0.7,0l-5.4,-6.1l-1.6,-2.7l-7,-2.6l1.3,-5.5l3.6,-3.7l-4.1,-2.7l3.1,-4.9l-2.1,-4.4l2.5,-3.2l5.1,-2.9l3.2,-3.8l-4.6,-3.8l1.4,-6.9l1.1,-4.2l-1.6,-2.7l-0.8,-2.4l0.6,-3.1l-6.5,1.9l-7.6,3.3l-0.3,-3.8l-0.5,-2.6l-2.8,-1.6l-4.2,-0.2l35.6,-32.7l24.6,-20.4l6,1.3l3.3,2.6l3.7,0.5l6.3,-2.2l7,-1.7l5.3,0.6l8.9,-2.3l8.2,-1.3l0.2,2.2l4.5,-1.3l3.9,-2.5l2.1,0.6l1.4,4.8l9.5,-3.7l-3.9,4.1l6,-0.9l3.2,-1.5l4.6,0.3l3.9,2.2l7.5,2l4.7,0.9l4.4,-0.3l2.9,2.8l-8.5,2.7l6.4,1.1l11.9,-0.6l4.4,-1l1.4,3.3l7.1,-2.7l-2.1,-2.4l4.5,-1.8l5.2,-0.3l3.9,-0.5l2.1,1.3l1.5,2.9l5,-0.4l5.3,2.5l7.2,-0.9l6,0.1l2.4,-3.4l4.5,-0.9l4.9,1.8l-4.3,5.2l6.2,-4.4l3.2,0.2l6.4,-5.5l-1.6,-3.3l-2.9,-2.2l5.5,-5.9l8.2,-3.8l4.5,0.9l2,2.3l0.4,6l-5.8,2.6l6.7,1.1l-4.4,5.5l8.9,-4.2l2.2,3.5l-4.3,4l1.3,3.7l7.3,-3.9l6.5,-4.8l4.7,-5.9l5.5,0.4l5.4,0.8l3.6,2.7l-1.7,2.7l-5.1,2.9l0.9,2.9l-2.4,2.7l-10.9,3.9l-6.5,0.9l-3.2,-1.7l-3.3,2.8l-7.4,4.7l-3,2.5l-7.7,3.8l-6.5,0.4l-5.1,2.4l-2.9,3.8l-5.7,0.7l-8.7,4.7l-9.4,6.5l-5,4.6l-4.9,6.9l6,1l-1.5,5.5l-0.8,4.6l7.3,-1.2l7,2.6l3.3,2.3l1.7,2.8l4.9,1.7l3.6,2.5l7.6,0.4l4.8,0.6l-3.6,5.2l-1.7,6.1l0.1,6.9l4.4,5.9l4.7,-2l5.6,-6.4l2.3,-9.6l-1.7,-3.2l9,-2.9l7.5,-4.2l4.8,-4.2l1.7,-4l-0.4,-5.1l-3.2,-4.5l8.9,-6.2l1,-5.3l3.9,-9l3.8,-1.4l6.7,1.6l4.2,0.6l4.5,-1.6l3.1,2l3.6,3.4l0.2,2.2l7.7,0.5l-2.6,4.9l-2.3,7.4l3.8,1l1.6,3.5l8.2,-3.3l7.5,-6.6l4.2,-2.7l1.1,5.3l2.6,7.5l2,7.2l-3.4,3.8l4.8,3.4l2.9,3.4l6.9,1.6l2.4,1.9l0,5.2l3.4,0.8l1.1,2.3l-2,6.9l-4.3,2.3l-4.2,2.2l-8.8,2.2l-7.9,5l-8.6,1.1l-10.1,-1.4l-7.3,0l-5.3,0.4l-5.7,4.5l-7.4,2.8l-10.1,8.2l-7.9,5.8l4.7,-1l10.9,-8.3l12.3,-5.2l7.6,-0.6l3.3,3.1l-6.1,4.2l-0.6,6.7l0.1,4.8l5.6,3.1l8.6,-0.9l7.2,-7.1l-1,4.6l2.5,2.3l-7.4,4.1l-12.4,3.8l-5.8,2.5l-7.2,4.6l-3.7,-0.5l1.5,-5.3l10.4,-5.3l-8.1,0.2l-5.9,0.8z",
    fill: "#cbd6f4",
    id: "svg_19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canada",
    d: "m539,48.7l-4.7,2.4l10.5,-1.5l2.6,2.6l7.3,-2.7l1.8,1.7l-2.2,5.1l4.3,-2.1l2.8,-5.3l4.3,-0.8l3,0.8l2.2,2.1l-2.7,5.1l-2.4,3.7l4.2,2.6l5,2.6l-2.6,2.3l-7.1,0.5l0.8,2l-3.2,2l-6.7,-0.8l-5.7,-1.5l-5.1,0.3l-9.5,1.9l-11.3,0.8l-7.9,0.5l0.3,-2.6l-4.1,-1.4l-4.3,0.6l-0.6,-4.3l3.3,-0.6l7.3,-0.9l5.5,0.3l6.2,-1l-6.5,-1.2l-9.1,0.4l-5.7,-0.1l0,-1.9l11.7,-2.2l-6.3,0.1l-5.4,-1.4l7.8,-3.9l5.2,-2.1l14.2,-3.1l2.8,1z",
    fill: "#cbd6f4",
    id: "svg_20"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canada",
    d: "m578.5,47.2l-7,3.4l-2.3,-3.6l2.1,-0.8l5.5,-0.2l1.7,1.2z",
    fill: "#cbd6f4",
    id: "svg_21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canada",
    d: "m687.1,48.8l-0.7,1.4l-4.1,-0.1l-4.1,-0.1l-4.9,0.7l-0.9,-0.4l-2.1,-2.7l1.7,-1.8l2.2,-0.4l8.4,0.6l4.5,2.8z",
    fill: "#cbd6f4",
    id: "svg_22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canada",
    d: "m647.3,48.5l0.3,3.2l7.2,-4.1l11.7,-2.1l2.3,5.3l-3.2,3.4l9,-1.5l5.3,-2.1l6.8,2.6l3.7,2.5l-1.1,2.3l8.2,-1.2l1.9,3.4l8.4,2.1l2.2,2.1l0.9,5.1l-9.1,2.5l7.7,3.6l5.9,1.2l3.3,5l6.5,0.4l-3.3,3.9l-10.9,6.5l-4,-2.4l-3.8,-5.4l-5.9,0.7l-2.3,3.3l2.7,3.2l4.5,2.6l1,1.5l-0.1,5.7l-3.6,4.1l-4.7,-1.6l-8.6,-4.5l3.6,4.9l2.8,3.5l-0.3,2l-10.9,-2.3l-7.6,-3.4l-3.8,-2.7l2.4,-1.7l-4.8,-2.9l-4.7,-2.7l-0.9,1.6l-13.1,0.9l-2.4,-1.9l5.4,-4.2l8.1,-0.1l9.3,-0.7l-0.2,-2l3.1,-2.8l8.8,-5.4l0.4,-2.5l-0.5,-1.8l-4.7,-2.7l-7.1,-1.8l3.5,-1.4l-2,-3.4l-3.4,-0.3l-1.9,-1.8l-3.3,1.6l-7.9,0.7l-14,-1.2l-7.4,-1.6l-5.9,-0.8l-1.9,-1.9l6.3,-2.4l-5.7,0l3.3,-5.3l7.1,-4.6l6,-2.1l11.2,-1.4l-5.8,3.3z",
    fill: "#cbd6f4",
    id: "svg_23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canada",
    d: "m596.9,45l3.6,1.1l7.6,-0.7l-0.5,1.5l-6.1,2.5l3.8,2.2l-5.2,4.7l-8.4,2l-3.4,-0.4l-0.9,-2l-5.9,-4l1.7,-1.7l7.4,0.6l-0.9,-3.3l7.2,-2.5z",
    fill: "#cbd6f4",
    id: "svg_24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canada",
    d: "m619.5,50.5l-7.8,3.9l-4.4,-0.2l1.8,-4.6l2.6,-2.5l4.2,-2.2l5.2,-1.4l7.9,0.2l6.2,1.2l-10.1,4.6l-5.6,1z",
    fill: "#cbd6f4",
    id: "svg_25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canada",
    d: "m503.7,57.7l-13.5,2.6l0.6,-2.3l-6,-2.8l4.4,-2.2l7.5,-3.8l7.6,-3.4l0.4,-3.1l14,-0.8l4.2,1.1l9.5,0.3l1.9,1.4l1.6,2.2l-6.5,1.3l-13.9,3.6l-9.2,3.7l-2.6,2.2z",
    fill: "#cbd6f4",
    id: "svg_26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canada",
    d: "m628.9,39.3l-4.1,1.9l-5.2,-0.4l-3.2,-1.3l4.5,-2.2l6.9,-1.4l1.4,1.8l-0.3,1.6z",
    fill: "#cbd6f4",
    id: "svg_27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canada",
    d: "m620.1,30.6l0.2,2.3l-2.8,2.5l-5.8,3.8l-6.9,0.5l-3.2,-0.8l3.4,-2.9l-6.6,0.3l4.3,-3.8l3.8,0.2l7.7,-1.7l4.9,0.3l1,-0.7z",
    fill: "#cbd6f4",
    id: "svg_28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canada",
    d: "m580.7,33.2l-0.7,1.7l4.4,-0.8l3.6,0.2l-2.3,2.5l-5.1,2.3l-13.9,0.8l-12.3,2.2l-6,0.1l1.5,-1.6l10.7,-2.3l-17.9,0.6l-4.2,-0.9l11.7,-4.8l5.4,-1.4l8.3,1.7l2.9,2.9l6.1,0.4l0.7,-4.7l5.8,-1.8l3.1,0.5l-1.8,2.4z",
    fill: "#cbd6f4",
    id: "svg_29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canada",
    d: "m636.4,28.8l2.3,1.6l7.4,0l1.4,1.6l-2.8,1.8l3.1,1.1l1.2,1.2l4.9,0.2l5.1,0.4l7.1,-1l8.1,-0.5l5.8,0.4l2.3,1.9l-1,2l-3.6,1.4l-6.7,1.1l-4.3,-0.7l-11.8,0.8l-8,0.1l-5.6,-0.6l-8.6,-1.6l1.6,-2.8l2.1,-2.4l-1.4,-2.2l-7,-0.6l-2.6,-1.5l3.8,-2l7.2,0.3z",
    fill: "#cbd6f4",
    id: "svg_30"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canada",
    d: "m560.7,26.2l-5.8,3.7l-5.3,1.7l-3.8,0.2l-9.9,2.1l-7.1,0.8l-3.6,-1.1l11.7,-3.7l12.2,-3.1l5.5,0.1l6.1,-0.7z",
    fill: "#cbd6f4",
    id: "svg_31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canada",
    d: "m641.9,26.8l-1.8,0.1l-6.6,-0.3l0.7,-1.3l7.2,0.1l1.6,0.8l-1.1,0.6z",
    fill: "#cbd6f4",
    id: "svg_32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canada",
    d: "m583.1,25.9l-8.8,1.4l-3.3,-1.5l5.1,-1.5l6,-0.5l4.1,0.7l-3.1,1.4z",
    fill: "#cbd6f4",
    id: "svg_33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canada",
    d: "m590.9,21.7l-5.7,0.9l-6,0l1,-0.7l5.7,-1.3l1.7,0.2l3.3,0.9z",
    fill: "#cbd6f4",
    id: "svg_34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canada",
    d: "m637.7,24.2l-6.6,1l-1.6,-1.1l0.6,-1.7l2.2,-1.9l4.4,0.2l1.7,0.3l2.3,1.6l-3,1.6z",
    fill: "#cbd6f4",
    id: "svg_35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canada",
    d: "m623.9,23l-1.1,1.9l-5.3,-0.5l-4,-1.5l-7.8,-0.2l5.3,-1.3l-2.8,-1.1l2.2,-1.8l6.1,0.6l7.5,1.7l-0.1,2.2z",
    fill: "#cbd6f4",
    id: "svg_36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canada",
    d: "m678,16.9l2.7,1.5l-6.5,1.3l-10.6,3.5l-6.8,0.3l-6.8,-0.6l-1.6,-1.9l2.1,-1.6l4.3,-1.2l-6.6,0l-2,-1.5l0.4,-1.9l4.9,-1.9l4.1,-1.3l4,-0.3l-0.3,-1l8.3,-0.2l1.6,2.2l4.7,0.9l4.8,0.9l-0.7,2.8z",
    fill: "#cbd6f4",
    id: "svg_37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canada",
    d: "m757.2,2.9l8.7,0.3l6.7,0.5l5.2,1l-1.1,1l-9.8,1.7l-9,0.8l-4,0.9l7.5,0l-10.5,2.5l-6.8,1.2l-9.3,3.5l-8.1,0.7l-3.1,1l-11.3,0.4l4.4,0.6l-3.3,0.8l0.7,2.3l-5,1.6l-6.9,1.3l-3.5,1.8l-6.6,1.5l-0.5,1.1l6.5,-0.2l-1.1,1.2l-12.7,2.9l-8.5,-1.4l-11.7,0.8l-5,-0.6l-6.8,-0.3l2.1,-2.3l8,-1.1l2,-3.4l2.6,-0.3l7.5,2l-1.7,-3l-4.9,-0.9l5,-1.8l7.6,-1.1l2.8,-1.6l-3,-1.7l1.1,-2.2l9.4,0.1l2.2,0.5l7.3,-1.6l-7.3,-0.5l-12.6,0.3l-4.4,-1.4l-0.8,-1.7l-2.5,-1.2l1.1,-1.3l6,-0.8l4.2,-0.1l7.4,-0.6l6.8,-1.5l3.9,0.2l2.4,1.1l5,-2l5.2,-0.6l6.5,-0.4l10.4,-0.2l1.3,0.4l10.3,-0.6l7,0.2l7,0.2z",
    fill: "#cbd6f4",
    id: "svg_38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1034.4,197.5l0.2,1.1l-0.7,1.5l2.3,1.2l2.6,0.2l-0.3,2.5l-2.1,1.1l-3.8,-0.8l-1,2.5l-2.4,0.2l-0.9,-1l-2.7,2.2l-2.5,0.3l-2.2,-1.4l-1.8,-2.7l-2.4,1l0,-2.9l3.6,-3.5l-0.2,-1.6l2.3,0.6l1.3,-1.1l4.2,0l1,-1.3l5.5,1.9z",
    fill: "#cbd6f4",
    id: "CH"
  }), /*#__PURE__*/React.createElement("path", {
    className: "China",
    d: "m1602.2,381.9l-4.3,3.1l-4.9,-2l-1,-5.5l2.2,-2.9l5.8,-1.8l3.3,0.1l1.6,2.5l-2,2.8l-0.7,3.7z",
    fill: "#cbd6f4",
    id: "svg_39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "China",
    d: "m1625.6,185.5l9,4.5l6,5.8l7.6,0l2.6,-2.4l6.9,-1.9l1.3,5.7l-0.3,2.3l2.8,6.8l0.6,6.2l-6.9,-1.1l-2.9,2.2l4.7,5.4l3.9,7.5l-2.5,0.1l1.9,3.3l-5.5,-3.8l0,3.6l-6.4,2.7l2.8,3.4l-4.6,-0.3l-3.6,-2l-1.1,4.6l-3.9,3.4l-2.1,4.1l-6.3,1.8l-2.4,3l-4.8,1.8l1.3,-3l-2.3,-2.5l2,-4.3l-4.5,-3.3l-3.4,2.2l-3.6,4.5l-1.3,4.1l-5,0.3l-1.3,3l4.8,4.3l4.8,1.1l1.4,2.8l5.1,1.9l3.8,-4.6l5.9,2.5l3.5,0.2l2.3,3.3l-6.7,1.8l-1,3.5l-3.8,3.2l-0.9,4.5l7.1,3.5l4.6,6.3l5.5,5.9l5.5,4.9l1.6,4.8l-2.8,1.8l2.4,3.4l3.9,2l0.8,5.2l0.1,5.1l-2.8,0.6l-2.1,6.9l-2.3,8.5l-3.4,7.6l-6.4,5.9l-6.6,5.5l-6.1,0.7l-2.9,2.8l-2.3,-2l-2.5,3.1l-7.2,3.3l-5.8,0.9l-0.7,6.8l-3.1,0.4l-2.2,-4.7l0.9,-2.4l-7.8,-2.1l-2.4,1.1l-5.9,-1.7l-3.1,-2.6l0.3,-3.7l-5.3,-1.2l-3.1,-2.4l-4.1,3.4l-5.3,0.8l-4.4,-0.1l-2.7,1.6l-2.7,0.9l2,7.4l-3,-0.2l-0.8,-1.5l-0.5,-2.7l-3.8,1.9l-2.6,-1.2l-4.5,-2.4l0.8,-5.3l-3.7,-1.3l-2.4,-5.9l-5.6,1.1l-0.7,-7.6l4.2,-5.4l-0.9,-5.3l-1.3,-4.9l-2.7,-1.5l-2.7,-3.8l-3.1,0.5l-6.1,-1l1.2,-2.7l-3.6,-4l-3.2,2.7l-4.9,-1.5l-5.4,4l-3.9,4.8l-4.2,0.8l-2.8,-1.7l-2.9,-0.2l-4.3,-1.4l-2.6,1.6l-2.6,4.8l-1.5,-5.1l-3.1,1.4l-6.5,-0.7l-6.5,-1.4l-5,-2.9l-4.5,-1.2l-2.5,-3.1l-3.3,-0.9l-6.4,-4.2l-4.8,-2l-1.9,1.5l-8.6,-4.5l-6.2,-4l-3.2,-7.1l4.1,0.9l-0.6,-3.3l-3,-3.3l-0.8,-5.2l-7.7,-7.6l-9.5,-2.5l-2.9,-5l-4.7,-3l-1.5,-1.8l-1.8,-3.6l-0.5,-2.5l-3.7,-1.5l-1.5,0.7l-3.1,-6l1.1,-1.4l-1.2,-1.5l4.1,-3l3.2,-1.3l5.8,0.9l0.6,-4.1l6.4,-0.7l1,-2.6l6.9,-3.4l0.2,-1.4l-1.7,-3.7l2.9,-1.6l-8.8,-11l9.1,-2.5l2,-1.4l-1,-11.3l10.8,2.1l1.6,-2.9l-2.5,-6.2l3.8,-0.6l1.9,-4.2l1.7,-0.5l3.3,4.4l5.7,3.3l8.2,2.3l5.8,5.1l1.4,7.3l3,2.8l6.5,1.1l7.2,0.8l8,4l3.4,0.7l5,5.8l4.7,3.8l5.6,-0.2l11.3,1.5l6.4,-0.9l5.6,0.9l9.4,3.9l6.2,0l3.3,1.9l4.4,-3.4l7.2,-2.2l7.6,-0.2l4.9,-2.2l2,-3.4l2.4,-2.2l-1.9,-2.1l-2.9,-2.4l0.5,-4.1l3.2,0.6l5.9,1.3l3.2,-3.4l6.4,-2.4l1.3,-4.2l2.5,-1.8l6.8,-0.8l4.4,0.7l-0.8,-2.2l-7.2,-4.4l-5.2,-2l-2.5,2.3l-5.5,-1l-2.3,0.8l-2.8,-2.5l-0.3,-6.3l-0.6,-4.7l7.4,2.4l4.4,-3.9l-1.9,-2.8l-0.2,-6.5l1.3,-2l-2.5,-3.4l-3.7,-1.4l1.7,-3.1l5.1,-1.1l6.2,-0.2l8.6,1.9l6,2.2l7.7,6.2l3.8,2.7l4.5,3.8l6.2,6l10,2z",
    fill: "#cbd6f4",
    id: "svg_40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m955.9,435.2l2.5,1.4l1,2.2l2.5,1.3l2,-1.6l2.6,-0.2l3.9,1.6l1.5,9.2l-2.4,5.3l-1.5,7.3l2.4,5.5l-0.2,2.6l-2.6,0l-3.9,-1.2l-3.7,0l-6.7,1.2l-3.9,1.8l-5.6,2.4l-1.1,-0.2l0.4,-5.3l0.6,-0.8l-0.2,-2.5l-2.4,-2.7l-1.8,-0.4l-1.6,-1.8l1.2,-2.9l-0.5,-3.1l0.2,-1.8l0.9,0l0.4,-2.8l-0.4,-1.3l0.5,-0.9l2.1,-0.7l-1.4,-5.2l-1.3,-2.6l0.5,-2.2l1.1,-0.5l0.8,-0.6l1.5,1l4.4,0l1,-1.8l1,0.1l1.6,-0.7l0.9,2.7l1.3,-0.8l2.4,-1z",
    fill: "#cbd6f4",
    id: "CI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1072.8,454.2l-2.8,6.5l-1.4,1.1l-0.4,5l0.6,2.7l-0.5,1.9l2.7,3.4l0.5,2.3l2.1,3.3l2.6,2.1l0.3,2.9l0.6,1.9l-0.4,3.4l-4.5,-1.5l-4.6,-1.7l-7.1,-0.2l-0.7,-0.4l-3.4,0.8l-3.4,-0.8l-2.7,0.4l-9.3,-0.1l0.9,-5.1l-2.3,-4.3l-2.6,-1l-1.1,-2.9l-1.5,-0.9l0.1,-1.8l1.4,-4.6l2.7,-6.2l1.6,0l3.4,-3.8l2.1,-0.1l3.2,2.7l3.9,-2.2l0.5,-2.7l1.3,-2.6l0.8,-3.2l3,-2.6l1.1,-4.5l1.2,-1.5l0.8,-3.3l1.4,-4.1l4.7,-5l0.3,-2.1l0.6,-1.2l-2.3,-2.5l0.2,-2.1l1.5,-0.3l2.3,4.1l0.5,4.2l-0.2,4.3l3.2,5.8l-3.2,0l-1.6,0.4l-2.6,-0.6l-1.2,3l3.4,3.8l2.5,1.1l0.8,2.6l1.8,4.4l-0.8,1.8z",
    fill: "#cbd6f4",
    id: "CM"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1141.3,468.2l3.5,5.3l2.6,0.8l1.5,-1.1l2.6,0.4l3.1,-1.3l1.4,2.7l5.1,4.3l-0.3,7.5l2.3,0.9l-1.9,2.2l-2.1,1.8l-2.2,3.3l-1.2,3l-0.3,5.1l-1.3,2.5l-0.1,4.8l-1.6,1.8l-0.2,3.8l-0.8,0.5l-0.6,3.6l1.4,2.9l0.1,1l-1.2,10.3l1.5,3.6l-1,2.7l1.8,4.6l3.4,3.5l0.7,3.5l1.6,1.7l-0.3,1.1l-0.9,-0.3l-7.7,1.1l-1.5,0.8l-1.7,4.1l1.2,2.8l-1.1,7.6l-0.9,6.4l1.5,1.2l3.9,2.5l1.6,-1.2l0.2,6.9l-4.3,0l-2.2,-3.5l-2,-2.8l-4.3,-0.9l-1.2,-3.3l-3.5,2l-4.4,-0.9l-1.9,-2.9l-3.5,-0.6l-2.7,0.1l-0.3,-2l-1.9,-0.1l-2.6,-0.4l-3.5,1l-2.4,-0.2l-1.4,0.6l0.4,-7.6l-1.8,-2.4l-0.4,-4l0.9,-3.9l-1.1,-2.4l-0.1,-4.1l-6.8,0.1l0.5,-2.3l-2.9,0l-0.3,1.1l-3.5,0.3l-1.5,3.7l-0.9,1.6l-3.1,-0.9l-1.8,0.9l-3.8,0.5l-2.1,-3.3l-1.3,-2.1l-1.6,-3.9l-1.3,-4.7l-16.7,-0.1l-2,0.7l-1.7,-0.1l-2.3,0.9l-0.8,-2l1.4,-0.7l0.2,-2.8l1,-1.6l2,-1.4l1.5,0.7l2,-2.5l3.1,0.1l0.3,1.8l2.1,1.1l3.4,-4l3.3,-3.1l1.4,-2.1l-0.1,-5.3l2.5,-6.2l2.6,-3.3l3.7,-3.1l0.7,-2l0.1,-2.4l0.9,-2.2l-0.3,-3.7l0.7,-5.7l1.1,-4l1.7,-3.4l0.3,-3.9l0.5,-4.5l2.2,-3.2l3,-2.1l4.7,2.2l3.6,2.4l4.1,0.6l4.3,1.3l1.6,-3.9l0.8,-0.5l2.6,0.6l6.3,-3.2l2.2,1.4l1.8,-0.2l0.9,-1.6l2.1,-0.5l4.2,0.7l3.7,0.1l1.8,-0.7z",
    fill: "#cbd6f4",
    id: "CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1090.9,479.3l-0.3,3.9l-1.7,3.4l-1.1,4l-0.7,5.7l0.3,3.7l-0.9,2.2l-0.1,2.4l-0.7,2l-3.7,3.1l-2.6,3.3l-2.5,6.2l0.1,5.3l-1.4,2.1l-3.3,3.1l-3.4,4l-2.1,-1.1l-0.3,-1.8l-3.1,-0.1l-2,2.5l-1.5,-0.7l-2.1,-2.2l-1.7,1.1l-2.3,2.8l-4.6,-6.8l4.3,-3.6l-2.1,-4.2l2,-1.6l3.8,-0.8l0.4,-2.9l3.1,3.1l5,0.3l1.7,-3l0.7,-4.3l-0.6,-5l-2.7,-3.8l2.5,-7.5l-1.4,-1.2l-4.2,0.5l-1.6,-3.3l0.4,-2.8l7.1,0.2l4.6,1.7l4.5,1.5l0.4,-3.4l3,-6l3.3,-3.4l3.9,1.1l3.6,0.3z",
    fill: "#cbd6f4",
    id: "CG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m584.4,426.2l-3.7,1.1l-1.6,3.2l-2.3,1.8l-1.8,2.4l-0.9,4.6l-1.8,3.8l2.9,0.4l0.6,2.9l1.2,1.5l0.3,2.5l-0.7,2.4l0.1,1.4l1.4,0.5l1.2,2.2l7.3,-0.6l3.3,0.8l3.8,5.6l2.3,-0.7l4.1,0.3l3.2,-0.7l2,1.1l-1.2,3.4l-1.3,2.2l-0.6,4.6l1.1,4.3l1.5,1.9l0.2,1.4l-2.9,3.2l2,1.4l1.5,2.3l1.6,6.4l-1.1,0.8l-1,-3.8l-1.6,-2.1l-1.9,2.3l-11,-0.2l0,4l3.3,0.7l-0.2,2.5l-1.1,-0.7l-3.2,1l-0.1,4.7l2.6,2.4l0.9,3.6l-0.1,2.8l-2.2,17.6l-2.9,-3.4l-1.7,-0.1l3.5,-6.6l-4.4,-3l-3.4,0.6l-2.1,-1.1l-3.1,1.7l-4.2,-0.9l-3.5,-6.7l-2.6,-1.6l-1.8,-3.1l-3.8,-3l-1.5,0.6l-2.4,-1.5l-2.8,-2.1l-1.6,1l-4.8,-0.9l-1.4,-2.8l-1.1,0.1l-5.6,-3.6l-0.7,-2l2.1,-0.5l-0.2,-3.2l1.4,-2.4l2.8,-0.4l2.5,-4l2.2,-3.4l-2,-1.5l1.2,-3.7l-1.1,-5.9l1.3,-1.7l-0.7,-5.4l-2.2,-3.5l0.9,-3.1l1.8,0.5l1.1,-1.9l-1.1,-3.8l0.7,-0.9l2.9,0.2l4.5,-4.5l2.4,-0.7l0.1,-2.1l1.4,-5.5l3.4,-2.9l3.5,-0.2l0.6,-1.3l4.4,0.5l4.6,-3.2l2.3,-1.4l2.9,-3.1l2,0.4l1.3,1.7l-1.2,2.1z",
    fill: "#cbd6f4",
    id: "CO"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m514.6,431.6l1.2,3.5l2,2.6l2.5,2.7l-2.2,0.6l-0.1,2.6l1.1,0.9l-0.9,0.8l0.2,1.1l-0.6,1.3l-0.3,1.3l-3,-1.4l-1.1,-1.4l0.7,-1.1l-0.1,-1.4l-1.5,-1.5l-2.2,-1.3l-1.8,-0.8l-0.3,-1.9l-1.4,-1.1l0.2,1.8l-1.2,1.6l-1.2,-1.8l-1.7,-0.7l-0.7,-1.2l0.1,-2l0.9,-2l-1.5,-0.9l1.4,-1.3l0.9,-0.8l3.6,1.7l1.3,-0.8l1.8,0.5l0.8,1.3l1.7,0.5l1.4,-1.4z",
    fill: "#cbd6f4",
    id: "CR"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m544.8,355.7l1.9,2.3l5.2,-0.7l1.8,1.5l4.2,4l3.2,2.9l1.8,-0.1l3.2,1.3l-0.6,1.8l4,0.3l3.9,2.6l-0.8,1.5l-3.8,0.8l-3.8,0.3l-3.7,-0.5l-8.1,0.6l4.2,-3.5l-2.1,-1.7l-3.6,-0.4l-1.7,-1.9l-0.8,-3.6l-3.2,0.2l-5,-1.7l-1.5,-1.4l-7.1,-1l-1.8,-1.2l2.3,-1.6l-5.4,-0.3l-4.4,3.3l-2.3,0.1l-1,1.6l-2.8,0.7l-2.3,-0.7l3.2,-1.9l1.5,-2.4l2.7,-1.4l3,-1.2l4.3,-0.6l1.4,-0.8l4.7,0.5l4.4,0.1l4.9,2.2z",
    fill: "#cbd6f4",
    id: "CU"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1059.7,175.2l2.5,2l3.7,0.5l-0.2,1.7l2.8,1.3l0.6,-1.6l3.4,0.7l0.7,2l3.7,0.3l2.6,3.1l-1.5,0l-0.7,1.1l-1.1,0.3l-0.2,1.4l-0.9,0.3l-0.1,0.6l-1.6,0.6l-2.2,-0.1l-0.6,1.4l-2.4,-1.2l-2.3,0.3l-4,-1.9l-1.7,0.5l-2.6,2.6l-3.8,-2.1l-3,-2.6l-2.6,-1.5l-0.7,-2.7l-1,-1.8l3.4,-1.3l1.7,-1.6l3.5,-1.2l1.1,-1.2l1.3,0.7l2.2,-0.6z",
    fill: "#cbd6f4",
    id: "CZ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1053.9,158.9l1.4,3.1l-1.2,1.7l1.9,2.1l1.5,3.3l-0.2,2.2l2.4,3.9l-2.2,0.6l-1.3,-0.7l-1.1,1.2l-3.5,1.2l-1.7,1.6l-3.4,1.3l1,1.8l0.7,2.7l2.6,1.5l3,2.6l-1.6,2.9l-1.7,0.8l1,4.1l-0.4,1.1l-1.7,-1.3l-2.4,-0.2l-3.5,1.1l-4.4,-0.3l-0.6,1.7l-2.7,-1.7l-1.4,0.3l-5.5,-1.9l-1,1.3l-4.2,0l0.4,-4.5l2.4,-4.2l-7.2,-1.2l-2.4,-1.6l0.2,-2.7l-1,-1.4l0.4,-4.2l-1.1,-6.5l2.9,0l1.2,-2.3l0.9,-5.6l-0.9,-2.1l0.8,-1.3l4,-0.3l1,1.3l3.1,-3l-1.3,-2.3l-0.4,-3.4l3.7,0.8l2.9,-0.9l0.3,2.3l4.9,1.4l0.1,2.2l4.7,-1.2l2.6,-1.6l5.6,2.4l2.4,1.9z",
    fill: "#cbd6f4",
    id: "DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1229.5,428.2l-1.9,3.5l-1.3,-1.2l-1.3,0.5l-3.2,-0.1l-0.2,-2l-0.5,-1.8l1.8,-3l1.9,-2.8l2.4,0.6l1.7,-1.6l1.4,2l-0.1,2.6l-3.1,1.6l2.4,1.7z",
    fill: "#cbd6f4",
    id: "DJ"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Denmark",
    d: "m1046.1,147.7l-2.4,4.9l-5.2,-3.5l-0.9,-2.5l6.8,-2l1.7,3.1z",
    fill: "#cbd6f4",
    id: "svg_41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Denmark",
    d: "m1033.3,151.5l-2.9,0.9l-3.7,-0.8l-2.1,-3.4l-0.4,-6.1l0.6,-1.7l1.3,-1.8l4,-0.3l1.6,-1.7l3.6,-1.7l0,3.1l-1.2,2l0.7,1.6l2.6,0.9l-1,2.3l-1.4,-0.6l-3.1,4.3l1.4,3z",
    fill: "#cbd6f4",
    id: "svg_42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m585.7,386l0.3,-1.8l-1.3,-1.9l1.5,-1.1l0.7,-2.5l-0.1,-3.4l0.8,-1.1l4.3,0l3.2,1.6l1.5,-0.1l0.7,2.3l3.1,-0.2l-0.4,1.9l2.5,0.3l2.5,2.3l-2.3,2.6l-2.6,-1.4l-2.6,0.3l-1.8,-0.3l-1.1,1.2l-2.2,0.4l-0.7,-1.6l-1.9,0.9l-2.7,4.4l-1.3,-1l-0.1,-1.8z",
    fill: "#cbd6f4",
    id: "DO"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1031,264.6l-1,3.3l1,6.1l-1.1,5.3l-3.2,3.6l0.6,4.8l4.5,3.9l0.1,1.5l3.4,2.6l2.6,11.5l1.9,5.7l0.4,3l-0.8,5.2l0.4,3l-0.6,3.5l0.6,4l-2.2,2.7l3.4,4.7l0.2,2.7l2.1,3.6l2.5,-1.2l4.5,3l2.5,4l-18.8,12.3l-16,12.6l-7.8,2.8l-6.2,0.7l-0.1,-4.1l-2.6,-1.1l-3.5,-1.8l-1.3,-3l-18.7,-14l-18.6,-14l-20.5,-15.6l0.1,-1.2l0.1,-0.4l0.1,-7.6l8.9,-4.8l5.4,-1l4.5,-1.7l2.1,-3.2l6.4,-2.5l0.3,-4.8l3.1,-0.6l2.5,-2.3l7.1,-1.1l1,-2.5l-1.4,-1.4l-1.9,-6.8l-0.3,-3.9l-1.9,-4.1l5.1,-3.5l5.8,-1.1l3.3,-2.6l5.1,-2l9,-1.1l8.8,-0.5l2.7,0.9l4.9,-2.5l5.7,-0.1l2.2,1.5l3.6,-0.4z",
    fill: "#cbd6f4",
    id: "DZ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m559,502.8l0.8,4.9l-1.7,4.1l-6.1,6.8l-6.7,2.5l-3.4,5.6l-0.9,4.3l-3.1,2.7l-2.5,-3.3l-2.3,-0.7l-2.3,0.5l-0.3,-2.3l1.6,-1.5l-0.7,-2.7l2.9,-4.8l-1.3,-2.8l-2.1,3l-3.5,-2.9l1.1,-1.8l-1,-5.8l2,-1l1,-4l2.1,-4.1l-0.3,-2.6l3.1,-1.4l3.9,-2.5l5.6,3.6l1.1,-0.1l1.4,2.8l4.8,0.9l1.6,-1l2.8,2.1l2.4,1.5z",
    fill: "#cbd6f4",
    id: "EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1172.1,301.4l3.9,9.4l0.7,1.6l-1.3,2.6l-0.7,4.8l-1.2,3.4l-1.2,1.1l-2,-2.1l-2.7,-2.8l-4.7,-9.2l-0.5,0.6l2.8,6.7l3.9,6.5l4.9,10l2.3,3.5l2,3.6l5.4,7.1l-1,1.1l0.4,4.2l6.8,5.8l1.1,1.3l-22.1,0l-21.5,0l-22.3,0l-1,-23.7l-1.3,-22.8l-2,-5.2l1.1,-3.9l-1,-2.8l1.7,-3.1l7.2,-0.1l5.4,1.7l5.5,1.9l2.6,1l4,-2l2.1,-1.8l4.7,-0.6l3.9,0.8l1.8,3.2l1.1,-2.1l4.4,1.5l4.3,0.4l2.5,-1.6z",
    fill: "#cbd6f4",
    id: "EG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1228.9,420.3l-1.7,1.6l-2.4,-0.6l-2,-2.1l-2.5,-3.7l-2.6,-2.1l-1.5,-2.2l-5,-2.6l-3.9,-0.1l-1.4,-1.3l-3.2,1.5l-3.6,-2.9l-1.5,4.8l-6.6,-1.4l-0.7,-2.5l2,-9.5l0.3,-4.2l1.7,-2l4,-1.1l2.7,-3.6l3.6,7.4l1.9,5.9l3.2,3.1l8,6.1l3.3,3.6l3.2,3.8l1.8,2.2l2.9,1.9z",
    fill: "#cbd6f4",
    id: "ER"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1113.7,124.6l0.9,1l-2.6,3.4l2.4,5.6l-1.6,1.9l-3.8,-0.1l-4.4,-2.2l-2.1,-0.7l-3.8,1l-0.1,-3.5l-1.5,0.8l-3.3,-2.1l-1,-3.4l5.5,-1.7l5.6,-0.8l5.1,0.9l4.7,-0.1z",
    fill: "#cbd6f4",
    id: "EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1207.3,408.5l3.9,0.1l5,2.6l1.5,2.2l2.6,2.1l2.5,3.7l2,2.1l-1.9,2.8l-1.8,3l0.5,1.8l0.2,2l3.2,0.1l1.3,-0.5l1.3,1.2l-1.2,2.2l2.2,3.6l2.2,3.1l2.2,2.3l18.7,7.6l4.8,-0.1l-15.6,19.3l-7.3,0.3l-5,4.5l-3.6,0.1l-1.5,2.1l-3.9,0l-2.3,-2.2l-5.2,2.7l-1.6,2.7l-3.8,-0.6l-1.3,-0.7l-1.3,0.2l-1.8,-0.1l-7.2,-5.4l-4,0l-1.9,-2.1l-0.1,-3.6l-2.9,-1.1l-3.5,-7l-2.6,-1.5l-1,-2.6l-3,-3.1l-3.5,-0.5l1.9,-3.6l3,-0.2l0.8,-1.9l-0.2,-5l0,-0.8l1.5,-6.7l2.6,-1.8l0.5,-2.6l2.3,-5l3.3,-3.1l2,-6.4l0.7,-5.5l6.6,1.4l1.5,-4.8l3.6,2.9l3.2,-1.5l1.4,1.3z",
    fill: "#cbd6f4",
    id: "ET"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1104.1,70.1l0.4,3.8l7.3,3.7l-2.9,4.2l6.5,6.3l-1.7,4.8l4.9,4.2l-0.9,3.8l7.4,3.9l-0.9,2.9l-3.4,3.4l-8,7.4l-8,0.5l-7.6,2.1l-7.1,1.3l-3.2,-3.2l-4.7,-1.9l0.1,-5.8l-3,-5.2l1.6,-3.4l3.3,-3.5l8.8,-6.2l2.6,-1.2l-0.9,-2.4l-6.5,-2.6l-1.8,-2.2l-1.8,-8.5l-7.2,-3.7l-6,-2.7l2.2,-1.4l5.1,2.8l5.3,-0.2l4.7,1.3l3.4,-2.4l1.1,-4l5.9,-1.8l5.8,2.1l-0.8,3.8z",
    fill: "#cbd6f4",
    id: "FI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1060.5,487.3l-0.4,2.8l1.6,3.3l4.2,-0.5l1.4,1.2l-2.5,7.5l2.7,3.8l0.6,5l-0.7,4.3l-1.7,3l-5,-0.3l-3.1,-3.1l-0.4,2.9l-3.8,0.8l-2,1.6l2.1,4.2l-4.3,3.6l-5.8,-6.5l-3.7,-5.3l-3.5,-6.6l0.2,-2.2l1.3,-2l1.3,-4.7l1.2,-4.8l1.9,-0.3l8.2,0l0,-7.7l2.7,-0.4l3.4,0.8l3.4,-0.8l0.7,0.4z",
    fill: "#cbd6f4",
    id: "GA"
  }), /*#__PURE__*/React.createElement("path", {
    className: "United Kingdom",
    d: "m956.7,158.2l-3.5,-1.2l-3,0.1l1.2,-3.3l-0.9,-3.2l4,-0.3l4.9,3.8l-2.7,4.1z",
    fill: "#5cbcb1",
    id: "svg_43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "United Kingdom",
    d: "m972.6,129.5l-5.1,6.5l4.7,-0.8l5.1,0l-1.3,4.9l-4.3,5.4l4.9,0.3l0.3,0.7l4.2,7.1l3.2,1l2.9,7l1.4,2.4l5.9,1.1l-0.6,4l-2.4,1.8l1.9,3.2l-4.4,3.2l-6.5,-0.1l-8.4,1.8l-2.2,-1.3l-3.3,2.9l-4.5,-0.7l-3.6,2.4l-2.5,-1.2l7.3,-6.5l4.4,-1.4l-7.6,-1l-1.3,-2.5l5.1,-1.9l-2.5,-3.3l1,-4l7.1,0.6l0.8,-3.6l-3.1,-3.7l-0.1,-0.1l-5.7,-1.1l-1.1,-1.6l1.8,-2.7l-1.5,-1.7l-2.6,2.9l-0.1,-5.9l-2.2,-3l1.9,-6.2l3.8,-4.8l3.6,0.4l5.6,-0.5z",
    fill: "#5cbcb1",
    id: "svg_44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1215.7,227.9l5.1,1.3l2.1,2.6l3.6,1.5l-1.2,0.8l3.3,3.5l-0.6,0.7l-2.9,-0.3l-4.2,-1.9l-1.1,1.1l-7,1l-5.6,-3.2l-5.5,0.3l0.3,-2.7l-2.1,-4.3l-3.4,-2.4l-3,-0.7l-2.2,-1.9l0.4,-0.8l4.6,1.1l7.7,1l7.6,3.1l1.2,1.2l2.9,-1z",
    fill: "#cbd6f4",
    id: "GE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m986.5,431.1l-0.4,2l2.3,3.3l0,4.7l0.6,5l1.4,2.4l-1.3,5.7l0.5,3.2l1.5,4.1l1.3,2.3l-8.9,3.7l-3.2,2.2l-5.1,1.9l-5,-1.8l0.2,-2.6l-2.4,-5.5l1.5,-7.3l2.4,-5.3l-1.5,-9.2l-0.8,-4.8l0.2,-3.7l9.8,-0.3l2.5,0.5l1.8,-1l2.6,0.5z",
    fill: "#cbd6f4",
    id: "GH"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m921.5,421.9l0.3,2.4l0.9,0l1.5,-0.9l0.9,0.2l1.6,1.7l2.4,0.5l1.5,-1.4l1.9,-0.9l1.3,-0.9l1.1,0.2l1.3,1.4l0.6,1.8l2.3,2.7l-1.1,1.6l-0.3,2.1l1.2,-0.6l0.7,0.7l-0.3,1.9l1.7,1.9l-1.1,0.5l-0.5,2.2l1.3,2.6l1.4,5.2l-2.1,0.7l-0.5,0.9l0.4,1.3l-0.4,2.8l-0.9,0l-1.6,-0.2l-1.1,2.6l-1.6,0l-1.1,-1.4l0.4,-2.6l-2.4,-3.9l-1.4,0.7l-1.3,0.2l-1.5,0.3l0.1,-2.3l-0.9,-1.7l0.2,-1.9l-1.2,-2.7l-1.6,-2.3l-4.5,0l-1.3,1.2l-1.6,0.2l-1,1.4l-0.6,1.7l-3.1,2.9l-2.4,-3.8l-2.2,-2.5l-1.4,-0.9l-1.4,-1.3l-0.6,-2.8l-0.8,-1.4l-1.7,-1.1l2.6,-3.1l1.7,0.1l1.5,-1l1.2,-0.1l0.9,-0.8l-0.4,-2.1l0.6,-0.7l0.1,-2.2l2.7,0.1l4.1,1.5l1.2,-0.1l0.4,-0.7l3.1,0.5l0.8,-0.4z",
    fill: "#cbd6f4",
    id: "GN"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m891.6,417.4l0.8,-2.9l6.1,-0.1l1.3,-1.6l1.8,-0.1l2.2,1.6l1.7,0l1.9,-1l1.1,1.8l-2.5,1.5l-2.4,-0.2l-2.4,-1.3l-2.1,1.5l-1,0l-1.4,0.9l-5.1,-0.1z",
    fill: "#cbd6f4",
    id: "GM"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m909.2,421l-0.1,2.2l-0.6,0.7l0.4,2.1l-0.9,0.8l-1.2,0.1l-1.5,1l-1.7,-0.1l-2.6,3.1l-2.9,-2.6l-2.4,-0.5l-1.3,-1.8l0.1,-1l-1.7,-1.3l-0.4,-1.4l3,-1l1.9,0.2l1.5,-0.8l10.4,0.3z",
    fill: "#cbd6f4",
    id: "GW"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1050.3,487.3l0,7.7l-8.2,0l-1.9,0.3l-1.1,-0.9l1.9,-7.2l9.3,0.1z",
    fill: "#cbd6f4",
    id: "GQ"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Greece",
    d: "m1112.7,272.6l3.1,2.2l4.1,-0.4l4,0.4l0,1.2l2.8,-0.8l-0.5,1.9l-7.6,0.5l-0.1,-1l-6.6,-1.3l0.8,-2.7z",
    fill: "#cbd6f4",
    id: "svg_45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Greece",
    d: "m1121.9,239.9l-3.2,-0.2l-2.7,-0.6l-6.2,1.6l4,3.6l-2.5,1.1l-2.9,0l-3.1,-3.3l-0.9,1.4l1.6,3.8l2.9,3l-1.9,1.4l3.2,2.9l2.8,1.9l0.4,3.6l-5,-1.7l1.8,3.3l-3.3,0.6l2.5,5.7l-3.5,0.1l-4.6,-2.8l-2.4,-5.1l-1.3,-4.3l-2.3,-2.9l-3,-3.7l-0.5,-1.8l2.2,-3.1l0.1,-2.1l1.7,-0.9l-0.1,-1.7l3.4,-0.5l1.8,-1.4l2.8,0.1l0.8,-1.1l1,-0.2l3.8,0.2l4,-1.8l3.9,2.3l4.6,-0.6l-0.3,-3.2l2.7,1.7l-1.1,4l-1.2,0.7z",
    fill: "#cbd6f4",
    id: "svg_46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m896.3,1.4l19.9,3l-6.7,1.4l-13,0.2l-18.5,0.4l1.4,0.7l12.3,-0.5l9.7,1.4l7,-1.2l2.4,1.4l-4.5,2.4l9.2,-1.6l17.1,-1.5l10,0.8l1.7,1.7l-14.8,2.9l-2.2,1l-11.4,0.8l8.1,0.2l-4.9,3.2l-3.6,2.9l-1.2,5.2l3.7,3.2l-5.9,0.1l-6.5,1.6l6.3,2.6l-0.1,4.2l-4.2,0.5l4.1,4.3l-8.7,0.4l4,2l-1.6,1.8l-5.7,0.8l-5.5,0.1l4.2,3.4l-0.5,2.4l-7.3,-2.2l-2.4,1.4l5,1.3l4.6,3.2l0.6,4.3l-7.4,1l-2.7,-2.1l-4.2,-3l0.5,3.6l-5.4,2.8l10.7,0.2l5.5,0.3l-11.9,4.7l-12.2,4.3l-12.7,1.8l-4.6,0.1l-4.9,2.1l-7.5,5.8l-10.2,3.9l-3,0.3l-6.1,1.3l-6.6,1.4l-4.8,3.4l-1.4,4l-3.4,3.8l-8.6,4.6l0.3,4.5l-3.6,4.8l-4.1,5.7l-6.5,0.4l-5,-4.8l-9,-0.1l-3.2,-3.2l-0.8,-5.6l-4.8,-7.2l-0.7,-3.7l1.5,-5.1l-3.7,-5.1l3.3,-4.1l-1.9,-2l7,-6.4l7.2,-2.1l2.6,-2.2l2.8,-4.2l-5.5,1.9l-2.6,0.8l-4.1,0.7l-4.2,-1.7l1.5,-3.7l3,-2.8l3.8,-0.1l7.6,1.5l-5.3,-3.4l-2.7,-1.8l-4.4,0.7l-2.6,-1.3l7,-4.8l-1.3,-2l-1.1,-3.5l-1.4,-5.4l-3.6,-1.9l1.4,-2.1l-8.1,-2.9l-7.7,-0.4l-10.1,0.2l-9.5,0.4l-3.1,-1.6l-3.8,-3.1l11,-1.5l7.6,-0.2l-14.6,-1.3l-6.5,-1.9l2.2,-1.8l15.7,-2.2l15,-2.2l2.8,-1.6l-8.1,-1.6l4.6,-1.7l14.7,-2.9l5.4,-0.4l0.2,-1.8l9,-1.1l11,-0.6l10.4,0l2.8,1.2l10.6,-2.2l7.1,1.5l4.6,0.3l6.2,1.3l-6.7,-2.1l1.6,-1.7l12.7,-2.2l11.6,0.2l5.1,-1.4l11.9,-0.3l26.3,0.4z",
    fill: "#cbd6f4",
    id: "GL"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m488.1,387.5l-0.7,5.1l-1.3,7.2l1.7,0l1.7,1.2l0.6,-1l1.5,0.8l-2.8,2.5l-2.9,1.8l-0.5,1.2l0.3,1.3l-1.3,1.6l-1.4,0.4l0.3,0.8l-1.2,0.7l-2,1.6l-0.3,0.9l-2.8,-1.1l-3.5,-0.1l-2.4,-1.3l-2.8,-2.6l0.4,-1.9l0.8,-1.5l-0.7,-1.2l3.3,-5.2l7.2,0l0.4,-2.2l-0.8,-0.4l-0.5,-1.4l-1.9,-1.5l-1.8,-2.1l2.5,-0.1l0.5,-3.6l5.2,0l5.2,0.1z",
    fill: "#cbd6f4",
    id: "GT"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m662.9,463.5l-1,5.8l-3.5,1.6l0.3,1.5l-1.1,3.4l2.4,4.6l1.8,0l0.7,3.6l3.3,5.6l-1.3,0.3l-3.2,-0.6l-1.8,1.7l-2.6,1.1l-1.8,0.3l-0.6,1.3l-2.8,-0.3l-3.5,-3l-0.3,-3l-1.4,-3.3l1,-5.4l1.6,-2.3l-1.2,-3l-2,-0.9l0.8,-2.9l-1.2,-1.4l-3,0.2l-3.7,-4.8l1.6,-1.8l0,-3l3.5,-1l1.4,-1.2l-1.8,-2.4l0.5,-2.3l4.7,-3.8l3.6,2.4l3.3,4.1l0.1,3.4l2.1,0.1l3,3.1l2.1,2.3z",
    fill: "#cbd6f4",
    id: "GY"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m519.6,405.5l-1.9,-0.1l-0.9,0.9l-2,0.8l-1.4,0l-1.3,0.8l-1.1,-0.2l-0.9,-1l-0.6,0.2l-0.9,1.5l-0.5,-0.1l-0.2,1.4l-2.1,1.7l-1.2,0.8l-0.6,0.8l-1.5,-1.3l-1.4,1.7l-1.2,0l-1.3,0.1l-0.2,3.2l-0.8,0l-0.8,1.5l-1.8,0.3l-0.8,-2l-1.7,-0.6l0.7,-2.6l-0.7,-0.7l-1.2,-0.4l-2.5,0.7l-0.1,-0.8l-1.6,-1.1l-1.1,-1.2l-1.6,-0.6l1.3,-1.6l-0.3,-1.3l0.5,-1.2l2.9,-1.8l2.8,-2.5l0.6,0.3l1.3,-1.1l1.6,-0.1l0.5,0.5l0.9,-0.3l2.6,0.6l2.6,-0.2l1.8,-0.7l0.8,-0.7l1.7,0.3l1.3,0.4l1.5,-0.1l1.2,-0.6l2.5,0.9l0.8,0.2l1.6,1.2l1.5,1.4l1.9,1l1.3,1.7z",
    fill: "#cbd6f4",
    id: "HN"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1081.5,207.6l1.5,2.5l1.7,1.8l-1.7,2.4l-2.4,-1.4l-3.5,0.1l-4.5,-1.1l-2.3,0.1l-1,1.4l-2,-1.5l-0.8,2.6l2.7,3l1.3,1.9l2.5,2.4l2.1,1.4l2.1,2.7l4.8,2.4l-0.5,1l-5,-2.3l-3.2,-2.3l-4.8,-1.9l-4.7,-4.6l1,-0.5l-2.5,-2.7l-0.3,-2.1l-3.3,-1l-1.4,2.7l-1.6,-2.1l0,-2.2l0.1,-0.1l3.6,0.2l0.8,-1l1.8,1l2,0.1l-0.1,-1.7l1.7,-0.7l0.3,-2.5l3.9,-1.7l1.6,0.8l4,2.7l4.3,1.2l1.8,-1z",
    fill: "#cbd6f4",
    id: "HR"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m586.8,375.3l0.1,3.4l-0.7,2.5l-1.5,1.1l1.3,1.9l-0.3,1.8l-3.6,-1.1l-2.7,0.4l-3.4,-0.4l-2.7,1.2l-2.8,-2l0.7,-2.1l5.1,0.9l4.1,0.5l2.2,-1.4l-2.3,-2.8l0.4,-2.5l-3.5,-1l1.5,-1.7l3.4,0.2l4.7,1.1z",
    fill: "#cbd6f4",
    id: "HT"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1096.2,191.9l3,1.7l0.5,1.7l-2.9,1.3l-1.9,4.2l-2.6,4.3l-3.9,1.2l-3.2,-0.3l-3.7,1.6l-1.8,1l-4.3,-1.2l-4,-2.7l-1.6,-0.8l-1.2,-2.1l-0.8,-0.1l1.3,-4l-1.1,-1.4l2.8,0l0.2,-2.6l2.7,1.7l1.9,0.6l4.1,-0.7l0.3,-1.3l1.9,-0.2l2.3,-0.9l0.6,0.4l2.3,-0.8l1,-1.5l1.6,-0.4l5.5,1.9l1,-0.6z",
    fill: "#cbd6f4",
    id: "HU"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Indonesia",
    d: "m1667.5,567.6l-2.4,0.1l-7.1,-4.5l5.4,-1.3l2.8,2l1.8,1.9l-0.5,1.8z",
    fill: "#cbd6f4",
    id: "svg_47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Indonesia",
    d: "m1692.3,558.9l0.5,1.3l-0.1,1.9l-4.1,4.8l-5,1.4l-0.6,-0.7l0.7,-2.2l2.8,-3.9l5.8,-2.6z",
    fill: "#cbd6f4",
    id: "svg_48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Indonesia",
    d: "m1652.7,553.8l1.9,1.7l3.6,-0.5l1.2,2.7l-6.7,1.3l-3.9,0.9l-3.1,-0.1l2.2,-3.7l3.2,0l1.6,-2.3z",
    fill: "#cbd6f4",
    id: "svg_49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Indonesia",
    d: "m1681,553.8l-1.1,3.6l-8.6,1.8l-7.5,-0.8l0.2,-2.4l4.6,-1.3l3.4,1.9l3.8,-0.5l5.2,-2.3z",
    fill: "#cbd6f4",
    id: "svg_50"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Indonesia",
    d: "m1600.8,545.3l10.8,0.7l1.4,-2.7l10.3,3.1l1.8,4.2l8.4,1.2l6.7,3.8l-6.6,2.4l-6.1,-2.6l-5.1,0.2l-5.8,-0.5l-5.2,-1.1l-6.4,-2.5l-4.1,-0.6l-2.4,0.8l-10.2,-2.7l-0.8,-2.7l-5.1,-0.5l4.2,-6.1l6.8,0.4l4.4,2.5l2.4,0.5l0.6,2.2z",
    fill: "#cbd6f4",
    id: "svg_51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Indonesia",
    d: "m1748.7,541.7l-3.2,4.4l-0.2,-4.8l1.1,-2.3l1.3,-2.2l1.2,1.9l-0.2,3z",
    fill: "#cbd6f4",
    id: "svg_52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Indonesia",
    d: "m1707.3,524l-2.2,2.2l-3.8,-1.2l-1,-2.8l5.7,-0.3l1.3,2.1z",
    fill: "#cbd6f4",
    id: "svg_53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Indonesia",
    d: "m1725.7,521.7l1.8,4.9l-4.6,-2.7l-4.7,-0.5l-3.3,0.4l-3.9,-0.2l1.5,-3.5l7,-0.3l6.2,1.9z",
    fill: "#cbd6f4",
    id: "svg_54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Indonesia",
    d: "m1785.5,518.5l-1,20.9l-1.6,21l-4.6,-5.3l-5.6,-1.3l-1.5,1.8l-7.2,0.2l2.8,-5.2l3.7,-1.8l-1,-7l-2.3,-5.3l-10.7,-5.5l-4.6,-0.5l-8.3,-6l-1.8,3.2l-2.2,0.5l-1.1,-2.3l0.1,-2.8l-4.2,-3.2l6.2,-2.3l4,0.1l-0.4,-1.7l-8.3,0l-2.2,-3.8l-5,-1.2l-2.3,-3.2l7.6,-1.5l2.9,-2.1l9.1,2.6l0.9,2.4l1.3,10.4l5.7,3.8l5,-6.8l6.6,-3.8l5,0l4.8,2.2l4.1,2.3l6.1,1.2z",
    fill: "#cbd6f4",
    id: "svg_55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Indonesia",
    d: "m1696.4,492.7l-4.5,6.4l-4.3,1.2l-5.4,-1.2l-9.5,0.3l-4.9,0.9l-0.8,4.9l5,5.7l3.1,-2.9l10.6,-2.2l-0.5,2.9l-2.5,-0.9l-2.5,3.8l-5.1,2.5l5.1,8.2l-1.1,2.2l4.8,7.4l-0.3,4.2l-3.1,1.9l-2.1,-2.3l3,-5.2l-5.7,2.5l-1.3,-1.8l0.8,-2.5l-3.9,-3.8l0.7,-6.2l-3.9,1.9l0.2,7.5l-0.2,9.2l-3.7,0.9l-2.3,-1.8l1.9,-5.9l-0.6,-6.2l-2.4,-0.1l-1.6,-4.4l2.5,-4.2l0.9,-5.1l3,-9.7l1.1,-2.6l4.8,-4.8l4.5,1.9l7.1,0.9l6.5,-0.3l5.6,-4.6l1,1.4z",
    fill: "#cbd6f4",
    id: "svg_56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Indonesia",
    d: "m1716,494.6l-0.3,5.6l-2.9,-0.7l-0.9,3.9l2.3,3.4l-1.6,0.8l-2.2,-4.1l-1.7,-8.2l1,-5.1l1.8,-2.3l0.5,3.5l3.4,0.5l0.6,2.7z",
    fill: "#cbd6f4",
    id: "svg_57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Indonesia",
    d: "m1608,488.9l1,4.3l3.9,3.7l3.7,-1.3l3.6,0.4l3.3,-3.2l2.7,-0.6l5.4,1.8l4.6,-1.4l2.6,-8.9l2.1,-2.2l1.7,-7.3l6.5,0l5,1.1l-3,5.8l4.4,6l-0.9,3l6.4,5.9l-6.7,0.8l-1.8,4.4l0.2,5.8l-5.5,4.4l-0.4,6.4l-2.5,9.8l-0.7,-2.3l-6.6,2.9l-2.1,-3.9l-4,-0.4l-2.8,-2.1l-6.8,2.4l-1.9,-3.2l-3.8,0.4l-4.6,-0.7l-0.6,-8.6l-2.8,-1.8l-2.7,-5.5l-0.8,-5.6l0.6,-6l3.3,-4.3z",
    fill: "#cbd6f4",
    id: "svg_58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Indonesia",
    d: "m1585.2,539.4l-6.2,0.1l-4.5,-5.3l-7.1,-5.3l-2.3,-3.9l-4.1,-5.2l-2.7,-4.8l-4.2,-9l-4.9,-5.4l-1.7,-5.5l-2.2,-5l-5.2,-4l-3.1,-5.5l-4.4,-3.6l-6.2,-7.1l-0.6,-3.3l3.6,0.3l8.9,1.2l5.2,6.3l4.6,4.4l3.2,2.6l5.5,6.9l5.8,0.1l4.8,4.4l3.4,5.4l4.3,3l-2.3,5.2l3.3,2.2l2,0.2l0.9,4.5l1.9,3.5l4.1,0.6l2.6,4.1l-1.7,8l-0.7,9.9z",
    fill: "#cbd6f4",
    id: "svg_59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1427.6,308l-2.8,3l-0.9,6l5.8,2.4l5.8,3.1l7.8,3.6l7.7,0.9l3.8,3.2l4.3,0.6l6.9,1.5l4.6,-0.1l0.1,-2.5l-1.5,-4.1l-0.2,-2.7l3.1,-1.4l1.5,5.1l0.4,1.2l5.5,2.5l3.2,-1l4.7,0.4l4.5,-0.2l-0.5,-3.9l-2.6,-2.1l4.2,-0.8l3.9,-4.8l5.4,-4l4.9,1.5l3.2,-2.7l3.6,4l-1.2,2.7l6.1,1l1,2.4l-1.7,1.2l1.4,3.9l-4.2,-1.1l-6.2,4.4l0.9,3.7l-2,5.4l0.3,3.1l-1.6,5.3l-4.6,-1.5l0.9,6.7l-1,2.2l1,2.7l-2.5,1.5l-4.4,-10.2l-1.5,0l-0.3,4.2l-3.6,-3.4l1.2,-3.6l2.4,-0.4l1.6,-5.4l-3.4,-1.1l-5.1,0.1l-5.4,-0.9l-1.2,-4.5l-2.7,-0.3l-4.9,-2.8l-1.2,4.4l4.6,3.4l-3,2.4l-0.9,2.3l3.7,1.7l-0.3,3.9l2.6,4.8l1.6,5.3l-0.5,2.4l-3.8,-0.1l-6.6,1.3l0.9,4.8l-2.4,3.8l-7.5,4.4l-5.3,7.5l-3.8,4.1l-5,4.2l0.3,2.9l-2.6,1.6l-4.8,2.3l-2.6,0.3l-1.2,4.9l1.9,8.4l0.7,5.3l-1.9,6.1l0.7,10.9l-2.9,0.3l-2.3,4.9l1.9,2.2l-5.1,1.8l-1.7,4.3l-2.2,1.9l-5.6,-6l-3.1,-9l-2.5,-6.5l-2.2,-3l-3.4,-6.2l-2,-8l-1.4,-4l-5.9,-8.8l-3.5,-12.5l-2.6,-8.2l-0.8,-7.8l-1.7,-6l-7.7,3.9l-4,-0.8l-8.1,-7.8l2.4,-2.3l-1.9,-2.5l-7.1,-5.5l3.2,-4.3l12.1,0l-1.8,-5.5l-3.5,-3.2l-1.4,-5l-4,-2.8l4.9,-6.8l6.5,0.5l4.5,-6.7l2.2,-6.5l3.9,-6.5l-1,-4.6l3.8,-3.7l-5.1,-3.1l-2.9,-4.4l-3.3,-5.6l2,-2.8l8.5,1.6l5.7,-1l3.8,-5.4l7.7,7.6l0.8,5.2l3,3.3l0.6,3.3l-4.1,-0.9l3.2,7.1l6.2,4l8.6,4.5z",
    fill: "#cbd6f4",
    id: "IN"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m956.7,158.2l0.7,4.4l-3.9,5.5l-8.8,3.6l-6.8,-0.9l4.3,-6.4l-2.1,-6.2l6.7,-4.8l3.7,-2.8l0.9,3.2l-1.2,3.3l3,-0.1l3.5,1.2z",
    fill: "#cbd6f4",
    id: "IE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1229,253.2l1.8,-0.2l5.3,-4.7l1.9,-0.5l1.9,1.9l-1.2,3.1l3.9,3.4l1.3,-0.4l2.5,4.8l5.3,1.3l4.3,3.2l7.7,1.1l8,-1.7l0.2,-1.5l4.4,-1.2l3,-3.7l3.6,0.2l2,-1.2l3.9,0.6l6.6,3.3l4.3,0.7l7.3,5.6l4,0.3l1.7,5.3l-0.6,8l-0.5,4.7l2.5,1l-1.6,3.5l2.7,5.1l1.2,4.1l4.3,1.1l1.1,4.1l-3.9,5.8l3.2,3.4l2.8,3.9l5.7,2.8l1,5.6l2.7,1.1l0.9,2.9l-7.5,3.4l-1.1,7.4l-10.6,-1.9l-6.2,-1.5l-6.3,-0.8l-3.3,-7.9l-2.8,-1.1l-4.1,1.1l-5.1,3.1l-7,-2.1l-6.1,-5l-5.5,-1.8l-4.4,-6.1l-5.2,-8.5l-2.8,1l-3.7,-2.1l-1.7,2.5l-3.5,-3.4l-0.5,-3.4l-1.7,0l0.2,-4.7l-3.5,-4.8l-7.1,-3.6l-4.6,-6.1l0.5,-5l2.3,-2.2l-0.9,-3.7l-3.8,-2l-4.7,-7.6l-3.8,-5.1l0.7,-2l-2.9,-7.3l3.3,-1.9l1.2,2.5l3.2,2.9l3.8,0.9z",
    fill: "#cbd6f4",
    id: "IR"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1223.5,263.2l4.7,7.6l3.8,2l0.9,3.7l-2.3,2.2l-0.5,5l4.6,6.1l7.1,3.6l3.5,4.8l-0.2,4.7l1.7,0l0.5,3.4l3.5,3.4l-3.3,-0.3l-3.7,-0.6l-3.3,6.2l-10.2,-0.5l-16.8,-12.9l-8.6,-4.5l-6.8,-1.8l-3.1,-7.8l11,-6.7l1,-7.7l-1.2,-4.7l2.7,-1.6l2.1,-4l2.1,-1l6.3,0.9l2.1,1.6l2.4,-1.1z",
    fill: "#cbd6f4",
    id: "IQ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m924.8,84.5l-1.4,3.6l4.4,3.8l-6.1,4.3l-13.1,3.9l-3.9,1.1l-5.6,-0.9l-11.9,-1.8l4.8,-2.5l-9,-2.7l7.9,-1.1l0.1,-1.7l-8.8,-1.3l3.6,-3.7l6.6,-0.8l6,3.8l7,-3l5.1,1.5l7.3,-2.9l7,0.4z",
    fill: "#cbd6f4",
    id: "IS"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1179.1,288.2l0.4,2.6l-0.6,1l0.1,0l-0.7,2l-2.1,-0.8l-0.7,4.2l1.5,0.7l-1.3,0.9l-0.1,1.7l2.5,-0.8l0.4,2.5l-1.8,10.2l-0.7,-1.6l-3.9,-9.4l1.4,-2.1l-0.4,-0.4l1.1,-3l0.6,-4.8l0.6,-1.7l0.1,0l1.8,0l0.4,-1.1l1.4,-0.1z",
    fill: "#cbd6f4",
    id: "IL"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Italy",
    d: "m1068.2,256.4l-1.7,5.1l0.9,1.9l-0.9,3.3l-4.2,-2.4l-2.7,-0.7l-7.5,-3.2l0.5,-3.3l6.2,0.6l5.4,-0.7l4,-0.6z",
    fill: "#cbd6f4",
    id: "svg_60"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Italy",
    d: "m1034.2,237.4l3.3,4.5l-0.4,8.5l-2.4,-0.4l-2.1,2.1l-2,-1.7l-0.5,-7.7l-1.3,-3.6l2.9,0.3l2.5,-2z",
    fill: "#cbd6f4",
    id: "svg_61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Italy",
    d: "m1055.9,203.9l-0.4,3.1l1.4,2.7l-4.1,-1l-3.9,2.3l0.4,3.1l-0.5,1.8l1.9,3.2l5,3.2l2.9,5.3l6.1,5.1l4,-0.1l1.4,1.4l-1.4,1.3l4.8,2.3l4,1.9l4.7,3.4l0.6,1.1l-0.8,2.3l-3.1,-3l-4.6,-1l-1.9,4.1l3.9,2.4l-0.4,3.3l-2.1,0.4l-2.5,5.5l-2.2,0.5l-0.1,-2l0.9,-3.4l1.1,-1.4l-2.3,-3.7l-1.8,-3.2l-2.2,-0.8l-1.8,-2.7l-3.4,-1.2l-2.4,-2.6l-3.8,-0.4l-4.3,-2.8l-4.9,-4.2l-3.7,-3.6l-1.9,-6.3l-2.6,-0.7l-4.2,-2.1l-2.3,0.8l-2.9,3l-2.1,0.4l0.5,-2.7l-2.8,-0.8l-1.5,-4.9l1.7,-1.9l-1.5,-2.4l0.1,-1.8l2.2,1.4l2.5,-0.3l2.7,-2.2l0.9,1l2.4,-0.2l1,-2.5l3.8,0.8l2.1,-1.1l0.3,-2.5l3.1,0.9l0.5,-1.2l4.9,-1.1l1.3,2.1l7.3,1.7z",
    fill: "#cbd6f4",
    id: "svg_62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m556.5,387.1l-1.8,1.1l-3,-1.1l-2.9,-2.3l0.8,-1.5l2.4,-0.4l1.3,0.2l3.7,0.6l2.7,1.5l0.8,1.8l-4,0.1z",
    fill: "#cbd6f4",
    id: "JM"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1198.1,295.3l-0.9,1l-10.4,3.2l6,6.5l-1.6,1l-0.7,2.2l-4.1,0.9l-1.1,2.3l-2.1,2l-6.2,-1.1l-0.3,-0.9l1.8,-10.2l-0.4,-2.5l0.6,-1.9l-0.4,-4l0.7,-2l6.3,2.6l9.7,-6.9l3.1,7.8z",
    fill: "#cbd6f4",
    id: "JO"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Japan",
    d: "m1708.5,282.6l1.6,2.2l-1.3,3.9l-3.1,-2.1l-2.1,1.5l0.1,3.7l-4.3,-1.8l-1.2,-3l1.3,-3.9l3.4,0.8l1,-2.7l4.6,1.4z",
    fill: "#cbd6f4",
    id: "svg_63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Japan",
    d: "m1733.1,263.4l0.6,5.1l2.5,3.2l-0.6,4.5l-5.4,3l-9.2,0.4l-4.4,7.4l-4.7,-2.5l-2.4,-4.8l-8.6,1.4l-5.1,3l-6.2,0.2l7.4,4.7l0.8,10.9l-2.5,2.7l-3.6,-2.5l-0.9,-5.8l-4.1,-1.8l-4,-4.4l4.3,-2l1.1,-4.1l3.9,-3.3l2,-4.4l9.7,-1.9l6.3,1.3l0,-11.4l5.1,3.1l4.5,-6.4l1.7,-2.5l-1,-7.8l-5.1,-7.2l-0.2,-4l4.8,-1.2l8.2,8.9l2.8,5.1l-1.3,6.5l3.6,6.6z",
    fill: "#cbd6f4",
    id: "svg_64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Japan",
    d: "m1721.2,218.6l4.5,1.3l1.8,-2.6l6,7.1l-6.4,1.7l-0.4,6.3l-10.9,-4.3l1.6,6.9l-5.7,0.1l-4.7,-6.3l-0.6,-4.9l5.2,-0.3l-4.4,-8.8l-1.8,-4.9l10.5,6.6l5.3,2.1z",
    fill: "#cbd6f4",
    id: "svg_65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1338.3,160.5l4.4,-0.3l9.2,-5.8l-0.8,2l8.4,4.7l18.3,15.6l1.1,-3.2l8.4,3.5l6.2,-1.6l3.3,1.1l4.1,3.6l4,1.2l3.3,2.7l6,-0.9l4.4,3.8l-1.9,4.2l-3.8,0.6l2.5,6.2l-1.6,2.9l-10.8,-2.1l1,11.3l-2,1.4l-9.1,2.5l8.8,11l-2.9,1.6l1.7,3.7l-3.5,-1l-3.4,-2.3l-7.9,-0.6l-8.6,-0.2l-1.6,0.7l-8.2,-2.7l-2.5,1.4l0.5,3.7l-9.2,-2.2l-3.1,0.9l-0.3,2.8l-2.6,1.2l-5.4,4.4l-0.9,4.6l-2,0l-2.3,-3l-6.7,-0.2l-2.5,-5.2l-2.6,-0.1l-1.5,-6.4l-7.6,-4.6l-8.6,0.5l-5.7,0.9l-6.6,-5.7l-4.8,-2.4l-9.2,-4.5l-1.1,-0.5l-12,3.7l6.2,23.4l-2.6,0.3l-4.8,-5l-3.9,-1.8l-5.6,1.3l-1.8,2.2l-0.6,-1.6l0.6,-2.6l-1.5,-2.2l-6.5,-2.2l-3.7,-5.7l-3.2,-1.6l-0.6,-2.1l5.1,0.6l-1,-4.6l4.1,-1l4.7,0.9l-0.7,-6.1l-1.9,-3.9l-5,0.3l-4.7,-1.5l-5.1,2.7l-4.4,1.4l-2.8,-1.1l-0.2,-3.2l-4.3,-4.2l-3.6,0.2l-5.3,-4.2l1.7,-4.8l-1.8,-1.2l2.2,-6.9l6,3.6l-0.6,-4.5l8.1,-6.7l7.6,-0.2l12,4.3l6.6,2.5l4.4,-2.6l7.7,-0.1l7.3,3.2l0.8,-1.9l7,0.3l0.2,-2.9l-9.4,-4.3l3.5,-3l-1.5,-1.6l4,-1.6l-5.1,-4.2l1.4,-2.1l17,-2.1l1.7,-1.5l10.9,-2.3l3.1,-2.5l9.1,1.3l4.4,6.3l4.3,-1.5l7.1,2.1l1.1,3.3z",
    fill: "#cbd6f4",
    id: "KZ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1223.5,476.7l-4.9,7.2l0.2,23.4l3.3,5.3l-4,2.6l-1.4,2.7l-2.2,0.4l-0.8,4.6l-1.9,2.6l-1.1,4.2l-2.3,2.1l-8.1,-6.4l-0.3,-3.7l-20.5,-13.1l0.4,-4.7l-1.4,-2.5l0,-0.3l1.6,-2.6l2.8,-4.2l2.1,-4.7l-2.6,-7.4l-0.7,-3.2l-2.7,-4.5l3.4,-3.8l3.8,-4.2l2.9,1.1l0.1,3.6l1.9,2.1l4,0l7.2,5.4l1.8,0.1l1.3,-0.2l1.3,0.7l3.8,0.6l1.6,-2.7l5.2,-2.7l2.3,2.2l3.9,0z",
    fill: "#cbd6f4",
    id: "KE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1400.5,230.2l-0.2,1.4l-6.9,3.4l-1,2.6l-6.4,0.7l-0.6,4.1l-5.8,-0.9l-3.2,1.3l-4.1,3l1.2,1.5l-1.1,1.4l-9.6,1l-7.1,-2.1l-5.5,0.5l-0.6,-3.6l6,1l1.4,-1.9l4.1,0.6l5.3,-4.6l-7.2,-3.4l-3.2,1.6l-4.6,-2.4l3,-4.1l-1.7,-0.6l0.3,-2.8l3.1,-0.9l9.2,2.2l-0.5,-3.7l2.5,-1.4l8.2,2.7l1.6,-0.7l8.6,0.2l7.9,0.6l3.4,2.3l3.5,1z",
    fill: "#cbd6f4",
    id: "KG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1589.8,410.6l1.8,4.3l0.1,7.7l-9,5l2.8,3.8l-5.9,0.5l-4.6,2.6l-4.8,-0.9l-2.6,-3.4l-3.5,-6.6l-2.1,-7.8l3.1,-5.3l7.1,-1.2l5.3,0.9l5,2.5l2,-4.4l5.3,2.3z",
    fill: "#cbd6f4",
    id: "KH"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1652.9,259.5l0,-0.6l2.5,0.2l0.6,-2.8l3.6,-0.4l2,-0.4l0,-1.5l8.3,7.5l3.3,4.2l3.4,7.4l-0.5,3.5l-4.3,1.2l-3.1,2.7l-4.6,0.5l-2.1,-3.5l-1.1,-4.8l-5.3,-6.6l3.4,-1.1l-6.1,-5.5z",
    fill: "#cbd6f4",
    id: "KR"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1247.5,309.4l1.5,2.8l-0.3,1.5l2.4,4.8l-3.9,0.2l-1.7,-3.1l-5,-0.6l3.3,-6.2l3.7,0.6z",
    fill: "#cbd6f4",
    id: "KW"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1589.8,410.6l-5.3,-2.3l-2,4.4l-5,-2.5l1.5,-2.9l-0.4,-5.4l-5.3,-5.6l-1.3,-6.4l-5,-5.2l-4.3,-0.4l-0.8,2.2l-3.2,0.2l-1.9,-1.1l-5.3,3.8l-1,-5.8l0.4,-6.7l-3.8,-0.3l-0.9,-3.9l-2.7,-2l0.8,-2.3l4.1,-4.2l0.8,1.5l3,0.2l-2,-7.4l2.7,-0.9l4,5.1l3.5,5.8l6.8,0l3,5.6l-3.3,1.7l-1.2,2.3l7.3,3.9l5.7,7.6l4.4,5.6l4.9,4.5l2,4.5l-0.2,6.4z",
    fill: "#cbd6f4",
    id: "LA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1179.1,288.2l-1.4,0.1l-0.4,1.1l-1.8,0l1.3,-5.3l2.2,-4.5l0,-0.2l2.5,0.3l1.2,2.5l-2.7,2.5l-0.9,3.5z",
    fill: "#cbd6f4",
    id: "LB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m938.6,452.5l-0.2,1.8l0.5,3.1l-1.2,2.9l1.6,1.8l1.8,0.4l2.4,2.7l0.2,2.5l-0.6,0.8l-0.4,5.3l-1.5,0.1l-5.8,-3.1l-5.2,-4.9l-4.8,-3.5l-3.8,-4.1l1.4,-2.1l0.3,-1.9l2.6,-3.4l2.6,-3l1.3,-0.2l1.4,-0.7l2.4,3.9l-0.4,2.6l1.1,1.4l1.6,0l1.1,-2.6l1.6,0.2z",
    fill: "#cbd6f4",
    id: "LR"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1122.6,299.1l-1.7,3.1l1,2.8l-1.1,3.9l2,5.2l1.3,22.8l1,23.7l0.5,12.8l-6.4,0l0,2.7l-22.6,-12.3l-22.5,-12.3l-5.5,3.5l-3.8,2.4l-3.2,-3.5l-8.8,-2.8l-2.5,-4l-4.5,-3l-2.5,1.2l-2.1,-3.6l-0.2,-2.7l-3.4,-4.7l2.2,-2.7l-0.6,-4l0.6,-3.5l-0.4,-3l0.8,-5.2l-0.4,-3l-1.9,-5.7l2.6,-1.4l0.4,-2.8l-0.6,-2.6l3.6,-2.5l1.6,-2.1l2.6,-1.8l0.1,-4.9l6.4,2.2l2.3,-0.6l4.5,1.1l7.3,2.9l2.8,5.7l4.9,1.2l7.8,2.7l6,3.2l2.5,-1.7l2.5,-2.9l-1.6,-4.9l1.5,-3.2l3.7,-3l3.7,-0.8l7.4,1.3l2,2.8l2,0.1l1.8,1.1l5.4,0.7l1.5,2.1z",
    fill: "#cbd6f4",
    id: "LY"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1445.9,462l-4.8,1.5l-2.9,-5.1l-1.4,-9.2l2,-10.4l4.1,3.5l2.8,4.5l3.1,6.7l-0.6,6.7l-2.3,1.8z",
    fill: "#cbd6f4",
    id: "LK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1139.1,697.9l-2,0.7l-3.7,-5l3.2,-4l3.1,-2.5l2.7,-1.4l2.2,2l1.7,2l-1.9,3.1l-1.1,2.1l-3.1,1l-1.1,2z",
    fill: "#cbd6f4",
    id: "LS"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1111.1,147.6l1,2.7l-3.6,2l-0.5,3.4l-4.8,2.3l-4.7,0l-1.4,-1.9l-2.5,-0.7l-0.6,-1.5l0.2,-1.7l-2.2,-0.9l-5.1,-1.1l-1.7,-5.1l5.1,-1.8l7.9,0.4l4.5,-0.6l0.9,1.2l2.5,0.4l5,2.9z",
    fill: "#cbd6f4",
    id: "LT"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1016.9,185.4l-1.4,0.1l-1.1,-0.5l0.4,-3.5l1.3,-0.2l1,1.4l-0.2,2.7z",
    fill: "#cbd6f4",
    id: "LU"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1112.8,136.5l2.5,1.3l1,2.9l2.1,3.6l-4.6,2.3l-2.7,1l-5,-2.9l-2.5,-0.4l-0.9,-1.2l-4.5,0.6l-7.9,-0.4l-5.1,1.8l-0.5,-4.5l1.7,-3.8l4.1,-2l4.4,4.5l3.7,-0.2l0.1,-4.6l3.8,-1l2.1,0.7l4.4,2.2l3.8,0.1z",
    fill: "#cbd6f4",
    id: "LV"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m974.8,276l1.9,4.1l0.3,3.9l1.9,6.8l1.4,1.4l-1,2.5l-7.1,1.1l-2.5,2.3l-3.1,0.6l-0.3,4.8l-6.4,2.5l-2.1,3.2l-4.5,1.7l-5.4,1l-8.9,4.8l-0.1,7.6l-0.9,0l0.1,3.4l-3.4,0.2l-1.8,1.5l-2.5,0l-2,-0.9l-4.6,0.7l-1.9,5l-1.8,0.5l-2.7,8.1l-7.9,6.9l-2,8.9l-2.4,2.9l-0.7,2.3l-12.5,0.5l-0.1,0l0.3,-3l2.2,-1.7l1.9,-3.4l-0.3,-2.2l2,-4.5l3.2,-4.1l1.9,-1l1.6,-3.7l0.2,-3.5l2.1,-3.9l3.8,-2.4l3.6,-6.5l0.1,-0.1l2.9,-2.5l5.1,-0.7l4.4,-4.4l2.8,-1.7l4.7,-5.4l-1.2,-7.9l2.2,-5.6l0.9,-3.4l3.6,-4.3l5.4,-2.9l4.1,-2.7l3.7,-6.6l1.8,-4l3.9,0.1l3.1,2.7l5.1,-0.4l5.5,1.4l2.4,0z",
    fill: "#cbd6f4",
    id: "MA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1129.4,210.3l-1.3,-2.9l0.2,-2.7l-0.6,-2.7l-3.4,-3.8l-2,-2.6l-1.8,-1.8l-1.6,-0.7l1.1,-0.9l3.2,-0.6l4,1.9l2,0.3l2.6,1.7l-0.1,2.1l2,1l1.1,2.6l2,1.6l-0.2,1l1,0.6l-1.3,0.5l-3,-0.2l-0.6,-0.9l-1,0.5l0.6,1.1l-1.1,2.1l-0.6,2.1l-1.2,0.7z",
    fill: "#cbd6f4",
    id: "MD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1267.9,588.9l0.4,7.7l1.3,3l-0.7,3.1l-1.2,1.8l-1.6,-3.7l-1.2,1.9l0.8,4.7l-0.7,2.8l-1.7,1.4l-0.7,5.5l-2.7,7.5l-3.4,8.8l-4.3,12.2l-2.9,8.9l-3.1,7.5l-4.6,1.5l-5.1,2.7l-3,-1.6l-4.2,-2.3l-1.2,-3.4l0,-5.7l-1.5,-5.1l-0.2,-4.7l1.3,-4.6l2.6,-1.1l0.2,-2.1l2.9,-4.9l0.8,-4.1l-1.1,-3l-0.8,-4.1l-0.1,-5.9l2.2,-3.6l1,-4.1l2.8,-0.2l3.2,-1.3l2.2,-1.2l2.4,-0.1l3.4,-3.6l4.9,-4l1.8,-3.2l-0.6,-2.8l2.4,0.8l3.3,-4.4l0.3,-3.9l2,-2.9l1.8,2.8l1.4,2.7l1.2,4.3z",
    fill: "#cbd6f4",
    id: "MG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m449.3,335.9l2.2,-0.2l-3.2,5.7l-1.8,4.6l-1.8,8.6l-1.1,3.1l0.4,3.5l1.3,3.2l0.4,4.9l3,4.8l0.8,3.7l1.7,3.1l5.7,1.7l1.9,2.7l5.2,-1.8l4.3,-0.6l4.4,-1.2l3.6,-1.1l3.9,-2.6l1.8,-3.7l1.2,-5.4l1.2,-1.9l4,-1.7l6.1,-1.5l4.9,0.3l3.4,-0.6l1.2,1.4l-0.6,3.1l-3.5,3.8l-1.8,3.9l0.9,1.1l-1.2,2.8l-2.1,5l-1.2,-1.7l-1.1,0.1l-1.1,0.1l-2.5,3.9l-0.9,-0.8l-0.7,0.3l-0.1,1l-5.2,-0.1l-5.2,0l-0.5,3.6l-2.5,0.1l1.8,2.1l1.9,1.5l0.5,1.4l0.8,0.4l-0.4,2.2l-7.2,0l-3.3,5.2l0.7,1.2l-0.8,1.5l-0.4,1.9l-5.6,-6.9l-2.6,-2.1l-4.4,-1.7l-3.2,0.5l-4.8,2.4l-2.9,0.6l-3.7,-1.7l-4.1,-1.2l-4.8,-2.9l-4.1,-0.9l-5.9,-3l-4.3,-3.1l-1.1,-1.7l-3.1,-0.4l-5.4,-2l-1.9,-2.9l-5.4,-3.7l-2.2,-4l-0.8,-3.2l1.9,-0.6l-0.3,-1.8l1.6,-1.7l0.4,-2.2l-1.5,-2.9l0,-2.5l-1.3,-3.3l-3.8,-6.4l-4.6,-5l-1.9,-4l-4.1,-2.6l-0.7,-1.6l1.7,-3.9l-2.4,-1.5l-2.5,-3.2l-0.2,-4.4l-2.8,-0.6l-2.3,-3.3l-1.7,-3.2l0.3,-2l-1.5,-4.8l-0.3,-4.9l0.8,-2.5l-3.1,-2.6l-1.9,0.3l-2.4,-1.7l-1.8,2.6l-0.1,3l-1,4.9l1,2.6l2.8,4.4l0.4,1.6l0.7,0.4l0.1,2.2l1,-0.1l0,4.2l1.3,1.6l0.5,2.3l2.7,3.2l0.4,6l1,2.8l0.9,3l-0.3,3.4l2.6,0.2l1.6,2.9l1.5,2.9l-0.3,1.2l-2.8,2.3l-1,0l-0.7,-3.9l-2.9,-3.7l-3.4,-3.1l-2.5,-1.6l1.2,-4.7l-0.1,-3.5l-2.1,-2l-3.1,-2.8l-0.9,0.8l-1,-1.7l-3,-1.5l-2.2,-3.8l0.5,-0.4l2.1,0.3l2.7,-2.4l1,-2.9l-2.9,-4.6l-2.6,-1.7l-0.8,-4l-0.6,-4.3l-0.8,-5.1l-0.2,-5.8l6.3,-0.5l7.1,-0.7l-0.9,1.3l7,3.1l10.9,4.5l10.8,0l4.3,0l0.8,-2.7l9.4,0l1.3,2.3l2.1,2.1l2.4,2.8l0.8,3.3l0.4,3.6l2.3,1.9l4,1.9l4.8,-5l4.5,-0.2l3.2,2.6l1.6,4.4l0.9,3.8l2.4,3.6l0.2,4.5l0.9,3l3.9,2l3.6,1.4z",
    fill: "#cbd6f4",
    id: "MX"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1105.5,236.6l-1,0.2l-0.8,1.1l-2.8,-0.1l-1.8,1.4l-3.4,0.5l-2.3,-1.5l-1,-2.7l0.5,-2.2l0.7,0.1l0.1,-1.3l2.9,-1l1.2,-0.3l1.7,-0.3l2.4,-0.2l2.8,2.1l0.8,4.2z",
    fill: "#cbd6f4",
    id: "MK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1010.2,378.8l0.1,14.8l-3.1,4.3l-0.4,4l-5,1l-7.7,0.5l-2,2.3l-3.6,0.3l-3.6,0l-1.4,-1.2l-3.1,0.9l-5.3,2.7l-1.1,2l-4.3,2.8l-0.8,1.7l-2.4,1.3l-2.7,-0.9l-1.5,1.6l-0.9,4.4l-4.5,5.3l0.2,2.2l-1.6,2.7l0.4,3.7l-2.4,1l-1.3,0.8l-0.9,-2.7l-1.6,0.7l-1,-0.1l-1,1.8l-4.4,0l-1.5,-1l-0.8,0.6l-1.7,-1.9l0.3,-1.9l-0.7,-0.7l-1.2,0.6l0.3,-2.1l1.1,-1.6l-2.3,-2.7l-0.6,-1.8l-1.3,-1.4l-1.1,-0.2l-1.3,0.9l-1.9,0.9l-1.5,1.4l-2.4,-0.5l-1.6,-1.7l-0.9,-0.2l-1.5,0.9l-0.9,0l-0.3,-2.4l0.3,-2l-0.5,-2.4l-2,-1.8l-1.1,-3.7l-0.2,-4l1.9,-1.2l1,-3.8l1.8,-0.1l3.9,1.8l3.2,-1.3l2.1,0.4l0.9,-1.4l22.5,-0.1l1.3,-4.5l-1,-0.8l-2.5,-27.7l-2.4,-27.7l8.5,-0.1l18.6,14l18.7,14l1.3,3l3.5,1.8l2.6,1.1l0.1,4.1l6.2,-0.7z",
    fill: "#cbd6f4",
    id: "ML"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1548.4,364.2l-4.1,4.2l-0.8,2.3l-3,1.5l-2.8,2.8l-3.9,0.3l-1.5,6.9l-2.2,1.2l3.5,5.6l4.1,4.7l2.9,4.3l-1.4,5.5l-1.8,1.2l1.8,3.2l4.3,5.1l1,3.6l0.2,3l2.7,5.9l-2.6,6l-2.2,6.6l-0.9,-4.8l1.3,-4.9l-2.2,-3.8l-0.2,-7l-2.6,-3.4l-2.7,-7.6l-2,-8.1l-3.1,-5.4l-3.2,3.3l-5.8,4.5l-3.3,-0.5l-3.6,-1.5l0.9,-8l-2,-6l-5.3,-7.4l0.3,-2.3l-3.4,-0.9l-4.6,-5.2l-1.1,-5.2l2.1,1l-0.6,-4.6l2.5,-1.5l-1,-2.7l1,-2.2l-0.9,-6.7l4.6,1.5l1.6,-5.3l-0.3,-3.1l2,-5.4l-0.9,-3.7l6.2,-4.4l4.2,1.1l-1.4,-3.9l1.7,-1.2l-1,-2.4l3.1,-0.5l2.7,3.8l2.7,1.5l1.3,4.9l0.9,5.3l-4.2,5.4l0.7,7.6l5.6,-1.1l2.4,5.9l3.7,1.3l-0.8,5.3l4.5,2.4l2.6,1.2l3.8,-1.9l0.5,2.7z",
    fill: "#cbd6f4",
    id: "MM"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1090.6,227.2l-0.8,1.4l-1.4,0.6l-0.4,-1.2l-1.9,3.1l0.5,2.1l-1.1,-0.5l-1.7,-2.1l-2.3,-1.3l0.5,-1l0.4,-3.5l1.6,-1.5l0.9,-0.6l1.4,1.1l0.9,0.9l1.7,0.7l2.1,1.3l-0.4,0.5z",
    fill: "#cbd6f4",
    id: "ME"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1496.2,181.5l4,-1.2l5.7,-0.8l5.4,0.9l6.6,2.9l4.9,3.2l4.6,0l6.8,1l3.6,-1.6l5.9,-1l4.4,-4.4l3.4,0.7l3.9,2.1l5.6,-0.6l0.6,4.7l0.3,6.3l2.8,2.5l2.3,-0.8l5.5,1l2.5,-2.3l5.2,2l7.2,4.4l0.8,2.2l-4.4,-0.7l-6.8,0.8l-2.5,1.8l-1.3,4.2l-6.4,2.4l-3.2,3.4l-5.9,-1.3l-3.2,-0.6l-0.5,4.1l2.9,2.4l1.9,2.1l-2.4,2.2l-2,3.4l-4.9,2.2l-7.6,0.2l-7.2,2.2l-4.4,3.4l-3.3,-1.9l-6.2,0l-9.4,-3.9l-5.6,-0.9l-6.4,0.9l-11.3,-1.5l-5.6,0.2l-4.7,-3.8l-5,-5.8l-3.4,-0.7l-8,-4l-7.2,-0.8l-6.5,-1.1l-3,-2.8l-1.4,-7.3l-5.8,-5.1l-8.2,-2.3l-5.7,-3.3l-3.3,-4.4l4.7,-1.1l6.7,-5.3l5.9,-2.9l5.3,1.9l5.2,0.1l4.8,2.9l5,0.2l8,1.6l2.4,-4.4l-4,-3.6l1.3,-6.4l7,2.5l4.8,0.8l6.7,1.6l3.6,4.6l8.5,2.6z",
    fill: "#cbd6f4",
    id: "MN"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1166.7,673.5l-4.1,0l-0.3,-2.9l-0.6,-2.9l-0.4,-2.3l1.4,-7.1l-1.1,-4.6l-2.2,-9l6.2,-7.3l1.7,-4.6l0.8,-0.6l0.9,-3.8l-0.8,-1.9l0.4,-4.8l1.3,-4.4l0.4,-8.2l-2.8,-2l-2.7,-0.5l-1.1,-1.6l-2.6,-1.3l-4.7,0.1l-0.2,-2.4l-0.4,-4.6l17.2,-5.3l3.2,3.1l1.5,-0.6l2.2,1.6l0.2,2.6l-1.3,3l0.2,4.5l3.5,4l1.9,-4.5l2.5,-1.3l-0.1,-8.3l-2.2,-4.6l-1.9,-2.1l-0.4,0l-0.6,-7.3l1.5,-6.1l2.2,-0.2l6.7,1.8l1.5,-0.8l3.9,-0.2l2.1,-1.9l3.4,0.1l6.2,-2.5l4.6,-3.7l0.9,2.8l-0.5,6.4l0.5,5.7l-0.2,10l0.8,3.1l-1.9,4.6l-2.4,4.5l-3.7,4l-5.3,2.4l-6.5,3.1l-6.6,6.9l-2.2,1.2l-4.2,4.6l-2.3,1.4l-0.8,4.6l2.4,4.9l0.9,3.7l0,2l1,-0.4l-0.5,6.3l-1.1,3l1.2,1.1l-1,2.7l-2.4,2.3l-4.7,2.1l-6.9,3.5l-2.5,2.4l0.3,2.7l1.3,0.4l-0.7,3.4z",
    fill: "#cbd6f4",
    id: "MZ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m959.2,341.5l-8.5,0.1l2.4,27.7l2.5,27.7l1,0.8l-1.3,4.5l-22.5,0.1l-0.9,1.4l-2.1,-0.4l-3.2,1.3l-3.9,-1.8l-1.8,0.1l-1,3.8l-1.9,1.2l-3.6,-4.4l-3.4,-4.8l-3.6,-1.7l-2.7,-1.8l-3.1,0l-2.8,1.4l-2.7,-0.5l-2,2l-0.4,-3.4l1.6,-3.2l0.8,-6l-0.4,-6.4l-0.6,-3.2l0.6,-3.2l-1.4,-3l-2.8,-2.8l1.3,-2.1l21.7,0l-0.9,-9.3l1.5,-3.3l5.2,-0.5l0.2,-16.5l18,0.4l0.2,-9.8l20.5,15.6z",
    fill: "#cbd6f4",
    id: "MR"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1182.3,588.9l0.4,0l1.9,2.1l2.2,4.6l0.1,8.3l-2.5,1.3l-1.9,4.5l-3.5,-4l-0.2,-4.5l1.3,-3l-0.2,-2.6l-2.2,-1.6l-1.5,0.6l-3.2,-3.1l-2.9,-1.6l2,-6l1.8,-2.2l-0.9,-5.4l1.3,-5.2l1,-1.7l-1.3,-5.4l-2.6,-2.9l5.5,1.2l1,1.7l-0.1,0.8l1.8,4.1l0.2,7.7l-1.8,3.6l1.6,4.7l-0.2,2.8l1.2,1.9l-0.1,2.4l0.9,1.4l1,-1.6l1.9,2.5l0.2,-0.8l-1,-3.4l-1.1,-0.3l-0.1,-0.9z",
    fill: "#cbd6f4",
    id: "MW"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Malaysia",
    d: "m1564.3,461.9l1.4,0.6l3.5,3.9l2.5,4.3l0.6,4.3l-0.5,2.9l0.6,2.2l0.5,3.8l2.1,1.8l2.3,5.7l0,2.1l-4,0.5l-5.5,-4.8l-6.8,-5.1l-0.8,-3.3l-3.4,-4.3l-1,-5.3l-2.2,-3.5l0.4,-4.7l-1.4,-2.7l0.9,-1.1l4.8,2.8l0.6,3.3l3.7,-0.8l1.7,-2.6z",
    fill: "#cbd6f4",
    id: "svg_66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Malaysia",
    d: "m1654.1,475.3l-5,-1.1l-6.5,0l-1.7,7.3l-2.1,2.2l-2.6,8.9l-4.6,1.4l-5.4,-1.8l-2.7,0.6l-3.3,3.2l-3.6,-0.4l-3.7,1.3l-3.9,-3.7l-1,-4.3l4.2,2.2l4.3,-1.2l1,-5.4l2.4,-1.2l6.8,-1.4l3.8,-5.1l2.6,-4l2.8,3.3l1.1,-2.2l2.7,0.2l0.1,-4.1l0.1,-3.2l4.1,-4.4l2.6,-5l2.3,-0.1l3.1,3.3l0.4,2.8l3.8,1.8l4.8,1.9l-0.2,2.5l-3.8,0.3l1.1,3.2l-4,2.2z",
    fill: "#cbd6f4",
    id: "svg_67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1116.2,614.3l4.6,-1.4l3.6,0.3l2.2,1.5l0,0.5l-3.2,1.5l-1.7,0l-3.7,2.5l-2,-2.7l-8.7,2.3l-4.2,0.2l-0.8,22.9l-5.5,0.2l-0.6,18.7l-1.1,23.7l-5,3.3l-2.9,0.5l-3.4,-1.2l-2.5,-0.5l-0.8,-2.7l-2,-1.8l-2.8,3.2l-3.9,-4.9l-2,-4.6l-1,-6.3l-1.2,-4.6l-1.6,-9.9l0.1,-7.7l-0.6,-3.5l-2.1,-2.7l-2.8,-5.3l-2.8,-7.7l-1.1,-4l-4.4,-6.3l-0.3,-4.9l2.7,-1.2l3.4,-1.1l3.6,0.2l3.3,2.9l0.8,-0.5l22.7,-0.2l3.8,3l13.5,0.9l10.4,-2.6z",
    fill: "#cbd6f4",
    id: "NA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1068.6,355l1.6,10l2.2,1.7l0.1,2l2.4,2.2l-1.2,2.8l-1.8,13l-0.2,8.4l-7,6l-2.3,8.5l2.4,2.4l0,4.1l3.7,0.1l-0.6,3.1l-1.5,0.3l-0.2,2.1l-1,0.1l-3.9,-7l-1.4,-0.3l-4.3,3.6l-4.4,-1.9l-3,-0.3l-1.6,0.9l-3.3,-0.2l-3.3,2.7l-2.9,0.2l-6.8,-3.3l-2.7,1.5l-2.9,-0.1l-2.1,-2.4l-5.6,-2.4l-6.1,0.8l-1.4,1.3l-0.8,3.7l-1.6,2.6l-0.4,5.8l-4.3,-3.7l-2,0l-1.9,1.9l0.1,-4.4l-6.5,-1.5l-0.2,-3.1l-3.1,-4.2l-0.8,-2.9l0.5,-3.1l3.6,-0.3l2,-2.3l7.7,-0.5l5,-1l0.4,-4l3.1,-4.3l-0.1,-14.8l7.8,-2.8l16,-12.6l18.8,-12.3l8.8,2.8l3.2,3.5l3.8,-2.4z",
    fill: "#cbd6f4",
    id: "NE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1066.2,421.7l2.3,2.5l-0.6,1.2l-0.3,2.1l-4.7,5l-1.4,4.1l-0.8,3.3l-1.2,1.5l-1.1,4.5l-3,2.6l-0.8,3.2l-1.3,2.6l-0.5,2.7l-3.9,2.2l-3.2,-2.7l-2.1,0.1l-3.4,3.8l-1.6,0l-2.7,6.2l-1.4,4.6l-5.9,2.3l-2.1,-0.3l-2.2,1.4l-4.5,-0.1l-3.1,-4.1l-1.9,-4.6l-4,-4.2l-4.2,0l-5,0l0.3,-10.3l-0.2,-4.1l1.1,-4l1.7,-2l2.8,-4l-0.6,-1.7l1.1,-2.6l-1.3,-3.8l0.2,-2.1l0.4,-5.8l1.6,-2.6l0.8,-3.7l1.4,-1.3l6.1,-0.8l5.6,2.4l2.1,2.4l2.9,0.1l2.7,-1.5l6.8,3.3l2.9,-0.2l3.3,-2.7l3.3,0.2l1.6,-0.9l3,0.3l4.4,1.9l4.3,-3.6l1.4,0.3l3.9,7l1,-0.1z",
    fill: "#cbd6f4",
    id: "NG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m519.6,405.5l-0.5,0.7l-0.5,1.4l0.4,2.3l-1.5,2.2l-0.8,2.6l-0.5,2.8l0.2,1.7l-0.1,2.9l-0.9,0.6l-0.7,2.8l0.2,1.7l-1.2,1.6l0.1,1.7l0.8,1.1l-1.4,1.4l-1.7,-0.5l-0.8,-1.3l-1.8,-0.5l-1.3,0.8l-3.6,-1.7l-0.9,0.8l-1.8,-2l-2.5,-2.6l-1.1,-2.1l-2.2,-2.1l-2.5,-2.9l0.7,-1l0.8,1l0.5,-0.4l1.8,-0.3l0.8,-1.5l0.8,0l0.2,-3.2l1.3,-0.1l1.2,0l1.4,-1.7l1.5,1.3l0.6,-0.8l1.2,-0.8l2.1,-1.7l0.2,-1.4l0.5,0.1l0.9,-1.5l0.6,-0.2l0.9,1l1.1,0.2l1.3,-0.8l1.4,0l2,-0.8l0.9,-0.9l1.9,0.1z",
    fill: "#cbd6f4",
    id: "NI"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Norway",
    d: "m1113.7,67.5l-6.4,2.1l-3.2,0.5l0.8,-3.8l-5.8,-2.1l-5.9,1.8l-1.1,4l-3.4,2.4l-4.7,-1.3l-5.3,0.2l-5.1,-2.8l-2.2,1.4l-2.6,0.2l0.1,3.6l-8,-0.9l-0.6,3.1l-4,0l-2.3,3.9l-3.4,6.1l-5.7,7.9l1.8,2l-1.3,2.2l-4.3,-0.1l-2.4,5.4l1,7.7l3.1,2.9l-0.8,6.9l-3.4,4l-1.8,3.4l-3.3,-3.6l-8.6,6.8l-6.1,1.4l-6.5,-3l-1.8,-6.3l-2,-13.5l4,-3.7l11.3,-4.9l8.1,-5.9l7.2,-7.8l8.9,-10.7l6.4,-4.1l10.3,-6.8l8.5,-2.4l6.7,0.3l5.2,-4.4l7.4,0.2l7,-1l13.7,3.9l-4.9,1.4l5.4,3.4z",
    fill: "#cbd6f4",
    id: "svg_68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Norway",
    d: "m1076.6,25.2l-7.6,1.9l-6.8,-1.1l2.2,-1.2l-2.6,-1.5l7.3,-0.9l1.9,1.7l5.6,1.1z",
    fill: "#cbd6f4",
    id: "svg_69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Norway",
    d: "m1051,16.7l12.6,3.4l-8.6,1.8l-1.2,3.4l-3,0.9l-0.9,4l-4.4,0.2l-8.5,-2.9l3,-1.7l-5.7,-1.4l-7.7,-3.9l-3.2,-3.5l9.3,-1.6l2.3,1.5l5,0l1,-1.5l5.2,-0.2l4.8,1.5z",
    fill: "#cbd6f4",
    id: "svg_70"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Norway",
    d: "m1075.4,13.7l7.4,1.5l-4.4,2.4l-10.1,0.5l-10.7,-0.8l-1,-1.2l-5.1,0l-4.3,-2l10.5,-1.2l5.4,1l3.1,-1.3l9.2,1.1z",
    fill: "#cbd6f4",
    id: "svg_71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1469,322.9l0.2,2.7l1.5,4.1l-0.1,2.5l-4.6,0.1l-6.9,-1.5l-4.3,-0.6l-3.8,-3.2l-7.7,-0.9l-7.8,-3.6l-5.8,-3.1l-5.8,-2.4l0.9,-6l2.8,-3l1.9,-1.5l4.8,2l6.4,4.2l3.3,0.9l2.5,3.1l4.5,1.2l5,2.9l6.5,1.4l6.5,0.7z",
    fill: "#cbd6f4",
    id: "NP"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Oman",
    d: "m1283.8,394.9l-2.2,-4.5l-5.2,-10.6l16.3,-6.4l2.6,-12.8l-3,-4.6l0,-2.6l1.3,-2.6l-0.2,-2.6l2.4,-1.3l-1.1,-0.9l0,-4.2l2.8,0l3,4.4l3.3,2.3l4.1,0.9l3.4,1.1l2.9,3.7l1.7,2.1l2,0.9l0.2,1.4l-1.7,3.8l-0.7,1.8l-2.2,2.1l-1.7,4.4l-2.5,-0.4l-1,1.6l-0.7,3.2l1.1,4.3l-0.5,0.8l-2.5,0l-3.3,2.4l-0.3,3.1l-1.2,1.4l-3.5,-0.1l-2,1.6l0.2,2.6l-2.6,1.8l-3.1,-0.6l-3.6,2.2l-2.5,0.3z",
    fill: "#cbd6f4",
    id: "svg_72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Oman",
    d: "m1296.2,336.7l-1.3,-2.2l1.4,-2.1l0.7,0.5l-0.2,2.7l-0.6,1.1z",
    fill: "#cbd6f4",
    id: "svg_73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1401.6,273.9l-3.8,5.4l-5.7,1l-8.5,-1.6l-2,2.8l3.3,5.6l2.9,4.4l5.1,3.1l-3.8,3.7l1,4.6l-3.9,6.5l-2.2,6.5l-4.5,6.7l-6.5,-0.5l-4.9,6.8l4,2.8l1.4,5l3.5,3.2l1.8,5.5l-12.1,0l-3.2,4.3l-4.2,-1.6l-2.2,-4.6l-4.9,-4.9l-10,1.2l-9,0.1l-7.6,0.9l1.1,-7.4l7.5,-3.4l-0.9,-2.9l-2.7,-1.1l-1,-5.6l-5.7,-2.8l-2.8,-3.9l-3.2,-3.4l9.6,3.3l5.3,-1l3.4,0.8l0.9,-1.4l3.9,0.6l6.6,-2.7l-0.8,-5.4l2.3,-3.7l4.1,0l0.2,-1.7l4,-0.9l2.1,0.6l1.8,-1.8l-1.1,-3.9l1.4,-3.8l3.1,-1.7l-3.1,-4.2l5.2,0.2l0.9,-2.3l-0.8,-2.5l2,-2.7l-1.4,-3.2l-1.9,-2.7l2.4,-2.8l5.3,-1.3l5.9,-0.8l2.4,-1.1l2.9,-0.8l4.7,3l2.9,5l9.5,2.5z",
    fill: "#cbd6f4",
    id: "PK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m549.3,446.2l-0.7,0.9l1.1,3.8l-1.1,1.9l-1.8,-0.5l-0.9,3.1l-1.8,-1.8l-1,-3.5l1.4,-1.7l-1.4,-0.4l-0.9,-2.1l-2.8,-1.8l-2.4,0.4l-1.3,2.2l-2.4,1.6l-1.2,0.2l-0.6,1.4l2.5,3.5l-1.6,0.8l-0.8,0.9l-2.7,0.4l-0.8,-3.9l-0.8,1.1l-1.8,-0.4l-1,-2.5l-2.3,-0.5l-1.5,-0.7l-2.4,0l-0.2,1.4l-0.6,-1l0.3,-1.3l0.6,-1.3l-0.2,-1.1l0.9,-0.8l-1.1,-0.9l0.1,-2.6l2.2,-0.6l1.9,2.3l-0.2,1.4l2.2,0.3l0.6,-0.6l1.5,1.6l2.8,-0.5l2.5,-1.6l3.5,-1.3l2,-1.9l3.1,0.4l-0.2,0.6l3.1,0.2l2.4,1.2l1.8,1.9l2,1.8z",
    fill: "#cbd6f4",
    id: "PA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m590.5,529.4l-5.1,-0.3l-0.8,1l-4.6,1.2l-6.3,4.4l-0.3,3l-1.4,2.2l0.7,3.5l-3.4,1.8l0.2,2.8l-1.5,1.1l2.6,5.8l3.3,3.9l-1,2.8l3.8,0.3l2.3,3.5l5,0.1l4.4,-3.7l0.1,9.7l2.6,0.7l3.2,-1.1l5.5,10.4l-1.1,2.1l0,4.6l0.3,5.4l-1.9,3.2l1.2,2.4l-1.1,2.2l2.9,5.4l-2.9,6.9l-1.1,3.3l-2.8,1.6l-5.9,-3.7l-0.8,-2.6l-11.7,-6.4l-10.7,-7.1l-4.7,-3.9l-2.8,-5.3l0.8,-1.9l-5.4,-8.4l-6.4,-11.8l-6,-12.8l-2.4,-3l-2,-4.7l-4.6,-4.2l-4.1,-2.6l1.7,-2.8l-3,-6.2l1.7,-4.5l4.4,-4l0.7,2.7l-1.6,1.5l0.3,2.3l2.3,-0.5l2.3,0.7l2.5,3.3l3.1,-2.7l0.9,-4.3l3.4,-5.6l6.7,-2.5l6.1,-6.8l1.7,-4.1l-0.8,-4.9l1.5,-0.6l3.8,3l1.8,3.1l2.6,1.6l3.5,6.7l4.2,0.9l3.1,-1.7l2.1,1.1l3.4,-0.6l4.4,3l-3.5,6.6l1.7,0.1l2.9,3.4z",
    fill: "#cbd6f4",
    id: "PE"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Philippines",
    d: "m1700.5,447.8l0.9,4.3l0.6,3.6l-1.6,5.8l-2.5,-6.5l-2.4,3.3l2.1,4.7l-1.4,3l-6.9,-3.7l-1.9,-4.7l1.5,-3l-3.8,-3.1l-1.6,2.7l-2.6,-0.3l-4,3.6l-1,-1.9l1.8,-5.4l3.4,-1.8l2.9,-2.4l2.2,2.9l4.2,-1.7l0.7,-2.9l4,-0.2l-0.8,-4.9l4.9,3l0.7,3.2l0.6,2.4z",
    fill: "#cbd6f4",
    id: "svg_74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Philippines",
    d: "m1685.9,435.8l-1.8,2.1l-1.4,4.1l-1.6,1.9l-3.9,-4.4l1,-1.8l1.3,-1.8l0.2,-3.9l3.1,-0.4l-0.5,4.3l3.6,-6.2l0,6.1z",
    fill: "#cbd6f4",
    id: "svg_75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Philippines",
    d: "m1655.6,442l-7.1,6.1l2.4,-4.5l3.8,-4l3,-4.4l2.3,-6.4l1.6,5.3l-3.5,3.5l-2.5,4.4z",
    fill: "#cbd6f4",
    id: "svg_76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Philippines",
    d: "m1673.1,425.5l3.6,2l3.5,0l0.2,2.6l-2.3,2.8l-3.4,1.9l-0.5,-3l0.1,-3.3l-1.2,-3z",
    fill: "#cbd6f4",
    id: "svg_77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Philippines",
    d: "m1693.2,423.7l2.4,7.2l-4.5,-1.7l0.3,2.2l1.8,3.9l-2.6,1.5l-0.6,-4.6l-1.8,-0.3l-1.2,-3.9l3.3,0.5l-0.3,-2.4l-4,-4.9l5.4,0.1l1.8,2.4z",
    fill: "#cbd6f4",
    id: "svg_78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Philippines",
    d: "m1670.2,417.9l-0.9,5.6l-2.7,-3.2l-3.5,-4.9l4.8,0.2l2.3,2.3z",
    fill: "#cbd6f4",
    id: "svg_79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Philippines",
    d: "m1663.7,383l3.8,1.9l1.4,-1.7l0.8,1.6l-0.4,2.7l2.6,4.6l-0.6,5.3l-2.9,2.1l-0.1,5.2l2,5.1l3,0.7l2.4,-0.7l7.5,3.5l-0.1,3.5l2.1,1.6l-0.3,2.9l-4.7,-3.1l-2.5,-3.4l-1.2,2.4l-4,-3.9l-5,1l-3,-1.4l-0.1,-2.7l1.6,-1.6l-1.9,-1.5l-0.4,2.3l-3.3,-3.7l-1.3,-2.8l-1.1,-6.1l2.6,2.1l-1.1,-10.1l0.8,-5.8l3.4,0z",
    fill: "#cbd6f4",
    id: "svg_80"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Papua New Guinea",
    d: "m1868.1,545.6l-1.6,0.7l-2.3,-2.5l-2.2,-4.1l-0.8,-4.9l0.8,-0.6l0.5,1.9l1.6,1.5l2.4,4l2.5,2.2l-0.9,1.8z",
    fill: "#cbd6f4",
    id: "svg_81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Papua New Guinea",
    d: "m1846.7,537l-3,0.5l-1,1.8l-3.2,1.6l-3,1.5l-3.1,0l-4.5,-1.9l-3.1,-1.8l0.6,-2l5,1l3.2,-0.5l1,-3.1l0.9,-0.2l0.3,3.4l3.2,-0.4l1.8,-2.2l3.3,-2.3l-0.4,-3.8l3.4,-0.1l1.1,1l-0.4,3.6l-2.1,3.9z",
    fill: "#cbd6f4",
    id: "svg_82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Papua New Guinea",
    d: "m1782.9,560.4l1.6,-21l1,-20.9l9.6,4.4l10.3,3.7l3.7,3.3l3,3.2l0.6,3.8l9.2,4l1.1,3.4l-5.2,0.7l0.9,4.3l4.7,4.2l3,6.8l3.3,-0.2l-0.6,2.8l4.3,1.1l-1.8,1.2l5.7,2.7l-0.9,1.9l-3.8,0.4l-1.2,-1.6l-4.7,-0.8l-5.6,-0.9l-4,-4.1l-2.8,-3.6l-2.5,-5.6l-7.1,-2.8l-4.9,1.8l-3.7,2.2l0.3,4.7l-4.6,2.2l-3.1,-1.1l-5.8,-0.2z",
    fill: "#cbd6f4",
    id: "svg_83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Papua New Guinea",
    d: "m1853.6,530.7l-1.8,1.7l-0.9,-3.8l-1.1,-2.4l-2.5,-2.1l-3.1,-2.8l-4,-1.9l1.6,-1.5l3,1.8l1.9,1.4l2.3,1.5l2.1,2.7l2.1,2.1l0.4,3.3z",
    fill: "#cbd6f4",
    id: "svg_84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1079.9,154.8l5.9,0.7l8.8,-0.1l2.5,0.7l1.4,1.9l0.6,2.7l1.7,2.3l0.4,2.4l-2.8,1.3l1.9,2.8l0.5,2.8l3.2,5.4l-0.3,1.7l-2.3,0.7l-3.8,5.2l1.6,2.8l-1.1,-0.4l-5,-2.4l-3.5,0.9l-2.4,-0.6l-2.8,1.3l-2.7,-2.2l-1.9,0.9l-0.3,-0.4l-2.6,-3.1l-3.7,-0.3l-0.7,-2l-3.4,-0.7l-0.6,1.6l-2.8,-1.3l0.2,-1.7l-3.7,-0.5l-2.5,-2l-2.4,-3.9l0.2,-2.2l-1.5,-3.3l-1.9,-2.1l1.2,-1.7l-1.4,-3.1l3.1,-1.8l7.1,-2.8l5.8,-2l4.8,1l0.6,1.5l4.6,0z",
    fill: "#cbd6f4",
    id: "PL"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1660.3,229.9l1.4,1.1l-2.2,-0.4l-1,2.2l-0.3,2.1l2.8,4.6l-1.9,1.4l-0.3,1.1l-0.9,1.9l-2.9,1.1l-1.4,1.7l1.3,2.7l-0.3,0.7l2.6,1.1l4.4,2.8l0,1.5l-2,0.4l-3.6,0.4l-0.6,2.8l-2.5,-0.2l0,0.6l-3.2,-1.2l-0.1,1.2l-1.3,0.5l-0.7,-1.2l-1.7,-0.6l-1.9,-1l0.1,-2.8l0.9,-0.8l-1,-1.1l-0.4,-3.5l-0.9,-1l-3.4,-0.7l-3.4,-1.7l2.1,-4.1l3.9,-3.4l1.1,-4.6l3.6,2l4.6,0.3l-2.8,-3.4l6.4,-2.7l0,-3.6l5.5,3.8z",
    fill: "#cbd6f4",
    id: "KP"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m662.5,631.4l2,3.5l0.4,8.7l5.9,1.3l2.2,-1.3l3.9,1.8l1.2,1.9l1.1,5.9l0.8,2.4l2.1,0.3l2,-1l2.1,1.1l0.3,3.6l-0.3,3.8l-0.7,3.7l-0.3,5.6l-4.3,5l-4.2,1l-6.3,-1l-5.8,-1.7l4.2,-9.8l-1.1,-2.8l-5.9,-2.5l-7.3,-4.8l-4.6,-1l-11.3,-10.4l1.5,-7.7l-0.2,-3.5l2.1,-5.6l9.6,-1.9l5.2,0.1l5.4,3.3l0.3,2z",
    fill: "#cbd6f4",
    id: "PY"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1178.3,293.8l0.4,4l-0.6,1.9l-2.5,0.8l0.1,-1.7l1.3,-0.9l-1.5,-0.7l0.7,-4.2l2.1,0.8z",
    fill: "#cbd6f4",
    id: "PS"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1270.1,343.7l-1.5,0.5l-1.8,-1.3l-0.8,-4.7l1.1,-3.3l1.5,-0.7l1.8,2l0.5,3.7l-0.8,3.8z",
    fill: "#cbd6f4",
    id: "QA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1118.9,193.1l1.6,0.7l1.8,1.8l2,2.6l3.4,3.8l0.6,2.7l-0.2,2.7l1.3,2.9l2.4,1.2l2.3,-1.1l2.4,1.1l0.4,1.7l-2.3,1.3l-1.6,-0.6l-0.4,7.7l-3.1,-0.7l-4,-2.3l-5.9,1.5l-2.3,1.6l-7.6,-0.4l-4,-0.9l-1.9,0.4l-1.8,-2.6l-1,-1.1l1,-1.1l-1.3,-0.7l-1.5,1.4l-3.1,-1.9l-0.7,-2.6l-3.2,-1.4l-0.8,-2.1l-3,-2.4l3.9,-1.2l2.6,-4.3l1.9,-4.2l2.9,-1.3l2,-1.4l3.2,0.7l3.2,0l2.5,1.6l1.6,-1l3.6,-0.6l1,-1.5l2.1,0z",
    fill: "#cbd6f4",
    id: "RO"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1158.8,509.1l2.2,3.6l-0.3,3.8l-1.6,0.8l-3.1,-0.4l-1.7,3.7l-3.5,-0.5l0.6,-3.6l0.8,-0.5l0.2,-3.8l1.6,-1.8l1.4,0.7l3.4,-2z",
    fill: "#cbd6f4",
    id: "RW"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m938.9,324.3l-0.1,0.4l-0.1,1.2l-0.2,9.8l-18,-0.4l-0.2,16.5l-5.2,0.5l-1.5,3.3l0.9,9.3l-21.7,0l-1.3,2.1l0.3,-2.7l0.1,0l12.5,-0.5l0.7,-2.3l2.4,-2.9l2,-8.9l7.9,-6.9l2.7,-8.1l1.8,-0.5l1.9,-5l4.6,-0.7l2,0.9l2.5,0l1.8,-1.5l3.4,-0.2l-0.1,-3.4l0.9,0z",
    fill: "#cbd6f4",
    id: "EH"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1240.5,315l5,0.6l1.7,3.1l3.9,-0.2l2.7,5.6l2.9,1.4l1.2,2.3l4,2.7l0.7,2.6l-0.4,2.2l0.9,2.1l1.8,1.8l0.9,2.1l1,1.6l1.8,1.3l1.5,-0.5l1.3,2.5l0.3,1.4l2.7,6.6l16.9,3.2l1,-1.4l3,4.6l-2.6,12.8l-16.3,6.4l-15.9,2.5l-5,2.9l-3.5,6.7l-2.6,1.1l-1.5,-2.1l-2.1,0.3l-5.5,-0.7l-1.1,-0.6l-6.4,0.1l-1.5,0.6l-2.4,-1.6l-1.3,3.1l0.8,2.7l-2.4,2.1l-0.9,-2.8l-1.8,-1.9l-0.5,-2.6l-3.1,-2.3l-3.3,-5.4l-1.9,-5.2l-4.1,-4.4l-2.5,-1.1l-4.1,-6.1l-0.9,-4.4l0,-3.8l-3.6,-7.2l-2.8,-2.5l-3,-1.3l-2.1,-3.7l0.2,-1.4l-1.8,-3.4l-1.7,-1.4l-2.5,-4.8l-3.8,-5.1l-3.1,-4.4l-2.7,0l0.5,-3.5l0.1,-2.3l0.4,-2.6l6.2,1.1l2.1,-2l1.1,-2.3l4.1,-0.9l0.7,-2.2l1.6,-1l-6,-6.5l10.4,-3.2l0.9,-1l6.8,1.8l8.6,4.5l16.8,12.9l10.2,0.5z",
    fill: "#cbd6f4",
    id: "SA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1191,409.2l-0.7,5.5l-2,6.4l-3.3,3.1l-2.3,5l-0.5,2.6l-2.6,1.8l-1.5,6.7l0,0.8l-0.8,-0.2l0.1,-3.2l-0.8,-2.2l-2.9,-2.5l-0.9,-4.6l0.6,-4.8l-2.6,-0.4l-0.4,1.4l-3.4,0.4l1.5,1.8l0.5,3.9l-3,3.5l-2.7,4.6l-2.9,0.7l-4.8,-3.7l-2.1,1.3l-0.5,1.8l-2.9,1.3l-0.2,1.3l-5.6,0l-0.8,-1.3l-4.1,-0.3l-2,1.1l-1.6,-0.5l-2.9,-3.8l-1,-1.7l-4.1,0.9l-1.5,2.9l-1.3,5.8l-2,1.2l-1.7,0.7l-0.5,-0.3l-1.9,-1.9l-0.4,-2l0.8,-2.6l0,-2.7l-3.3,-4l-0.7,-2.7l0,-1.6l-2.1,-1.9l-0.1,-3.7l-1.3,-2.5l-1.9,0.4l0.5,-2.4l1.4,-2.6l-0.7,-2.7l1.8,-2l-1.2,-1.5l1.3,-3.9l2.5,-4.8l4.8,0.5l-1.1,-25.5l0,-2.7l6.4,0l-0.5,-12.8l22.3,0l21.5,0l22.1,0l2.1,6.3l-1.2,1.1l1.2,6.7l2.5,7.6l2.2,1.6l3.2,2.4l-2.7,3.6l-4,1.1l-1.7,2l-0.3,4.2l-2,9.5l0.7,2.5z",
    fill: "#cbd6f4",
    id: "SD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1178.1,441.1l0.2,5l-0.8,1.9l-3,0.2l-1.9,3.6l3.5,0.5l3,3.1l1,2.6l2.6,1.5l3.5,7l-3.8,4.2l-3.4,3.8l-3.5,3l-4,0l-4.5,1.5l-3.6,-1.5l-2.3,1.8l-5.1,-4.3l-1.4,-2.7l-3.1,1.3l-2.6,-0.4l-1.5,1.1l-2.6,-0.8l-3.5,-5.3l-0.9,-2l-4.3,-2.6l-1.4,-3.8l-2.4,-2.8l-3.9,-3.3l-0.1,-2.1l-3.1,-2.6l-3.9,-2.5l1.7,-0.7l2,-1.2l1.3,-5.8l1.5,-2.9l4.1,-0.9l1,1.7l2.9,3.8l1.6,0.5l2,-1.1l4.1,0.3l0.8,1.3l5.6,0l0.2,-1.3l2.9,-1.3l0.5,-1.8l2.1,-1.3l4.8,3.7l2.9,-0.7l2.7,-4.6l3,-3.5l-0.5,-3.9l-1.5,-1.8l3.4,-0.4l0.4,-1.4l2.6,0.4l-0.6,4.8l0.9,4.6l2.9,2.5l0.8,2.2l-0.1,3.2l0.8,0.2z",
    fill: "#cbd6f4",
    id: "SS"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m918,408l0.2,4l1.1,3.7l2,1.8l0.5,2.4l-0.3,2l-0.8,0.4l-3.1,-0.5l-0.4,0.7l-1.2,0.1l-4.1,-1.5l-2.7,-0.1l-10.4,-0.3l-1.5,0.8l-1.9,-0.2l-3,1l-0.8,-4.9l5.1,0.1l1.4,-0.9l1,0l2.1,-1.5l2.4,1.3l2.4,0.2l2.5,-1.5l-1.1,-1.8l-1.9,1l-1.7,0l-2.2,-1.6l-1.8,0.1l-1.3,1.6l-6.1,0.1l-2.3,-5l-2.7,-2.2l2.5,-1.3l2.8,-4.5l1.4,-3.3l2,-2l2.7,0.5l2.8,-1.4l3.1,0l2.7,1.8l3.6,1.7l3.4,4.8l3.6,4.4z",
    fill: "#cbd6f4",
    id: "SN"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m928.5,447.9l-2.6,3l-2.6,3.4l-0.3,1.9l-1.4,2.1l-1.5,-0.5l-4,-2.6l-3,-3.4l-0.9,-2.4l-0.7,-4.7l3.1,-2.9l0.6,-1.7l1,-1.4l1.6,-0.2l1.3,-1.2l4.5,0l1.6,2.3l1.2,2.7l-0.2,1.9l0.9,1.7l-0.1,2.3l1.5,-0.3z",
    fill: "#cbd6f4",
    id: "SL"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m492.5,415.9l-0.7,1.5l-3.3,-0.1l-2,-0.6l-2.2,-1.3l-3,-0.4l-1.5,-1.4l0.3,-0.9l2,-1.6l1.2,-0.7l-0.3,-0.8l1.4,-0.4l1.6,0.6l1.1,1.2l1.6,1.1l0.1,0.8l2.5,-0.7l1.2,0.4l0.7,0.7l-0.7,2.6z",
    fill: "#cbd6f4",
    id: "SV"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1102,218.2l-1.1,1.4l0.7,2.4l2.8,2.7l-1.8,2l-0.6,2l0.6,0.8l-0.7,0.8l-2.4,0.2l-1.7,0.3l-0.3,-0.5l0.6,-0.7l0.4,-1.6l-0.7,0.1l-1.1,-1.2l-0.9,-0.3l-0.8,-1l-1,-0.4l-0.8,-0.9l-0.9,0.4l-0.5,2.1l-1.2,0.4l0.4,-0.5l-2.1,-1.3l-1.7,-0.7l-0.9,-0.9l-1.4,-1.1l1.1,-0.3l0.5,-2.9l-2.7,-2.5l1.1,-2.8l-1.9,0.1l1.7,-2.4l-1.7,-1.8l-1.5,-2.5l3.7,-1.6l3.2,0.3l3,2.4l0.8,2.1l3.2,1.4l0.7,2.6l3.1,1.9l1.5,-1.4l1.3,0.7l-1,1.1l1,1.1z",
    fill: "#cbd6f4",
    id: "RS"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m681,464.9l-3.1,5.5l0.3,4.4l2.2,3.8l-1.1,2.7l-0.5,3l-1.5,2.7l-3.2,-1.4l-2.7,0.7l-2.3,-0.6l-0.6,1.9l1,1.2l-0.6,1.4l-3.1,-0.6l-3.3,-5.6l-0.7,-3.6l-1.8,0l-2.4,-4.6l1.1,-3.4l-0.3,-1.5l3.5,-1.6l1,-5.8l6.8,1.3l0.6,-1.2l4.6,-0.5l6.1,1.8z",
    fill: "#cbd6f4",
    id: "SR"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1098.1,187.7l-1.2,1.7l-0.7,2.5l-1,0.6l-5.5,-1.9l-1.6,0.4l-1,1.5l-2.3,0.8l-0.6,-0.4l-2.3,0.9l-1.9,0.2l-0.3,1.3l-4.1,0.7l-1.9,-0.6l-2.7,-1.7l-0.7,-2.1l0.3,-0.8l0.6,-1.4l2.2,0.1l1.6,-0.6l0.1,-0.6l0.9,-0.3l0.2,-1.4l1.1,-0.3l0.7,-1.1l1.5,0l0.3,0.4l1.9,-0.9l2.7,2.2l2.8,-1.3l2.4,0.6l3.5,-0.9l5,2.4z",
    fill: "#cbd6f4",
    id: "SK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1069.8,203.9l-3.9,1.7l-0.3,2.5l-1.7,0.7l0.1,1.7l-2,-0.1l-1.8,-1l-0.8,1l-3.6,-0.2l1.1,-0.5l-1.4,-2.7l0.4,-3.1l4.2,0.5l2.4,-1.5l4.4,-0.1l0.9,-1.1l0.8,0.1l1.2,2.1z",
    fill: "#cbd6f4",
    id: "SI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1088.2,87l-7,1.6l-3.5,3.9l1.3,3.5l-6.2,4.5l-7.8,5l-2.1,8.1l3.7,4.1l4.8,3.3l-3.3,6.6l-4.6,1.4l-0.6,10l-2.1,5.7l-5.7,-0.6l-2.2,4.8l-5.5,0.3l-1.9,-5.7l-4.5,-6.9l-4.2,-8.4l1.8,-3.4l3.4,-4l0.8,-6.9l-3.1,-2.9l-1,-7.7l2.4,-5.4l4.3,0.1l1.3,-2.2l-1.8,-2l5.7,-7.9l3.4,-6.1l2.3,-3.9l4,0l0.6,-3.1l8,0.9l-0.1,-3.6l2.6,-0.2l6,2.7l7.2,3.7l1.8,8.5l1.8,2.2z",
    fill: "#cbd6f4",
    id: "SE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1161.7,667.7l0.6,2.9l0.3,2.9l-1.4,2.8l-3.2,0.7l-3.1,-3.5l0.1,-2.2l1.7,-2.4l0.6,-1.9l1.7,-0.4l2.7,1.1z",
    fill: "#cbd6f4",
    id: "SZ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1195,287.5l-9.7,6.9l-6.3,-2.6l-0.1,0l0.6,-1l-0.4,-2.6l0.9,-3.5l2.7,-2.5l-1.2,-2.5l-2.5,-0.3l-1.1,-4.9l1,-2.7l1.3,-1.4l1.2,-1.4l-0.2,-3.5l1.9,1.2l5.6,-1.8l3,1.2l4.4,0l5.7,-2.4l2.9,0.1l5.9,-1l-2.1,4l-2.7,1.6l1.2,4.7l-1,7.7l-11,6.7z",
    fill: "#cbd6f4",
    id: "SY"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1119.2,376.1l1.1,25.5l-4.8,-0.5l-2.5,4.8l-1.3,3.9l1.2,1.5l-1.8,2l0.7,2.7l-1.4,2.6l-0.5,2.4l1.9,-0.4l1.3,2.5l0.1,3.7l2.1,1.9l0,1.6l-3.6,1.1l-2.8,2.6l-4,7l-5.2,3l-5.5,-0.4l-1.6,0.6l0.6,2.2l-2.9,2.3l-2.4,2.5l-7.1,2.4l-1.4,-1.4l-1,-0.2l-1,1.7l-4.6,0.5l0.8,-1.8l-1.8,-4.4l-0.8,-2.6l-2.5,-1.1l-3.4,-3.8l1.2,-3l2.6,0.6l1.6,-0.4l3.2,0l-3.2,-5.8l0.2,-4.3l-0.5,-4.2l-2.3,-4.1l0.6,-3.1l-3.7,-0.1l0,-4.1l-2.4,-2.4l2.3,-8.5l7,-6l0.2,-8.4l1.8,-13l1.2,-2.8l-2.4,-2.2l-0.1,-2l-2.2,-1.7l-1.6,-10l5.5,-3.5l22.5,12.3l22.6,12.3z",
    fill: "#cbd6f4",
    id: "TD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m991.4,431.2l-0.7,3.4l1.7,1.9l2,2.2l0.2,3.2l1.2,1.3l-0.3,14.8l1.4,4.4l-4.5,1.4l-1.3,-2.3l-1.5,-4.1l-0.5,-3.2l1.3,-5.7l-1.4,-2.4l-0.6,-5l0,-4.7l-2.3,-3.3l0.4,-2l4.9,0.1z",
    fill: "#cbd6f4",
    id: "TG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1577.5,410.2l-5.3,-0.9l-7.1,1.2l-3.1,5.3l2.1,7.8l-5.3,-3l-4.8,0.2l0.3,-5.1l-4.9,0l0.2,7.1l-2.2,9.4l-1.4,5.7l0.7,4.6l3.7,0.2l2.7,5.9l1.3,5.5l3.4,3.7l3.4,0.7l3.1,3.4l-1.7,2.6l-3.7,0.8l-0.6,-3.3l-4.8,-2.8l-0.9,1.1l-2.3,-2.4l-1.2,-3.2l-3.2,-3.6l-2.9,-3.1l-0.7,3.8l-1.3,-3.6l0.4,-4l1.2,-6.1l2.2,-6.6l2.6,-6l-2.7,-5.9l-0.2,-3l-1,-3.6l-4.3,-5.1l-1.8,-3.2l1.8,-1.2l1.4,-5.5l-2.9,-4.3l-4.1,-4.7l-3.5,-5.6l2.2,-1.2l1.5,-6.9l3.9,-0.3l2.8,-2.8l3,-1.5l2.7,2l0.9,3.9l3.8,0.3l-0.4,6.7l1,5.8l5.3,-3.8l1.9,1.1l3.2,-0.2l0.8,-2.2l4.3,0.4l5,5.2l1.3,6.4l5.3,5.6l0.4,5.4l-1.5,2.9z",
    fill: "#cbd6f4",
    id: "TH"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1357,243.6l-1.4,1.9l-6,-1l0.6,3.6l5.5,-0.5l7.1,2.1l9.6,-1l3.1,6l1.5,-0.7l3.7,1.5l0.5,2.5l1.8,3.6l-5.4,0l-3.8,-0.5l-2.5,2.9l-2.2,0.6l-1.5,1.4l-2.7,-2.1l-0.9,-5.4l-1.7,-0.3l0.1,-2l-3.3,-1.4l-1.7,2.2l0.2,2.6l-0.6,0.9l-3.2,-0.1l-0.9,2.9l-2.1,-1.2l-3.4,2l-1.8,-0.7l1.3,-6.5l-2.4,-4.8l-4.2,-1.5l0.6,-2.8l4.4,0.3l1.5,-3.5l0.5,-4.1l6.5,-1.5l-0.2,3l1.3,1.7l2.1,-0.1z",
    fill: "#cbd6f4",
    id: "TJ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1338.3,262l-1.6,-0.2l-2.9,-1.7l-0.3,2.2l-4.2,1.3l0.2,5.1l-2.6,2l-4,0.9l-0.4,2.9l-3.9,0.9l-5.9,-2.5l-1.7,-5.3l-4,-0.3l-7.3,-5.6l-4.3,-0.7l-6.6,-3.3l-3.9,-0.6l-2,1.2l-3.6,-0.2l-3,3.7l-4.4,1.2l-1.9,-4.5l-0.6,-6.7l-4.6,-2.2l0.4,-4.3l-3.5,-0.4l-0.1,-5.4l5.3,1.6l4.1,-2l-4.7,-3.9l-2.4,-3.6l-3.8,1.6l0.6,4.7l-2.6,-4.1l1.8,-2.2l5.6,-1.3l3.9,1.8l4.8,5l2.6,-0.3l5.9,-0.1l-1.7,-3.2l3.8,-2.2l3.4,-3.7l7.9,3.4l1.9,5l2.3,1.3l5.5,-0.3l2.1,1.2l4.3,6.6l7.1,4.4l4.2,3l6.3,3.1l7.7,2.8l0.8,3.9z",
    fill: "#cbd6f4",
    id: "TM"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1692.7,562.1l0.1,-1.9l-0.5,-1.3l0.8,-1.5l4.9,-1.4l4,-0.3l1.8,-0.8l2.1,0.8l-2.2,1.8l-6.1,2.8l-4.9,1.8z",
    fill: "#cbd6f4",
    id: "TL"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1048.2,289.1l-0.1,4.9l-2.6,1.8l-1.6,2.1l-3.6,2.5l0.6,2.6l-0.4,2.8l-2.6,1.4l-2.6,-11.5l-3.4,-2.6l-0.1,-1.5l-4.5,-3.9l-0.6,-4.8l3.2,-3.6l1.1,-5.3l-1,-6.1l1,-3.3l5.7,-2.5l3.7,0.7l0,3.3l4.4,-2.4l0.4,1.2l-2.5,3.2l0.1,2.9l1.9,1.6l-0.5,5.6l-3.5,3.2l1.2,3.5l2.8,0.1l1.4,3.1l2.1,1z",
    fill: "#cbd6f4",
    id: "TN"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Turkey",
    d: "m1201.7,235.3l5.5,-0.3l5.6,3.2l1.3,2.2l0.1,3.1l4.2,1.6l2.4,1.8l-3.3,1.9l2.9,7.3l-0.7,2l3.8,5.1l-2.4,1.1l-2.1,-1.6l-6.3,-0.9l-2.1,1l-5.9,1l-2.9,-0.1l-5.7,2.4l-4.4,0l-3,-1.2l-5.6,1.8l-1.9,-1.2l0.2,3.5l-1.2,1.4l-1.3,1.4l-2.3,-2.9l1.7,-2.4l-3.2,0.6l-4.6,-1.5l-3.2,3.7l-8,0.7l-4.7,-3.4l-5.7,-0.2l-1,2.6l-3.6,0.8l-5.4,-3.4l-5.8,0.1l-3.8,-6.4l-4.2,-3.5l2,-5l-3.6,-3.1l5.1,-6.1l8,-0.2l1.6,-4.9l10,0.9l5.6,-4.1l5.8,-1.8l8.5,-0.2l9.8,4.5l7.9,2.5l5.8,-1l4.6,0.6l5.5,-3.4z",
    fill: "#cbd6f4",
    id: "svg_85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Turkey",
    d: "m1121.9,239.9l1.2,-0.7l1.1,-4l-2.7,-1.7l5,-2l4.6,0.8l0.9,2.5l4.8,2l-0.7,1.6l-6.2,0.3l-2,2l-3.9,3.4l-2,-2.9l-0.1,-1.3z",
    fill: "#cbd6f4",
    id: "svg_86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1657.9,355.5l-1.4,5.3l-4,-5.5l-1.5,-4.7l1.9,-6.3l3.3,-4.9l3,1.9l-0.1,3.9l-1.2,10.3z",
    fill: "#cbd6f4",
    id: "TW"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1167,508.4l-0.2,3.9l-1.1,4.5l1.6,2.5l2.5,-1.5l3.3,-0.4l0.7,0.8l3.3,-1.6l-2.3,-2.2l1.9,-2.9l2.8,-2.9l20.5,13.1l0.3,3.7l8.1,6.4l-2.8,8l0.3,3.6l3.5,2.3l0.2,1.7l-1.7,3.9l0.3,1.9l-0.4,3.1l1.8,4l2.2,6.4l2,1.4l-4.6,3.7l-6.2,2.5l-3.4,-0.1l-2.1,1.9l-3.9,0.2l-1.5,0.8l-6.7,-1.8l-2.2,0.2l0.1,-0.1l-1.8,-2.4l-0.3,-6.8l-2.9,-3.4l-0.4,1.2l-1,-1.7l-5.5,-1.2l-3.2,-1.9l-3.6,-1.1l-2.2,-1.1l-0.3,-0.2l-2.7,-6.6l-0.4,-3.9l-4.5,-4.4l1.4,-2.4l-1.1,-2.6l0.2,-2.7l-1,-0.9l0.3,-2.8l0.6,-0.1l2,-2.3l2.3,-3.4l1.4,-1.3l0,-2.1l-1.2,-1.5l-0.3,-2.5l1.6,-0.8l0.3,-3.8l-2.2,-3.6l2,-0.8l6.2,0.1z",
    fill: "#cbd6f4",
    id: "TZ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1179,474.5l2.7,4.5l0.7,3.2l2.6,7.4l-2.1,4.7l-2.8,4.2l-1.6,2.6l0,0.3l-0.2,-0.4l-3,-1.3l-2.4,1.6l-3.6,0.9l-2.6,3.7l0.3,2.5l-6.2,-0.1l-2,0.8l-3.4,2l-1.4,-0.7l0.1,-4.8l1.3,-2.5l0.3,-5.1l1.2,-3l2.2,-3.3l2.1,-1.8l1.9,-2.2l-2.3,-0.9l0.3,-7.5l2.3,-1.8l3.6,1.5l4.5,-1.5l4,0l3.5,-3z",
    fill: "#cbd6f4",
    id: "UG"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1157.2,174.6l2.3,2.7l0.1,1.2l6.7,2.2l3.6,-1l3.6,2.9l2.9,-0.1l7.7,2l0.4,1.9l-1.3,3.2l1.8,3.5l-0.3,2.1l-4.8,0.4l-2.2,1.8l0.4,2.7l-3.9,0.5l-3,2.1l-4.6,0.3l-4,2.4l1,3.9l2.8,1.5l5.1,-0.4l-0.6,2.3l-5.4,1.1l-6.3,3.6l-3.1,-1.3l0.7,-2.9l-5.9,-1.9l0.7,-1.2l4.6,-2.1l-1.7,-1.4l-8.1,-1.6l-0.8,-2.4l-4.5,0.8l-1.3,3.5l-3.3,4.6l-2.4,-1.1l-2.3,1.1l-2.4,-1.2l1.2,-0.7l0.6,-2.1l1.1,-2.1l-0.6,-1.1l1,-0.5l0.6,0.9l3,0.2l1.3,-0.5l-1,-0.6l0.2,-1l-2,-1.6l-1.1,-2.6l-2,-1l0.1,-2.1l-2.6,-1.7l-2,-0.3l-4,-1.9l-3.2,0.6l-1.1,0.9l-2.1,0l-1,1.5l-3.6,0.6l-1.6,1l-2.5,-1.6l-3.2,0l-3.2,-0.7l-2,1.4l-0.5,-1.7l-3,-1.7l0.7,-2.5l1.2,-1.7l1.1,0.4l-1.6,-2.8l3.8,-5.2l2.3,-0.7l0.3,-1.7l-3.2,-5.4l2.3,-0.3l2.4,-1.6l3.8,-0.2l4.9,0.5l5.7,1.5l3.9,0.1l1.9,0.9l1.7,-1.1l1.5,1.5l4.3,-0.3l2.1,0.6l-0.3,-3.1l1.3,-1.4l4.1,-0.3l1.8,0.2l1,-1.4l1.5,0.3l4.9,-0.6l3.8,3.5l-0.9,1.3l0.8,1.9l3.9,0.3z",
    fill: "#cbd6f4",
    id: "UA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m699.7,718.6l-1.6,4.1l-5.4,3.5l-4.2,-1.3l-2.8,0.7l-5.5,-2.7l-3.6,0.2l-3.9,-3.6l-0.4,-4.1l0.9,-1.4l-1.2,-6.4l0.4,-6.6l0.5,-5.2l3.4,-0.7l6.3,5l1.9,-0.2l6.3,4.1l4.8,3.6l3.8,4.3l-1.8,3.1l2.1,3.6z",
    fill: "#cbd6f4",
    id: "UY"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1352.7,230.7l1.7,0.6l-3,4.1l4.6,2.4l3.2,-1.6l7.2,3.4l-5.3,4.6l-4.1,-0.6l-2.1,0.1l-1.3,-1.7l0.2,-3l-6.5,1.5l-0.5,4.1l-1.5,3.5l-4.4,-0.3l-0.6,2.8l4.2,1.5l2.4,4.8l-1.3,6.5l-4.3,-1.4l-3,0l-0.8,-3.9l-7.7,-2.8l-6.3,-3.1l-4.2,-3l-7.1,-4.4l-4.3,-6.6l-2.1,-1.2l-5.5,0.3l-2.3,-1.3l-1.9,-5l-7.9,-3.4l-3.4,3.7l-3.8,2.2l1.7,3.2l-5.9,0.1l-6.2,-23.4l12,-3.7l1.1,0.5l9.2,4.5l4.8,2.4l6.6,5.7l5.7,-0.9l8.6,-0.5l7.6,4.6l1.5,6.4l2.6,0.1l2.5,5.2l6.7,0.2l2.3,3l2,0l0.9,-4.6l5.4,-4.4l2.6,-1.2z",
    fill: "#cbd6f4",
    id: "UZ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m648.7,448.1l-4.7,3.8l-0.5,2.3l1.8,2.4l-1.4,1.2l-3.5,1l0,3l-1.6,1.8l3.7,4.8l0.7,1.8l-2.1,2.5l-6.4,2.4l-4.1,1l-1.7,1.5l-4.5,-1.6l-4.1,-0.8l-1.1,0.6l2.5,1.6l-0.3,4.3l0.7,4.1l4.8,0.5l0.3,1.4l-4.1,1.8l-0.7,2.7l-2.4,1.1l-4.2,1.5l-1.1,2l-4.4,0.4l-3.1,-3.4l-1.6,-6.4l-1.5,-2.3l-2,-1.4l2.9,-3.2l-0.2,-1.4l-1.5,-1.9l-1.1,-4.3l0.6,-4.6l1.3,-2.2l1.2,-3.4l-2,-1.1l-3.2,0.7l-4.1,-0.3l-2.3,0.7l-3.8,-5.6l-3.3,-0.8l-7.3,0.6l-1.2,-2.2l-1.4,-0.5l-0.1,-1.4l0.7,-2.4l-0.3,-2.5l-1.2,-1.5l-0.6,-2.9l-2.9,-0.4l1.8,-3.8l0.9,-4.6l1.8,-2.4l2.3,-1.8l1.6,-3.2l3.7,-1.1l-0.2,1.5l-3.4,0.8l1.7,2.9l-0.3,3.4l-2.7,3.7l1.9,5.1l2.5,-0.4l1.5,-4.7l-1.7,-2.2l0,-4.9l7.2,-2.6l-0.6,-3l2.1,-2.1l1.7,4.6l4,0.1l3.4,3.5l0.2,2.2l5,0l6.1,-0.6l3.1,2.8l4.2,0.8l3.3,-2l0.1,-1.6l7.1,-0.4l6.7,-0.1l-4.9,1.9l1.8,3.1l4.5,0.4l4.2,3.2l0.7,5.1l2.9,-0.1l2.2,1.5z",
    fill: "#cbd6f4",
    id: "VE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1586.5,363.5l-6.5,5.4l-3.7,6.1l-0.6,4.5l5.3,6.7l6.5,8.4l5.7,4l4.1,5.1l4,11.9l0.4,11.3l-4.3,4.2l-6.1,4.2l-4.2,5.3l-6.6,6l-2.3,-4.1l1.2,-4.4l-4.4,-3.6l4.6,-2.6l5.9,-0.5l-2.8,-3.8l9,-5l-0.1,-7.7l-1.8,-4.3l0.2,-6.4l-2,-4.5l-4.9,-4.5l-4.4,-5.6l-5.7,-7.6l-7.3,-3.9l1.2,-2.3l3.3,-1.7l-3,-5.6l-6.8,0l-3.5,-5.8l-4,-5.1l2.7,-1.6l4.4,0.1l5.3,-0.8l4.1,-3.4l3.1,2.4l5.3,1.2l-0.3,3.7l3.1,2.6l5.9,1.7z",
    fill: "#cbd6f4",
    id: "VN"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1283.8,394.9l-4,1.7l-0.9,2.9l0,2.2l-5.4,2.7l-8.8,3l-4.7,4.5l-2.5,0.4l-1.7,-0.4l-3.2,2.7l-3.5,1.2l-4.7,0.3l-1.4,0.4l-1.1,1.7l-1.5,0.5l-0.8,1.6l-2.8,-0.2l-1.7,0.9l-4,-0.3l-1.6,-3.8l0,-3.5l-1,-1.9l-1.3,-4.7l-1.8,-2.6l1.1,-0.4l-0.7,-2.9l0.6,-1.2l-0.4,-2.8l2.4,-2.1l-0.8,-2.7l1.3,-3.1l2.4,1.6l1.5,-0.6l6.4,-0.1l1.1,0.6l5.5,0.7l2.1,-0.3l1.5,2.1l2.6,-1.1l3.5,-6.7l5,-2.9l15.9,-2.5l5.2,10.6l2.2,4.5z",
    fill: "#cbd6f4",
    id: "YE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1162.1,556.8l0.3,0.2l2.2,1.1l3.6,1.1l3.2,1.9l2.6,2.9l1.3,5.4l-1,1.7l-1.3,5.2l0.9,5.4l-1.8,2.2l-2,6l2.9,1.6l-17.2,5.3l0.4,4.6l-4.3,0.9l-3.3,2.5l-0.8,2.2l-2,0.6l-5.1,5.2l-3.2,4.2l-1.9,0.1l-1.8,-0.7l-6.2,-0.7l-1,-0.5l0,-0.5l-2.2,-1.5l-3.6,-0.3l-4.6,1.4l-3.6,-4l-3.6,-5.2l0.8,-20.5l11.7,0.1l-0.4,-2.2l0.9,-2.4l-0.9,-3l0.7,-3.1l-0.6,-2l1.9,0.1l0.3,2l2.7,-0.1l3.5,0.6l1.9,2.9l4.4,0.9l3.5,-2l1.2,3.3l4.3,0.9l2,2.8l2.2,3.5l4.3,0l-0.2,-6.9l-1.6,1.2l-3.9,-2.5l-1.5,-1.2l0.9,-6.4l1.1,-7.6l-1.2,-2.8l1.7,-4.1l1.5,-0.8l7.7,-1.1l0.9,0.3l-0.3,1.4l1.9,0.5l1.2,1.3l1,-0.3l-0.5,-1.1z",
    fill: "#cbd6f4",
    id: "ZM"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1159.4,644.7l-2.9,-0.7l-1.9,0.8l-2.7,-1.1l-2.2,0l-3.4,-2.9l-4.3,-1l-1.5,-4.1l0.1,-2.3l-2.3,-0.7l-6.1,-7l-1.6,-3.7l-1.1,-1.2l-1.9,-5.1l6.2,0.7l1.8,0.7l1.9,-0.1l3.2,-4.2l5.1,-5.2l2,-0.6l0.8,-2.2l3.3,-2.5l4.3,-0.9l0.2,2.4l4.7,-0.1l2.6,1.3l1.1,1.6l2.7,0.5l2.8,2l-0.4,8.2l-1.3,4.4l-0.4,4.8l0.8,1.9l-0.9,3.8l-0.8,0.6l-1.7,4.6l-6.2,7.3z",
    fill: "#cbd6f4",
    id: "ZW"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1222.1,512.6l-3.3,-5.3l-0.2,-23.4l4.9,-7.2l1.5,-2.1l3.6,-0.1l5,-4.5l7.3,-0.3l15.6,-19.3l-4.8,0.1l-18.7,-7.6l-2.2,-2.3l-2.2,-3.1l-2.2,-3.6l1.2,-2.2l1.9,-3.5l1.9,1.2l1.2,2.7l2.7,2.7l2.8,0l5.2,-1.7l6.1,-0.7l4.9,-2l2.8,-0.4l2,-1.2l3.2,-0.2l1.8,-0.2l2.5,-0.9l3,-0.7l2.5,-2.2l2.2,0l0.2,1.8l-0.4,3.7l0.2,3.4l-1.1,2.3l-1.4,7l-2.4,7.1l-3.3,8.2l-4.6,9.4l-4.7,7.2l-6.6,8.8l-5.6,5.2l-8.4,6.4l-5.3,4.8l-6.2,7.8l-1.3,3.4l-1.3,1.5z",
    fill: "#cbd6f4",
    id: "SO"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1097.8,230.8l-1.2,0.3l-2.9,1l-0.1,1.3l-0.7,-0.1l-0.6,-2.3l-1.3,-0.7l-1.2,-1.7l0.8,-1.4l1.2,-0.4l0.5,-2.1l0.9,-0.4l0.8,0.9l1,0.4l0.8,1l0.9,0.3l1.1,1.2l0.7,-0.1l-0.4,1.6l-0.6,0.7l0.3,0.5z",
    fill: "#cbd6f4",
    id: "XK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1159.4,644.7l2.2,9l1.1,4.6l-1.4,7.1l0.4,2.3l-2.7,-1.1l-1.7,0.4l-0.6,1.9l-1.7,2.4l-0.1,2.2l3.1,3.5l3.2,-0.7l1.4,-2.8l4.1,0l-1.7,4.7l-1,5.3l-1.7,2.9l-4,3.3l-1.1,0.9l-2.6,3.3l-1.8,3.3l-3.5,4.6l-6.7,6.6l-4.1,3.8l-4.3,3l-5.9,2.4l-2.7,0.4l-0.9,1.8l-3.2,-1l-2.7,1.2l-5.7,-1.2l-3.3,0.8l-2.2,-0.4l-5.8,2.6l-4.6,1l-3.5,2.4l-2.4,0.2l-2.1,-2.3l-1.8,-0.1l-2.2,-2.9l-0.3,0.9l-0.6,-1.7l0.3,-3.8l-1.5,-4.3l1.8,-1.2l0.1,-4.9l-3.3,-6l-2.4,-5.4l0,-0.1l-3.6,-8.3l2.8,-3.2l2,1.8l0.8,2.7l2.5,0.5l3.4,1.2l2.9,-0.5l5,-3.3l1.1,-23.7l1.4,1l3,6.1l-0.6,3.9l1.1,2.3l4,-0.7l2.8,-2.9l2.7,-1.9l1.5,-3.1l2.8,-1.4l2.3,0.7l2.5,1.8l4.5,0.3l3.6,-1.4l0.6,-2l1.2,-3.1l3,-0.5l1.8,-2.4l2,-4.3l5.2,-4.8l8.1,-4.7l2.2,0l2.7,1.1l1.9,-0.8l2.9,0.7zm-20.3,53.2l1.1,-2l3.1,-1l1.1,-2.1l1.9,-3.1l-1.7,-2l-2.2,-2l-2.7,1.4l-3.1,2.5l-3.2,4l3.7,5l2,-0.7z",
    fill: "#cbd6f4",
    id: "ZA"
  }), /*#__PURE__*/React.createElement("path", {
    className: "New Zealand",
    d: "m1886.2,764.4l-0.8,2.6l5.6,-2.6l-0.5,2.7l-2.1,2.7l-4.2,2.9l-7.1,4.7l-4.7,2.6l-0.6,3l-4,0.1l-6.3,2.4l-4.7,4.1l-8.2,6.4l-6.3,2.8l-4,1.8l-4.6,-0.1l-1.5,-2.1l-5.1,-0.4l1,-2.4l6.5,-4.6l11.4,-6.3l4.3,-1.2l5.6,-2.4l7,-3.3l5.7,-3.3l6,-4.7l3.1,-1.6l3.5,-3.6l5.8,-2.9l-0.8,2.7z",
    fill: "#cbd6f4",
    id: "svg_87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "New Zealand",
    d: "m1915.2,733.9l-0.4,6.8l2.9,-4.4l1.3,1.8l-2.4,4.8l2.9,2.1l3.2,0.5l4.7,-2.4l2.2,0.7l-5.2,5.7l-4.2,3.7l-3.9,-0.1l-2.8,1.9l-1.5,2.8l-1.6,1.1l-4.6,3.5l-5.9,4.3l-6,2.6l0.5,-1.7l-1.5,-0.9l6.9,-5.2l0.9,-3.6l-3.8,-2.5l1.8,-2.3l5.3,-2.2l4.2,-5l2.5,-4.1l0.6,-4.3l0.8,-1.1l-0.9,-2.7l-0.7,-5.6l0.4,-4.6l2.2,-0.5l0.9,3.6l3.2,1.6l-2,5.7z",
    fill: "#cbd6f4",
    id: "svg_88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Chile",
    d: "m655.1,837.9l6,13.6l5,0l3,0.2l-0.5,2.4l-3.2,1.9l-2.4,-0.2l-3.1,-0.5l-4.2,-1.8l-5.4,-0.9l-7.5,-3.4l-6.4,-3.2l-9.8,-6.9l4.6,1.3l8.6,4.1l7.3,2.2l1.2,-2.8l-0.3,-4.2l3.4,-2.6l3.7,0.8z",
    fill: "#cbd6f4",
    id: "svg_89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Chile",
    d: "m614.4,647.8l0.9,1.6l-1.2,6.7l-5.6,3.1l1.6,10.7l-0.8,2.1l2,2.5l-3.3,4l-2.6,6l-0.9,5.9l1.7,6.2l-2.1,6.6l4.9,11.1l1.6,1.2l1.4,5.9l-1.6,6.2l1.4,5.4l-3,4.2l1.6,5.8l3.3,6.3l-2.5,2.3l0.2,5.7l0.8,6.5l3.3,7.8l-1.7,1.3l3.7,7.3l3.1,2.4l-0.8,2.7l2.8,1.2l1.4,2.4l-1.8,1.2l1.8,3.7l1.1,8.3l-0.7,5.4l1.8,3.2l-0.1,3.9l-2.7,2.8l3.1,6.5l2.6,2.3l3.1,-0.4l1.9,4.6l3.5,3.6l12.1,0.8l4.9,1l-4.3,0l-1.7,1.5l-3.4,2.2l1.7,5.7l-1.9,0.1l-6.3,-1.9l-7.5,-4.3l-7.6,-3.5l-3.2,-3.9l-0.3,-3.6l-4.2,-4.2l-5,-10.6l-0.2,-6l3.4,-4.8l-8.3,-1.9l2.7,-5.5l-2,-10.5l6.5,2.2l-1.8,-13.1l-4,-1.7l1,7.9l-3.5,-0.9l-1.5,-9l-2,-11.8l1.1,-4.4l-3.3,-6.2l-2.4,-7.2l2.2,-0.3l0.6,-10.3l1.2,-10.3l0.1,-9.5l-3.3,-9.7l0.6,-5.3l-2.1,-7.9l1.8,-7.8l-0.9,-12.4l0,-13.4l0.1,-14.3l-1.5,-10.5l-2.1,-9.1l2.8,-1.6l1.1,-3.3l3.2,4.4l1.2,4.6l3.2,2.7l-1.1,6.2l3.7,7.2l3.1,8.9l3.9,-0.9z",
    fill: "#cbd6f4",
    id: "svg_90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1016.5,177.1l-2.8,-1.5l-3.1,-2.7l-4.5,1.3l-3.6,-0.5l2.5,-1.7l4,-9l6.5,-2.6l4,0.2l0.9,2.1l-0.9,5.6l-1.2,2.3l-2.9,0l1.1,6.5z",
    fill: "#cbd6f4",
    id: "NL"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m946.9,263.7l-2.2,1.6l-2.8,-0.9l-2.7,0.7l0.9,-5l-0.3,-3.9l-2.4,-0.6l-1.1,-2.4l0.5,-4.2l2.2,-2.3l0.5,-2.6l1.2,-3.8l0,-2.7l-0.9,-2.3l-0.2,-2.2l1.9,-1.6l2.2,-0.9l1.2,3.1l3,0l0.9,-0.8l3.1,0.2l1.3,3.2l-2.4,1.7l-0.3,5l-0.8,0.9l-0.3,3.1l-2.3,0.5l2,3.8l-1.6,4.2l1.8,1.9l-0.8,1.7l-2,2.4l0.4,2.2z",
    fill: "#cbd6f4",
    id: "PT"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Russian Federation",
    d: "m1689.5,177.4l13.7,11l-8.9,-2l3.7,9l9.6,6.4l3,4.4l-6.5,-3.8l0.1,4.9l-4.7,-5.3l-3.8,-6.1l-5.6,-6.7l-2.4,-4.8l-6.4,-8.2l-8,-6.1l-6.8,-8.4l1.9,-2.8l-4.4,-2.8l1.3,-0.9l4.9,4l6.9,5.9l5.2,6.1l7.2,6.2z",
    fill: "#cbd6f4",
    id: "svg_91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Russian Federation",
    d: "m1094.6,155.4l-8.8,0.1l-5.9,-0.7l0.7,-2.6l6.3,-2l5.1,1.1l2.2,0.9l-0.2,1.7l0.6,1.5z",
    fill: "#cbd6f4",
    id: "svg_92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Russian Federation",
    d: "m1548.4,48.2l-5.9,0.1l-8.9,-0.6l-1,-0.3l0.7,-2l4.2,-0.5l8.4,2l2.5,1.3z",
    fill: "#cbd6f4",
    id: "svg_93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Russian Federation",
    d: "m1561,38.7l-1.1,2l-6.9,-0.4l-10.3,-2l-1.8,-1.6l8.3,0.7l11.8,1.3z",
    fill: "#cbd6f4",
    id: "svg_94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Russian Federation",
    d: "m1535.5,36.3l3.1,3.8l-14.3,-0.2l-4.6,1.2l-12.5,-3.3l-3.4,-3.4l3.5,-0.9l10.2,0.2l18,2.6z",
    fill: "#cbd6f4",
    id: "svg_95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Russian Federation",
    d: "m1218.8,61.3l-2.2,0.4l-13.5,-0.7l-2.3,-2.3l-7.9,-1.4l-2,-2.9l3.5,-1.1l-1.6,-2.8l5.4,-4.4l-4,-0.6l6.7,-4.5l-2.5,-2.3l6.8,-2.6l10.3,-3.2l11.7,-0.9l5,-1.8l6.7,-0.6l4.2,1.9l-1.3,1.5l-11.4,2.5l-9.9,2.3l-8.7,4.8l-2.8,5l-3.3,5l3.1,4.3l10,4.4z",
    fill: "#cbd6f4",
    id: "svg_96"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Russian Federation",
    d: "m1661.7,231l-1.4,-1.1l-1.9,-3.3l2.5,-0.1l-3.9,-7.5l-4.7,-5.4l2.9,-2.2l6.9,1.1l-0.6,-6.2l-2.8,-6.8l0.3,-2.3l-1.3,-5.7l-6.9,1.9l-2.6,2.4l-7.6,0l-6,-5.8l-9,-4.5l-10,-2l-6.2,-6l-4.5,-3.8l-3.8,-2.7l-7.7,-6.2l-6,-2.2l-8.6,-1.9l-6.2,0.2l-5.1,1.1l-1.7,3.1l3.7,1.4l2.5,3.4l-1.3,2l0.2,6.5l1.9,2.8l-4.4,3.9l-7.4,-2.4l-5.6,0.6l-3.9,-2.1l-3.4,-0.7l-4.4,4.4l-5.9,1l-3.6,1.6l-6.8,-1l-4.6,0l-4.9,-3.2l-6.6,-2.9l-5.4,-0.9l-5.7,0.8l-4,1.2l-8.5,-2.6l-3.6,-4.6l-6.7,-1.6l-4.8,-0.8l-7,-2.5l-1.3,6.4l4,3.6l-2.4,4.4l-8,-1.6l-5,-0.2l-4.8,-2.9l-5.2,-0.1l-5.3,-1.9l-5.9,2.9l-6.7,5.3l-4.7,1.1l-1.7,0.5l-4.4,-3.8l-6,0.9l-3.3,-2.7l-4,-1.2l-4.1,-3.6l-3.3,-1.1l-6.2,1.6l-8.4,-3.5l-1.1,3.2l-18.3,-15.6l-8.4,-4.7l0.8,-2l-9.2,5.8l-4.4,0.3l-1.1,-3.3l-7.1,-2.1l-4.3,1.5l-4.4,-6.3l-9.1,-1.3l-3.1,2.5l-10.9,2.3l-1.7,1.5l-17,2.1l-1.4,2.1l5.1,4.2l-4,1.6l1.5,1.6l-3.5,3l9.4,4.3l-0.2,2.9l-7,-0.3l-0.8,1.9l-7.3,-3.2l-7.7,0.1l-4.4,2.6l-6.6,-2.5l-12,-4.3l-7.6,0.2l-8.1,6.7l0.6,4.5l-6,-3.6l-2.2,6.9l1.8,1.2l-1.7,4.8l5.3,4.2l3.6,-0.2l4.3,4.2l0.2,3.2l2.8,1.1l-1.4,3.7l-4.6,1l-3.6,6.5l6,6.1l0.4,4.2l7.3,7.5l-2.5,2.6l-0.6,1.6l-2.4,-0.5l-4.3,-3.8l-1.5,-0.2l-3.6,-1.5l-2.1,-2.6l-5.1,-1.3l-2.9,1l-1.2,-1.2l-7.6,-3.1l-7.7,-1l-4.6,-1.1l-0.4,0.8l-7.6,-5.4l-6.2,-2.4l-5.1,-3.7l3.6,-1l3.2,-5.2l-3.3,-2.5l6.9,-2.6l-0.4,-1.4l-4.3,1l-0.4,-2.7l2.2,-1.8l4.8,-0.4l0.3,-2.1l-1.8,-3.5l1.3,-3.2l-0.4,-1.9l-7.7,-2l-2.9,0.1l-3.6,-2.9l-3.6,1l-6.7,-2.2l-0.1,-1.2l-2.3,-2.7l-3.9,-0.3l-0.8,-1.9l0.9,-1.3l-3.8,-3.5l-4.9,0.6l-1.5,-0.3l-1,1.4l-1.8,-0.2l-2,-4l-1.5,-2l0.8,-0.6l3.9,0.2l1.6,-1.3l-1.7,-1.6l-3.4,-1.1l0,-1.1l-2.1,-1.1l-3.8,-4l0.7,-1.6l-1.1,-2.9l-4.8,-1.4l-2.4,0.7l-0.9,-1.5l-5.3,-1.5l-2.1,-3.6l-1,-2.9l-2.5,-1.3l1.6,-1.9l-2.4,-5.6l2.6,-3.4l-0.9,-1l4.5,-3.3l-5.4,-2.8l8,-7.4l3.4,-3.4l0.9,-2.9l-7.4,-3.9l0.9,-3.8l-4.9,-4.2l1.7,-4.8l-6.5,-6.3l2.9,-4.2l-7.3,-3.7l-0.4,-3.8l3.2,-0.5l6.4,-2.1l3.7,-1.9l7.7,3.2l11.7,1.3l17.7,6.2l4.1,2.6l1.5,3.7l-3.7,2.9l-6.5,1.5l-20.2,-4.2l-2.9,0.7l8.1,4.1l1,2.6l1.9,5.8l6.1,1.7l3.8,1.5l-0.2,-2.8l-3.4,-2.4l2.1,-2.2l11.6,3.6l3.2,-1.4l-4.3,-4.2l8.1,-5.4l4.1,0.3l4.6,1.9l1.1,-3.8l-4.7,-3.3l0.8,-3.3l-4.3,-3.4l12.3,1.8l3.6,3l-5.1,0.7l1.2,3.1l4.1,1.9l6,-1.2l-0.4,-3.5l7.7,-2.7l12.4,-4.6l3.2,0.2l-2.5,3.3l5.4,0.6l2.1,-1.9l7.7,-0.1l5,-2.3l6.4,3.3l2.8,-3.6l-6,-3.1l1.2,-1.8l13,1.6l6.6,1.7l18.6,6.2l1.1,-2.8l-5.9,-2.9l-0.8,-1.1l-5.3,-0.6l-0.2,-2.5l-4.7,-4.2l-1.1,-1.7l4.3,-4.7l-0.6,-4.8l2.2,-1l11.4,1.4l2.9,2.9l-0.9,4.2l3.7,1.7l3.8,3.7l3.8,7.4l6.7,3.3l0.5,3.7l-3.5,7.8l5.3,0.8l0.5,-2l3.8,-1.4l-0.5,-2.7l1.9,-2.7l-4.4,-3.1l-0.4,-3.6l-4.8,-0.4l-2.9,-3l-0.4,-5.4l-8.2,-4.3l4.7,-3.5l-3.7,-3.7l1.9,-0.1l4.2,2.8l2.1,5.1l5,1l-4.6,-3.8l5.1,-2.1l8.1,-0.3l9.6,3l-6.9,-4.3l-4.9,-5.5l5.9,-1l9.5,0.2l7.8,-0.7l-5.6,-2.6l1.3,-3.3l4.2,-0.2l4.9,-2.4l9.3,-0.7l-0.2,-1.4l9.3,-0.4l4.3,1.1l5.4,-2.6l7,0.1l-1.5,-2.2l0.9,-2l6.2,-2l8.3,1.6l-3.5,1.2l9.4,0.7l4.1,2.4l1.9,-1.2l10.9,0.1l11.6,2.4l5.5,1.8l2.5,2.6l-2.4,1.5l-6.6,2.8l-1.1,1.5l5.6,0.7l7.2,1.3l2.4,-1l5.8,3.3l0.2,-1.3l5.2,-0.8l13.6,0.8l3.8,2.4l17.4,0.8l-4.8,-3.9l9.5,0.9l6.1,-0.1l9.9,2.7l6,3.3l0.4,2.2l10.1,4.2l9,2.1l-3,-5.5l9.4,2.3l5,-1.4l9.8,1.6l1,-1.4l7.6,0.7l-9.4,-4.9l2.1,-2.2l40.4,3.4l7.9,3.1l16.3,4l14.8,-1l9.3,0.9l6.6,2.2l5.1,3.9l7.3,1.5l3.9,-1.1l7,-0.1l9.3,1l6.9,-0.6l14.3,4.8l2.5,-1.7l-8.5,-3.4l-1.8,-2.4l15.3,1.5l8,-0.3l15.8,2.5l9.5,2.4l33.2,22.1l-2,2.5l-6.2,-0.4l8.2,3l9.1,4.7l4.2,1.5l3.8,2.4l1,1.5l-10,-1.2l-6.6,4.3l-3,0.7l-1.6,4.1l-2,3.6l1.7,2.7l-11.5,-4.1l-6.1,4.6l-4.7,-2.2l-1.4,2.6l-7,-0.9l3.1,3.9l1.1,5.8l2.9,2.4l6.8,1.3l9.1,8.7l-4.1,0.3l3.4,5l4.7,2.6l-5,3.1l5.4,7l-5.7,1.5l4.5,6.2l-1.7,5.8l-5.7,-4.3l-10.5,-8.9l-16.2,-13.6l-6.5,-8.3l0.1,-3.6l-2.8,-2.8l5.7,-1.3l-0.2,-7.5l0.7,-6l2.5,-4.7l-6.6,-8.2l-4.7,0.5l3.2,4.8l-3.6,6.4l-12.3,-7.2l-9.1,2l0,9.8l7.7,3.6l-8.5,1.6l-6.4,0.6l-4.3,-4.3l-8,-0.9l-2.5,2.9l-15.1,-1l-13.2,1.7l-3.5,11.7l-5,14.2l8.2,0.8l5.7,3.8l5.8,1.3l0.4,-3l5.6,0.4l12.8,6.7l4.7,5.2l1.4,6.2l5.5,7.4l5.3,9.9l-1,9.1l1.3,4.3l-2,7.4l-2.1,7.3l-0.9,3.7l-4.6,3.7l-3.1,0.1l-5.2,-3.1l-4.1,4.7l0.5,2.1z",
    fill: "#cbd6f4",
    id: "svg_97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Russian Federation",
    d: "m1367.1,23.1l-18.1,1.8l-1.3,-6.1l2.2,-0.5l3.1,0.3l12.6,2.6l1.5,1.9z",
    fill: "#cbd6f4",
    id: "svg_98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Russian Federation",
    d: "m1164.8,13.1l-4.3,0.5l-2.9,0.4l0,0.7l-3.6,0.7l-4.5,-1l1.1,-1.4l-7.8,-0.1l6.3,-0.8l5.2,0l1.5,1.1l1.3,-1l2.8,-0.7l5.8,0.9l-0.9,0.7z",
    fill: "#cbd6f4",
    id: "svg_99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Russian Federation",
    d: "m1345.1,20.4l-7.1,0.6l-11.7,-1.3l-8.1,-1.7l-6.6,-3.2l-5.9,-0.8l5.4,-2.9l6.2,-0.9l9.6,2l13.7,4.2l4.5,4z",
    fill: "#cbd6f4",
    id: "svg_100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m976.6,223.4l2,2.4l9.5,2.9l1.9,-1.4l5.8,2.9l5.9,-0.8l0.4,3.7l-4.9,4.2l-6.6,1.4l-0.5,2.1l-3.2,3.5l-2,5.2l2,3.7l-3,2.8l-1.2,4.2l-4,1.3l-3.7,4.9l-6.8,0.1l-5,-0.1l-3.4,2.2l-2.1,2.4l-2.6,-0.5l-1.9,-2.2l-1.4,-3.6l-4.9,-1l-0.4,-2.2l2,-2.4l0.8,-1.7l-1.8,-1.9l1.6,-4.2l-2,-3.8l2.3,-0.5l0.3,-3.1l0.8,-0.9l0.3,-5l2.4,-1.7l-1.3,-3.2l-3.1,-0.2l-0.9,0.8l-3,0l-1.2,-3.1l-2.2,0.9l-1.9,1.6l0.5,-4.5l-2,-2.7l7.4,-4.6l6.2,1.1l6.9,0l5.4,1.1l4.3,-0.4l8.3,0.3z",
    fill: "#cbd6f4",
    id: "ES"
  }), /*#__PURE__*/React.createElement("path", {
    className: "France",
    d: "m1035.7,231.4l-1.5,4.9l-2.4,-1.3l-1.3,-4.2l0.9,-2.4l3.2,-2.4l1.1,5.4z",
    fill: "#cbd6f4",
    id: "svg_101"
  }), /*#__PURE__*/React.createElement("path", {
    className: "France",
    d: "m1014.4,185l1.1,0.5l1.4,-0.1l2.4,1.6l7.2,1.2l-2.4,4.2l-0.4,4.5l-1.3,1.1l-2.3,-0.6l0.2,1.6l-3.6,3.5l0,2.9l2.4,-1l1.8,2.7l-0.1,1.8l1.5,2.4l-1.7,1.9l1.5,4.9l2.8,0.8l-0.5,2.7l-4.5,3.6l-10.2,-1.7l-7.4,2.1l-0.6,3.8l-5.9,0.8l-5.8,-2.9l-1.9,1.4l-9.5,-2.9l-2,-2.4l2.7,-3.8l1,-12.6l-5.1,-6.6l-3.7,-3.2l-7.6,-2.4l-0.4,-4.6l6.5,-1.3l8.3,1.6l-1.5,-7.1l4.7,2.7l11.4,-4.8l1.5,-5.1l4.2,-1.3l0.8,2.2l2.2,0.1l2.4,2.5l3.5,2.9l2.5,-0.5l4.4,2.9z",
    fill: "#cbd6f4",
    id: "svg_102"
  }), /*#__PURE__*/React.createElement("path", {
    className: "United States",
    d: "m118.8,379.3l-1.1,1.1l-1.2,-0.9l0.6,-1.8l-0.4,-2.4l0.5,-0.7l1.2,-1l-0.1,-1.3l0.4,-0.6l0.4,0.1l1.9,1.1l0.9,0.6l0.7,0.8l0.9,2.3l-0.2,0.3l-2.5,1.4l-2,1z",
    fill: "#cbd6f4",
    id: "svg_103"
  }), /*#__PURE__*/React.createElement("path", {
    className: "United States",
    d: "m118.1,369.3l-2,0.4l-0.6,-1.3l-0.5,-0.5l0,-0.4l0.7,-0.6l1.8,0.6l1.2,1l-0.6,0.8z",
    fill: "#cbd6f4",
    id: "svg_104"
  }), /*#__PURE__*/React.createElement("path", {
    className: "United States",
    d: "m115.1,365.9l-0.3,0.7l-3,-0.2l0.6,-0.8l2.7,0.3z",
    fill: "#cbd6f4",
    id: "svg_105"
  }), /*#__PURE__*/React.createElement("path", {
    className: "United States",
    d: "m110.4,364.9l-0.4,0.4l-0.4,-0.1l-1.9,-0.2l-0.3,-1.5l-0.2,-0.2l1.7,-0.9l0.4,0.4l1.1,2.1z",
    fill: "#cbd6f4",
    id: "svg_106"
  }), /*#__PURE__*/React.createElement("path", {
    className: "United States",
    d: "m102,360.7l-0.8,0.6l-1.6,-1.1l0.4,-0.5l1,-0.6l1.3,0.1l-0.3,1.5z",
    fill: "#cbd6f4",
    id: "svg_107"
  }), /*#__PURE__*/React.createElement("path", {
    className: "United States",
    d: "m539.5,194.5l-6.1,2l-4.7,2.5l-4.6,2.7l-0.5,0.9l5.7,-1.3l2.1,2.1l4.6,-1.5l4.9,-2.1l5.4,-2.1l-3.1,3.3l2.5,0.8l2.5,2.4l5.1,-1.4l5.1,-0.5l0.3,1.8l1.5,0.2l1.2,0.2l1.5,2.5l-4.7,0.6l-0.1,0l-3.7,-0.7l-4.5,1.2l-3.7,0.6l-4.7,4.1l-3,2.3l0.4,0.7l5.5,-4.1l0.7,0l-4.7,4.9l-2.9,4.4l-2.5,3.6l-0.6,3.1l-0.8,1.5l-0.6,1.7l0.1,3.3l0.3,0.5l1.8,-0.1l1.6,-0.7l1.4,-0.8l3.3,-3.1l1.8,-4.2l-0.1,-3.9l1.4,-2.7l2.6,-3.1l2.1,-2.2l2.7,-1.5l-0.4,2.1l2.2,-3.1l1.3,-0.6l1.7,-2.4l3.8,1.3l2.8,2.4l-0.8,2.9l-1.6,2.9l-3.8,2.5l-0.4,1.6l1,0l4.3,-2.7l1.6,0.6l-0.5,3.7l-0.7,2.6l-3.7,3.5l-2,2.2l-2.7,2.4l2.7,1.3l2.5,0.4l4,-0.9l3.7,-1.7l3,-0.9l4.6,-1.8l5.8,-3.8l0.1,-0.6l0.3,-1.9l2.7,-0.8l3.9,0.3l4,0.5l4.6,-2.1l0.6,-2.5l-0.2,-0.9l6.8,-4.4l2.7,-1.1l7.8,-0.1l9.3,0l1.1,-1.5l1.7,-0.3l2.5,-1l2.8,-2.9l3.2,-4.9l5.5,-4.7l1.1,1.6l3.7,-1l1.6,1.8l-2.9,8.5l2.2,3.6l0.2,2.1l-6.4,3l-6,2.2l-6,1.9l-4,3.8l-1.3,1.4l-1.2,3.4l0.7,3.3l2.1,0.2l0.2,-2.3l1.1,1.4l-1,1.8l-3.8,1l-2.5,-0.1l-4.2,1.1l-2.3,0.3l-3.1,0.3l-5,1.9l8.1,-1.2l1.1,1.2l-7.9,1.9l-3.3,0l0.4,-0.8l-2.1,1.8l1.4,0.3l-2.5,4.6l-5.3,4.9l0.1,-1.7l-1.1,-0.3l-1.2,-1.6l0,3.5l1,1.1l-0.6,2.4l-2.4,2.5l-4.5,5.1l-0.4,-0.2l2.9,-4.4l-2,-2.4l1,-5.4l-1.9,2.8l0,4.1l-3.2,-1l3,2l-1.5,6.1l1.4,0.5l0,2.2l-1,6.4l-4.6,4.7l-6.1,1.9l-4.4,3.8l-2.8,0.4l-3.4,2.4l-1.3,2.1l-6.9,4.2l-3.8,3.1l-3.5,3.8l-1.9,4.5l0,4.5l0.6,5.5l1.5,4.5l-0.5,2.8l1.3,7.4l-1,4.4l-0.6,2.5l-2,3.9l-1.8,0.8l-2.6,-0.8l-0.4,-2.8l-1.8,-1.5l-2,-5.5l-1.6,-4.9l-0.4,-2.5l2,-4.3l-0.8,-3.5l-3.1,-5.4l-1.9,-1l-6.1,3l-0.9,-0.4l-2,-3l-3,-1.6l-6.4,0.9l-4.6,-0.8l-4.3,0.5l-2.5,1l0.6,1.7l-0.7,2.6l0.8,1.3l-1.2,0.8l-1.8,-0.9l-2.3,1.2l-3.9,-0.2l-3.3,-3.4l-4.9,0.8l-3.6,-1.5l-3.5,0.5l-5,1.5l-6.1,4.7l-6.1,2.8l-3.7,3l-1.9,2.9l-1,4.5l-0.4,3l0.6,2.2l-2.2,0.2l-3.6,-1.4l-3.9,-2l-0.9,-3l-0.2,-4.5l-2.4,-3.6l-0.9,-3.8l-1.6,-4.4l-3.2,-2.6l-4.5,0.2l-4.8,5l-4,-1.9l-2.3,-1.9l-0.4,-3.6l-0.8,-3.3l-2.4,-2.8l-2.1,-2.1l-1.3,-2.3l-9.4,0l-0.8,2.7l-4.3,0l-10.8,0l-10.9,-4.5l-7,-3.1l0.9,-1.3l-7.1,0.7l-6.3,0.5l0.3,-3.2l-2.1,-3.7l-2.2,-0.8l0.1,-1.8l-2.9,-0.4l-1.2,-1.7l-4.8,-0.6l-0.9,-1.1l0.8,-3.5l-2.5,-6.4l-0.5,-8.9l0.9,-1.5l-1.3,-2.1l-1.5,-5.4l1.8,-5.2l-0.9,-3.5l3.9,-5.3l2.8,-5.4l1.1,-4.9l5.5,-6l4,-5.7l4,-5.7l4.3,-8.5l1.8,-5.3l0.4,-2.9l1.4,-1.3l5.8,2.2l-1,5.9l2.2,-1.7l2.5,-5.1l1.6,-5.1l14.1,0l14.7,0l4.8,0l15.1,0l14.7,0l14.8,0l14.9,0l16.8,0l17,0l10.2,0l1.3,-2.4l1.7,0l-0.9,3.4l1,1l3.3,0.4l4.6,1l3.9,1.9l4.4,-0.8l5.4,1.7z",
    fill: "#cbd6f4",
    id: "svg_108"
  }), /*#__PURE__*/React.createElement("path", {
    className: "United States",
    d: "m275,138.6l-7,2.3l-0.8,-1.6l2.3,-2.8l6.4,-2.1l3.5,-0.9l2.6,0.4l0,1.9l-7,2.8z",
    fill: "#cbd6f4",
    id: "svg_109"
  }), /*#__PURE__*/React.createElement("path", {
    className: "United States",
    d: "m236,122l-3.9,0.9l-1.7,-1.1l-0.8,-1.6l5.7,-1l3,0.6l-2.3,2.2z",
    fill: "#cbd6f4",
    id: "svg_110"
  }), /*#__PURE__*/React.createElement("path", {
    className: "United States",
    d: "m237.2,99.6l1.2,1l3.5,-0.5l1.6,1.5l3.3,0.7l-1.2,0.7l-4.9,1.2l-1.7,-1.3l-0.3,-1l-4.3,0.3l-0.3,-0.5l3.1,-2.1z",
    fill: "#cbd6f4",
    id: "svg_111"
  }), /*#__PURE__*/React.createElement("path", {
    className: "United States",
    d: "m410,66.6l-24.6,20.4l-35.6,32.7l4.2,0.2l2.8,1.6l0.5,2.6l0.3,3.8l7.6,-3.3l6.5,-1.9l-0.6,3.1l0.8,2.4l1.6,2.7l-1.1,4.2l-1.4,6.9l4.6,3.8l-3.2,3.8l-5.1,2.9l-0.6,-2.2l-2.5,-2l3.3,-5.2l-1.6,-4.9l2.7,-5.6l-4.1,-0.4l-7.1,-0.1l-3.8,-1.8l-3.3,-6.1l-3.3,-1.1l-5.7,-2.1l-6.8,0.5l-6,-2.7l-2.7,-2.5l-6.3,1.2l-3.5,4.1l-2.9,0.4l-6.6,1.2l-6.2,2l-6.4,1.3l3.2,-3.5l8.4,-5.8l6.8,-1.8l0.4,-1.4l-9.4,3.2l-7.4,3.9l-11.2,4.2l0.2,2.9l-9,4.2l-7.7,2.5l-6.6,1.9l-4,2.6l-10.6,3.1l-4.5,2.8l-8.2,2.6l-2.7,-0.4l-6.2,1.6l-7,2.1l-6.1,2l-10,1.8l0.4,-1.1l8.2,-2.8l6.6,-1.9l8.6,-3.3l6.5,-0.6l5,-2.5l10.4,-3.6l2.3,-1.2l5.7,-2.1l5.8,-4.5l6.2,-3.5l-7.3,1.8l-0.3,-1.1l-4.9,2.2l0.4,-3l-3.6,2.1l1.6,-2.9l-7.3,2.3l-2.8,0l3.7,-3.5l3.3,-2.2l-0.4,-2.1l-7.2,1.2l-0.6,-2.8l-1.3,-1.4l4,-3.3l-0.4,-2.5l5.9,-3.3l7.7,-3.3l5.3,-2.9l4.1,-0.4l1.8,0.9l7.1,-2.8l2.5,0.5l5.6,-1.8l2.5,-2.6l-1.1,-1l6,-2.2l-2.8,0.1l-6.2,1.2l-2.9,1.3l-1.8,-1.3l-6.9,0.7l-4.6,-1.4l1.2,-2.3l-1,-3.2l9.2,-2.4l13.2,-2.7l3.5,0l-4.3,2.8l9.2,-0.2l1.2,-3.5l-2.3,-2.1l0.8,-2.8l-0.7,-2.3l-3.3,-1.7l6.5,-2.9l7.5,-0.2l8.8,-2.4l4.8,-2.6l7.9,-2.6l4.8,-0.6l11.2,-2.4l3.1,0.4l10.4,-2.8l4.4,1.1l-0.5,2.4l3.3,-1l6.3,0.3l-1.9,1.2l4.9,0.9l4.9,-0.5l6.2,1.6l7.2,0.6l2.2,0.6l6.6,-0.8l4.1,1.6l3.5,0.7z",
    fill: "#cbd6f4",
    id: "svg_112"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m677.3,487l1.5,-2.8l0.5,-2.9l1,-2.7l-2.1,-3.8l-0.3,-4.4l3.1,-5.5l1.9,0.7l4.1,1.5l5.9,5.4l0.8,2.6l-3.4,5.9l-1.8,4.7l-2.2,2.5l-2.7,0.4l-0.8,-1.8l-1.3,-0.2l-1.7,1.7l-2.5,-1.3z",
    fill: "#cbd6f4",
    id: "GF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m592.9,422l-0.5,-0.2l-0.5,-0.5l0.1,-0.6l0.2,0.3l0.4,0.4l0.3,0.5l0,0.1z",
    fill: "#cbd6f4",
    id: "AW"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m634.2,384.9l-0.2,0l0.3,-0.4l0.3,0l-0.2,0.3l-0.2,0.1z",
    fill: "#cbd6f4",
    id: "AI"
  }), /*#__PURE__*/React.createElement("path", {
    className: "American Samoa",
    d: "m27.7,593.3l-0.3,0.4l-0.2,0.3l-0.2,0.1l-0.4,-0.3l0.2,-0.2l0.3,0l0.1,-0.2l0.5,-0.1z",
    fill: "#cbd6f4",
    id: "svg_113"
  }), /*#__PURE__*/React.createElement("path", {
    className: "American Samoa",
    d: "m34.3,593.3l-0.5,0.1l-0.1,-0.2l0.4,-0.1l0.2,0.2z",
    fill: "#cbd6f4",
    id: "svg_114"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Antigua and Barbuda",
    d: "m640.7,391.9l0.6,0.3l-0.2,0.3l-0.2,0l-0.7,0.1l-0.2,-0.1l0,-0.5l0.3,-0.1l0.1,-0.3l0.2,0l0.1,0.3z",
    fill: "#cbd6f4",
    id: "svg_115"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Antigua and Barbuda",
    d: "m640.7,388.2l0.2,0l0.2,0.2l0.1,0.4l-0.1,0.3l-0.2,0.1l-0.1,-0.2l-0.3,-0.2l0,-0.5l0.2,-0.1z",
    fill: "#cbd6f4",
    id: "svg_116"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1264.1,333.3l0.3,0.1l0.2,-0.1l0.4,0.7l-0.1,0.2l0.1,0.9l0,0.7l-0.2,0.4l-0.1,-0.4l-0.6,-0.8l0.1,-0.4l-0.2,-0.7l0,-0.4l0.1,-0.2z",
    fill: "#cbd6f4",
    id: "BH"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Bahamas",
    d: "m580.4,366l-0.4,0.5l-0.2,0.5l-0.6,0.3l-0.5,0l-0.1,-0.1l-0.4,0.2l-0.5,0.1l-0.6,-0.2l-0.4,0.1l-0.1,-0.5l0.3,-0.2l0.2,-0.3l0.4,-0.2l0.3,-0.4l0.4,0l0.3,-0.2l0.2,0.3l0.5,0.2l0.5,-0.2l0.7,-1l0.3,0l0,0.2l-0.3,0.9z",
    fill: "#cbd6f4",
    id: "svg_117"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Bahamas",
    d: "m580.6,364.3l-0.2,-0.6l0.6,-0.3l0.3,0.3l0,0.2l-0.3,0.1l-0.4,0.3z",
    fill: "#cbd6f4",
    id: "svg_118"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Bahamas",
    d: "m581,357.8l0.2,-0.1l0.5,0.3l0.4,0l0.4,0.1l0.3,0.2l0,0.3l-0.2,0.1l-0.5,-0.4l-0.4,0l-0.1,-0.1l-0.5,0.2l-0.5,-0.2l0,-0.1l0.2,-0.5l0.2,0.2z",
    fill: "#cbd6f4",
    id: "svg_119"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Bahamas",
    d: "m577.1,356l-0.2,0.4l0,0.7l-0.1,0.4l-0.4,0.3l-0.2,0.4l-0.4,0.3l-0.7,0.3l-0.1,0.2l-0.2,-0.2l0.1,-0.2l0.4,-0.1l0.2,-0.2l0,-0.2l0.4,-0.1l0.2,-0.4l0.4,-0.1l0.3,-0.4l-0.2,-0.3l-0.4,0l-0.2,-0.2l0.4,-0.5l0.1,-0.1l0.6,0z",
    fill: "#cbd6f4",
    id: "svg_120"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Bahamas",
    d: "m575.2,355.7l0.1,0.1l0.4,0l0.4,0.2l-0.4,0.4l-0.1,-0.2l-0.2,0l-0.4,-0.1l-0.4,-0.2l-0.3,-0.6l0.3,-0.1l0.4,0.1l0.2,0.4z",
    fill: "#cbd6f4",
    id: "svg_121"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Bahamas",
    d: "m566,349.8l0.6,0.7l0.3,0.2l0.3,0.5l-0.3,-0.1l-0.1,-0.2l-0.3,-0.1l-0.4,-0.4l-0.2,-0.1l-0.2,-0.4l0.3,-0.1z",
    fill: "#cbd6f4",
    id: "svg_122"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Bahamas",
    d: "m569.7,349.8l0.3,0.6l0.2,0.5l0,0.4l0.2,0.2l0.2,0.7l0,0.9l0.2,0.3l0.5,0.2l0.4,0.6l0,0.8l-0.4,-0.7l0,-0.2l-0.3,-0.4l-0.6,-0.2l0.2,-0.2l-0.3,-0.3l0,-0.3l0.2,-0.3l-0.1,-0.5l-0.3,-0.4l0.1,-0.1l-0.3,-0.4l-0.1,-0.6l-0.2,0.1l0.1,-0.7z",
    fill: "#cbd6f4",
    id: "svg_123"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Bahamas",
    d: "m572.6,349.8l-0.3,0.2l-0.3,-0.1l-0.1,-0.2l0.6,-0.2l0.1,0.3z",
    fill: "#cbd6f4",
    id: "svg_124"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Bahamas",
    d: "m564.4,347.9l-0.1,-0.1l-0.3,-0.7l0.2,0l0.2,0.8z",
    fill: "#cbd6f4",
    id: "svg_125"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Bahamas",
    d: "m574.9,347.4l-0.4,0.6l-0.4,0l0.2,-0.3l0.1,-0.6l0.4,-0.3l0.1,0.4l0,0.2z",
    fill: "#cbd6f4",
    id: "svg_126"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Bahamas",
    d: "m556.4,346.2l-0.3,0.1l-0.2,0.3l-0.3,-0.1l0.6,-0.4l0.2,0.1z",
    fill: "#cbd6f4",
    id: "svg_127"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Bahamas",
    d: "m556.6,346.9l0.4,0.2l0.2,-0.2l0.1,-0.5l0.2,-0.1l0.2,0.6l0,0.5l-0.1,0.3l0.1,0.6l0,0.3l-0.4,0.8l-0.2,0.1l-0.4,-0.2l0.2,-0.3l0.4,-0.2l-0.1,-0.1l-0.6,0.4l-0.2,-0.2l0.4,-0.3l-0.4,0l-0.2,0.1l-0.2,-0.2l0,-0.7l0.1,-0.2l-0.4,-0.5l0,-0.2l0.4,-0.2l0.1,-0.3l0.3,-0.1l0.1,-0.2l0.6,-0.3l0.1,0.4l-0.5,0.4l-0.2,0.3z",
    fill: "#cbd6f4",
    id: "svg_128"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Bahamas",
    d: "m570.1,346.3l0.1,0.5l-0.2,-0.1l-0.5,0.1l-0.4,0.1l-0.1,-0.2l0.3,-0.2l0.4,-0.3l0,-0.2l-0.4,-0.2l-0.2,-0.6l-0.1,-0.6l-0.4,-0.4l0,-0.2l-0.5,-0.5l0.3,-0.3l0.4,0.4l0,0.5l0.2,0.3l0.1,0.5l0.3,0.5l0.4,0.3l0.1,0.3l0.2,0.3z",
    fill: "#cbd6f4",
    id: "svg_129"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Bahamas",
    d: "m559.8,340.8l0.3,0.2l-0.6,0.3l-0.3,-0.1l-0.2,0.2l-0.5,-0.1l0.2,-0.3l0.4,-0.2l0.7,0z",
    fill: "#cbd6f4",
    id: "svg_130"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Bahamas",
    d: "m555.6,340.3l0.4,-0.2l0.3,0.3l-0.1,0.2l0.1,0.2l-0.2,0.4l0.3,0.3l0.2,0.9l0.2,0.3l0.4,0.5l-0.2,0.7l0.1,0.6l-0.2,0.3l-0.3,0.1l-0.4,0.4l-0.3,0.2l-0.3,0l-0.3,0.2l-0.3,0l0,-0.4l-0.3,-0.2l0.1,-0.6l-0.3,0.3l-0.2,-0.1l-0.6,-0.4l-0.3,-0.3l-0.2,-0.3l0.7,-0.3l0.5,0.7l0.1,-0.6l-0.3,-0.1l-0.1,-0.3l0.1,-0.3l0.6,-0.6l0.2,-0.4l-0.1,-0.1l0.3,-0.4l0,-0.5l-0.2,-0.7l0.1,-0.1l0.3,0l0.2,0.3z",
    fill: "#cbd6f4",
    id: "svg_131"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Bahamas",
    d: "m563.7,337.7l0.1,0.2l0.3,0.4l0.8,0.7l0.5,0.1l0.1,0.1l0.2,0.4l0.3,0.4l0.5,0.4l0,0.2l-0.2,0.8l-0.1,0.2l0,0.3l-0.1,0.5l-0.2,0.3l-0.1,0.7l-0.1,0.1l-0.2,-0.6l-0.4,-0.3l0.1,-0.2l0.5,0.1l0.2,-0.2l-0.1,-0.2l0.1,-0.4l0.3,-0.4l0.1,-0.5l0,-0.3l-0.5,-0.4l-0.4,-0.7l-0.3,-0.2l-0.6,-0.3l-0.3,-0.3l-0.6,-0.2l-0.4,0.2l0.4,-0.9l0.1,0z",
    fill: "#cbd6f4",
    id: "svg_132"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Bahamas",
    d: "m554.9,330.2l0.5,0.2l0.1,0l0.7,0.1l0.2,-0.2l0.2,0.1l0.5,0l0.4,-0.2l0.4,0l0.3,-0.2l0.1,0.5l-0.1,0.2l-0.3,0l-0.4,0l-1.1,0.2l-0.3,0l-1.5,0.4l-0.7,0.4l-0.4,0l-0.2,-0.1l-0.3,-0.3l-0.5,-0.6l0.6,0.3l0.1,0.2l0.5,0l0.5,-0.2l0.4,-0.6l-0.3,-0.1l0.2,-0.3l0.1,-0.3l0.3,0.5z",
    fill: "#cbd6f4",
    id: "svg_133"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Bahamas",
    d: "m559.2,328.9l0.8,0.2l0.2,-0.1l0.4,0.3l0.9,1l0.2,0.6l0.4,0.1l0.7,0.5l0,0.2l-0.2,0.5l0.2,0.7l-0.4,0l-0.5,0.4l-0.1,0.2l-0.3,1l-0.1,0.9l-0.2,0.2l-0.3,-0.2l-0.1,-0.4l-0.4,-0.1l0.3,-0.5l0.2,0l0.5,-0.4l-0.1,-0.4l0.2,-0.4l0,-0.3l0.2,-0.3l0,-0.6l0.2,-0.1l0.2,-0.3l0.1,-0.3l-0.3,-0.1l-0.5,-0.1l-0.1,-0.3l0,-0.2l-0.4,-0.2l0,-0.3l-0.3,-0.7l-0.2,-0.1l-0.3,0.1l-0.5,-0.1l-0.3,0l-0.6,-0.4l0.5,0z",
    fill: "#cbd6f4",
    id: "svg_134"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m635.2,387l-0.1,-0.3l0.3,0.1l-0.2,0.2z",
    fill: "#cbd6f4",
    id: "BL"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m637.3,294l-0.3,0l-0.1,0.1l0.1,0.2l-0.4,0.2l-0.1,-0.1l0.2,-0.1l0.1,0l0.1,-0.3l0.3,-0.1l0.1,0.1z",
    fill: "#cbd6f4",
    id: "BM"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m651.5,418l-0.6,-0.2l-0.1,-0.5l0,-0.8l0.2,-0.4l0.2,0.2l0.2,0.6l0.5,0.3l0.1,0.4l-0.5,0.4z",
    fill: "#cbd6f4",
    id: "BB"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Comoros",
    d: "m1233.2,581.3l-0.9,-0.1l-0.2,-0.4l0,-0.3l0.5,0.1l0.7,0.5l-0.1,0.2z",
    fill: "#cbd6f4",
    id: "svg_135"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Comoros",
    d: "m1236.9,579.4l0.2,1l0,0.7l-0.1,0.2l-0.2,-0.3l-0.4,-0.3l-0.1,-0.2l-0.3,-0.1l-0.6,-0.4l0.1,-0.1l0.5,0.2l0.3,-0.1l0.2,-0.4l0,-0.2l0.3,-0.1l0.1,0.1z",
    fill: "#cbd6f4",
    id: "svg_136"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Comoros",
    d: "m1231.2,578.4l-0.5,-0.4l-0.3,-0.1l-0.3,-0.2l-0.2,-0.6l0.1,-0.3l0,-0.2l0.2,-1.2l-0.1,-0.1l0.2,-0.4l0.5,-0.1l0.2,0.3l-0.2,1.2l0.1,0.3l0.2,0.4l0.1,0.5l0.2,0.6l-0.2,0.3z",
    fill: "#cbd6f4",
    id: "svg_137"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Cape Verde",
    d: "m847.8,406.5l-0.2,0.3l-0.2,-0.2l0,-0.3l0.3,-0.1l0.1,0.3z",
    fill: "#cbd6f4",
    id: "svg_138"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Cape Verde",
    d: "m849.7,406.6l-0.2,0.1l-0.4,-0.1l-0.3,-0.3l-0.1,-0.3l0.2,-0.4l0.5,-0.3l0.4,0l0.2,0.7l-0.1,0.4l-0.2,0.2z",
    fill: "#cbd6f4",
    id: "svg_139"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Cape Verde",
    d: "m853.2,403.5l0.2,0.1l0,0.2l0.2,0.2l0.4,0.5l0.2,0l0.2,0.3l0.2,0.5l0.2,0.2l-0.3,0.5l-0.3,0.1l-0.5,-0.1l-0.3,-0.1l-0.3,-0.3l0,-0.2l-0.2,-0.1l-0.1,-0.4l0.1,-0.2l0,-0.3l0.2,-0.4l-0.2,-0.5l0.3,0z",
    fill: "#cbd6f4",
    id: "svg_140"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Cape Verde",
    d: "m856.3,403.5l0.3,0.1l0.1,0.6l-0.1,0.4l-0.4,0.2l-0.4,-0.4l0.2,-0.4l-0.1,-0.2l0.4,-0.3z",
    fill: "#cbd6f4",
    id: "svg_141"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Cape Verde",
    d: "m858.3,397.8l0.3,-0.2l0.5,0.2l0.1,0.2l0,0.7l-0.4,0.3l-0.3,0.2l-0.3,0l-0.5,-0.2l0,-0.5l0.2,-0.2l0,-0.6l0.1,-0.1l0.3,0.2z",
    fill: "#cbd6f4",
    id: "svg_142"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Cape Verde",
    d: "m850.3,395l0.4,-0.1l0.3,0.2l0.4,0l0.3,0.2l0.1,0.2l-0.5,0l-0.7,-0.3l-0.2,0.1l-0.3,0.6l-0.3,-0.6l-0.1,-0.1l-0.1,-0.4l0.3,-0.1l0.4,0.3z",
    fill: "#cbd6f4",
    id: "svg_143"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Cape Verde",
    d: "m858.1,394.5l0.1,0.1l-0.1,0.6l-0.2,0.1l0,-0.5l-0.2,-0.3l0,-0.3l-0.1,-0.3l0.4,-0.3l0.2,0.2l-0.1,0.6l0,0.1z",
    fill: "#cbd6f4",
    id: "svg_144"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Cape Verde",
    d: "m846.8,393.2l0.2,0.3l0.1,0.3l-0.7,0.3l-0.3,-0.2l-0.2,-0.2l0.4,-0.4l0.5,-0.1z",
    fill: "#cbd6f4",
    id: "svg_145"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Cape Verde",
    d: "m846,391.4l0.3,0.1l0,0.2l0.3,0.3l-0.2,0.4l-0.6,0.3l-0.4,0.4l-0.7,0.1l0,-0.1l0,-0.5l-0.2,-0.2l0,-0.2l0.2,-0.2l0.2,0l0.2,-0.2l0.7,-0.4l0.2,0z",
    fill: "#cbd6f4",
    id: "svg_146"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m599,424.5l-0.3,0l-0.4,-0.3l-0.3,-0.1l-0.3,-0.3l-0.1,-0.2l-0.3,-0.1l-0.2,-0.4l-0.3,-0.3l0.1,-0.5l0.5,0.3l0.1,0.5l0.4,0.4l0.7,0.2l0.2,0.3l0.3,0.4l-0.1,0.1z",
    fill: "#cbd6f4",
    id: "CW"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Cayman Islands",
    d: "m532.7,377.8l0.3,0.1l0.2,-0.4l0.4,0.1l0.5,0l0.1,0.2l-0.2,0.2l-0.2,-0.1l-0.4,0.1l-0.2,0.1l-0.7,0l0.2,-0.3z",
    fill: "#cbd6f4",
    id: "svg_147"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Cayman Islands",
    d: "m540.8,375.3l-0.7,0.3l0.2,-0.3l0.5,0z",
    fill: "#cbd6f4",
    id: "svg_148"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Cayman Islands",
    d: "m541.4,375.4l-0.1,-0.1l0.8,-0.3l-0.2,0.3l-0.5,0.1z",
    fill: "#cbd6f4",
    id: "svg_149"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Cyprus",
    d: "m1168.2,276.7l0.1,0.2l0.3,0.4l-0.4,-0.1l-0.3,0l-0.4,0.2l-0.3,-0.3l0,-0.3l0.3,-0.1l0.2,0.1l0.5,-0.1z",
    fill: "#cbd6f4",
    id: "svg_150"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Cyprus",
    d: "m1166.5,277.2l0,0.1l-0.2,0.2l-0.1,0.6l-0.1,0.2l-0.3,0l-0.2,0.2l-0.5,0.2l-0.2,0.1l-0.6,0.3l-0.4,-0.1l-0.5,0.1l-0.3,0.4l-0.2,-0.3l-0.3,0.1l-0.2,0l-0.3,-0.3l-0.4,0.3l-0.5,0l-0.5,-0.2l-0.5,-0.1l-0.4,-0.3l-0.3,-0.6l-0.3,-0.3l-0.2,-0.7l-0.2,-0.3l0.1,-0.3l0.5,0.3l0.4,-0.1l0.2,-0.3l0.1,-0.3l0.3,-0.1l0.2,0.1l0.2,-0.2l0.2,0l0.1,0.4l0.5,0.2l0.1,0.2l0.6,0l0.6,-0.5l0.4,0.1l0.3,-0.2l0.3,0.1l0.4,0.2l0.2,-0.3l0.3,0l0.3,0.4l0,0.6l0.3,-0.2l0.3,0.2l0.1,-0.1l0.7,0.2z",
    fill: "#cbd6f4",
    id: "svg_151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m642,401.7l0.5,0.1l0.2,0.5l0,0.6l-0.1,0.8l-0.1,0.2l-0.2,0.1l-0.4,0.2l0.1,-0.4l-0.1,-0.2l-0.1,-0.7l-0.3,-0.5l0,-0.3l0.1,-0.3l0,-0.3l0.2,0l0.2,0.2z",
    fill: "#cbd6f4",
    id: "DM"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Falkland Islands",
    d: "m697.4,836.2l0.4,-0.1l0,0.4l-0.8,-0.3l0.3,-0.3l0.2,-0.1l-0.1,0.4z",
    fill: "#cbd6f4",
    id: "svg_152"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Falkland Islands",
    d: "m696.7,834.8l0.2,0.2l0.4,0.1l0.1,0.4l-0.3,0.1l-0.1,-0.4l-0.2,-0.2l-0.1,-0.2z",
    fill: "#cbd6f4",
    id: "svg_153"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Falkland Islands",
    d: "m702.9,834l0.2,0.1l-0.1,0.4l-0.3,-0.1l-0.2,-0.3l0.3,-0.2l0.1,0.1z",
    fill: "#cbd6f4",
    id: "svg_154"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Falkland Islands",
    d: "m690.8,833.1l0,0.2l0.1,0.3l-0.4,0.1l-0.3,-0.1l-0.2,-0.2l-0.3,-0.1l-0.1,-0.4l0.2,0l0.1,-0.2l0.3,-0.1l0.2,0.1l-0.3,0.3l0.3,0.1l0.3,-0.3l0.1,0.3z",
    fill: "#cbd6f4",
    id: "svg_155"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Falkland Islands",
    d: "m693.7,831.8l-0.4,-0.2l-0.5,-0.3l-0.8,-0.3l0.1,-0.4l-0.7,-0.1l-0.3,-0.1l-0.3,-0.4l0.2,-0.1l0.8,0.3l0.8,0.4l0.5,0.1l0.4,0.1l0.3,-0.3l0.1,-0.3l0.2,0.1l0.4,-0.2l0.1,0.2l0.5,0l0,0.3l0.3,0l0.9,-0.2l0.1,0.2l0.3,0l0.4,-0.1l-0.3,-0.2l-0.1,-0.3l0.4,0l0.6,0.2l0.1,0.4l-0.4,0.5l0.1,0.3l-0.2,0.2l-0.4,0l-0.3,0.8l-0.3,0.3l-0.3,0.6l-0.1,0.3l-0.5,0.3l-0.1,-0.2l-0.4,0l0,0.3l-0.8,-0.1l-0.1,0.1l0.3,0.4l-0.1,0.1l-0.2,0.4l-0.4,0l-0.3,0.4l-0.3,0.1l-0.2,0l-0.2,-0.3l-0.4,-0.3l0,-0.2l-0.5,0l0.6,0.4l-0.4,0l-0.5,-0.3l-0.2,-0.1l-0.4,-0.2l-0.3,-0.2l0,-0.2l0.7,0.2l0.6,-0.2l-0.5,-0.2l-0.1,-0.1l0.9,0l0.4,0.1l0.3,0.2l0,-0.2l0.4,-0.1l0.1,-0.3l-0.4,-0.2l-0.2,-0.5l0.1,-0.2l0.6,0l0.2,0.1l0.4,-0.1l-0.1,-0.3l-0.8,0l0,0.1l-0.4,0.2l-0.6,0l-0.5,-0.3l0,-0.3l0.7,0.2l0.6,-0.2l0.3,0l0.5,-0.1l0.4,0.2l0,-0.1l-0.4,-0.1z",
    fill: "#cbd6f4",
    id: "svg_156"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Falkland Islands",
    d: "m695.3,829.9l0.3,0l0.3,0.3l-0.3,0.1l-0.3,0l0,-0.4z",
    fill: "#cbd6f4",
    id: "svg_157"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Falkland Islands",
    d: "m694.3,829.9l-0.3,0l-0.1,-0.3l0.4,0.1l0,0.2z",
    fill: "#cbd6f4",
    id: "svg_158"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Falkland Islands",
    d: "m692.9,829.7l0.6,-0.1l0.2,0.3l-0.3,0.4l-0.2,-0.1l-0.3,0.1l-0.3,-0.2l0.3,-0.2l0.3,0.2l0.1,-0.2l-0.5,-0.1l0.1,-0.1z",
    fill: "#cbd6f4",
    id: "svg_159"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Falkland Islands",
    d: "m700.1,829.8l0.6,0l0.1,-0.1l0.5,-0.1l0.4,0.2l0.4,0.3l0.1,0.3l0,0.1l-0.5,0.1l-0.2,-0.3l-0.2,-0.1l-0.1,0.3l0.2,0.1l0.1,0.3l0.3,-0.2l0.2,0.1l0.1,0.4l0.3,0.1l0.1,-0.1l0.5,0.3l0.1,-0.4l-0.8,-0.2l0.1,-0.5l0.3,-0.2l1.5,-0.1l0.7,0.6l0.2,0.1l0,0.4l-0.6,-0.1l-0.5,-0.2l-0.6,0.2l0.3,0.2l0.4,0.1l0.9,0.1l0.3,0.1l0.1,0.2l-0.2,0.5l-0.5,0l-0.1,0.1l-0.7,0.1l-0.5,0.2l0.3,0.2l-0.9,0.4l-0.4,-0.1l-0.5,0.1l-0.7,0l-0.6,-0.2l-0.6,-0.4l0,0.3l0.3,0.2l0.6,0.2l0.3,0.3l0.2,-0.1l0.4,0.1l0.4,0.3l-0.2,0.1l0.2,0.5l-0.2,0l-0.3,-0.3l-0.4,-0.1l-0.5,0.4l-0.2,-0.3l-0.3,-0.2l-0.3,0l-0.5,-0.2l-0.2,0.1l0.2,0.4l0.3,0l0.2,0.2l-0.2,0.1l0.7,0.6l-0.2,0.1l-0.4,-0.2l-0.3,0l-0.3,-0.3l-0.3,-0.1l-0.3,-0.1l-0.1,0.6l0.5,0.1l0,0.3l-0.1,0.2l-0.4,-0.1l-0.1,-0.2l-0.5,-0.2l-0.1,-0.2l-0.2,0l-0.4,-0.5l0.3,-0.4l0,-0.2l-0.4,-0.5l0,-0.2l0.5,-0.2l-0.1,-0.2l0.5,-0.1l-0.1,-0.3l0.6,-0.4l0.6,-0.2l0.4,0.4l0,0.4l0.3,-0.1l-0.5,-0.6l0.1,-0.3l-0.6,-0.2l-0.4,-0.3l0.1,-0.2l0.4,0.2l0.1,-0.5l-0.7,-0.2l0.1,-0.3l0.2,0.1l0.3,-0.2l0.3,0l0.2,-0.3l-0.3,-0.3l0.4,0l0.5,0.2z",
    fill: "#cbd6f4",
    id: "svg_160"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Falkland Islands",
    d: "m695.1,829.4l0.7,0l0.2,0.2l0.2,-0.2l0.2,0.1l0.2,0.3l-0.2,0.1l-0.4,-0.1l-0.4,-0.2l-0.8,-0.1l0.1,-0.2l0.2,0.1z",
    fill: "#cbd6f4",
    id: "svg_161"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Falkland Islands",
    d: "m688.3,828.3l-0.5,-0.1l0.1,-0.2l0.4,0.3z",
    fill: "#cbd6f4",
    id: "svg_162"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Faeroe Islands",
    d: "m955.6,112l0.4,0.2l0.3,0l0.1,0.2l0,0.4l0.2,0.3l-0.1,0.2l-0.6,-0.4l-0.2,-0.4l-0.2,-0.2l-0.2,-0.3l0.3,0z",
    fill: "#cbd6f4",
    id: "svg_163"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Faeroe Islands",
    d: "m955.9,110.4l0.8,0.2l0.2,0.2l-0.1,0.4l-0.1,0.1l-0.4,-0.5l-0.5,-0.1l-0.2,-0.4l0.3,0.1z",
    fill: "#cbd6f4",
    id: "svg_164"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Faeroe Islands",
    d: "m954.62,109.04l0.08,0.16l0.3,0l0,0.3l-0.4,0l-0.2,0.2l-0.6,-0.2l-0.2,-0.1l-0.2,-0.3l0.5,-0.1l0.1,-0.1l0.56,0.09l-0.26,-0.19l0.2,-0.8l0.5,0.1l0.3,0.5l0,0.1l0.6,0.2l0.3,0.5l0.3,0.2l-0.1,0.6l-0.5,-0.4l-0.2,-0.2l-0.2,-0.1l-0.1,-0.2l-0.2,-0.2l-0.5,0l-0.08,-0.06z",
    fill: "#cbd6f4",
    id: "svg_165"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Faeroe Islands",
    d: "m958.3,108.4l-0.2,-0.2l0.3,-0.2l-0.1,0.4z",
    fill: "#cbd6f4",
    id: "svg_166"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Faeroe Islands",
    d: "m955.9,108.9l-0.4,-0.2l-0.3,-0.3l-0.1,-0.3l0.1,-0.1l0.4,-0.1l0.3,0l0.6,0.4l-0.1,0.2l0.1,0.2l0.6,0.2l0,0.2l-0.4,0.3l-0.8,-0.5z",
    fill: "#cbd6f4",
    id: "svg_167"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Faeroe Islands",
    d: "m958.1,108.3l-0.3,0.4l-0.3,-0.2l-0.3,0l0.2,-0.3l-0.1,-0.4l0.1,-0.1l0.2,0.4l0.5,0.2z",
    fill: "#cbd6f4",
    id: "svg_168"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Faeroe Islands",
    d: "m957.2,108.3l-0.2,0l-0.2,-0.4l0.1,-0.3l0.2,0.4l0.1,0.3z",
    fill: "#cbd6f4",
    id: "svg_169"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Federated States of Micronesia",
    d: "m1909.4,467.7l-0.2,0.3l-0.5,-0.1l0,-0.2l0.5,-0.4l0.2,0.4z",
    fill: "#cbd6f4",
    id: "svg_170"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Federated States of Micronesia",
    d: "m1881.2,457.1l0.4,0l0.3,0.2l0.1,0.4l-0.2,0.1l0.1,0.2l-0.1,0.2l-0.6,0l-0.2,-0.2l0,-0.2l-0.2,-0.3l0,-0.3l0.4,-0.1z",
    fill: "#cbd6f4",
    id: "svg_171"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Federated States of Micronesia",
    d: "m1766.5,440.5l0.1,0.3l-0.3,0l-0.3,0.5l-0.1,-0.1l0.3,-0.8l0.4,-0.1l-0.1,0.2z",
    fill: "#cbd6f4",
    id: "svg_172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m639.2,424.5l-0.4,0.3l-0.2,-0.1l-0.1,-0.5l0.2,-0.5l0.3,-0.4l0.3,0l0.1,0.3l-0.1,0.7l-0.1,0.2z",
    fill: "#cbd6f4",
    id: "GD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1800.8,415.5l-0.1,0.4l0,0.6l-0.1,0.3l-0.3,0l-0.2,-0.3l-0.1,-0.5l0,-0.5l0.6,-0.5l0.1,-0.2l0.1,-0.5l0.2,-0.1l0.1,0.2l0.4,0.1l-0.2,0.5l-0.5,0.5z",
    fill: "#cbd6f4",
    id: "GU"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Saint Kitts and Nevis",
    d: "m636.3,392l-0.3,0l-0.1,-0.2l0.2,-0.4l0.2,0l0.1,0.2l-0.1,0.4z",
    fill: "#cbd6f4",
    id: "svg_173"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Saint Kitts and Nevis",
    d: "m635.6,390.5l-0.1,0.3l-0.2,0l-0.4,-0.2l-0.2,-0.2l0.3,-0.4l0.5,0.4l0.1,0.1z",
    fill: "#cbd6f4",
    id: "svg_174"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m643.7,413.8l-0.2,-0.2l-0.4,-0.2l-0.1,-0.2l0,-0.6l0.1,-0.2l0.7,-1.1l0.3,0.2l0,0.7l-0.1,0.8l-0.1,0.4l-0.2,0.4z",
    fill: "#cbd6f4",
    id: "LC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m634.2,386l-0.4,-0.1l0.2,-0.3l0.3,-0.1l-0.1,0.5z",
    fill: "#cbd6f4",
    id: "MF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1402.9,474.8l0,0.2l-0.2,-0.1l0.2,-0.2l0,0.1z",
    fill: "#cbd6f4",
    id: "MV"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1953.8,456l1,0.4l-0.2,0l-0.8,-0.4z",
    fill: "#cbd6f4",
    id: "MH"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Malta",
    d: "m1063.9,271.7l-0.2,0.3l-0.5,-0.2l-0.5,-0.3l0,-0.5l-0.1,-0.1l0.6,0l0.4,0.3l0.2,0.2l0.1,0.3z",
    fill: "#cbd6f4",
    id: "svg_175"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Malta",
    d: "m1062.3,270.6l-0.5,-0.1l0,-0.2l0.4,-0.1l0.4,0.3l-0.3,0.1z",
    fill: "#cbd6f4",
    id: "svg_176"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Northern Mariana Islands",
    d: "m1802.5,411.1l-0.1,0.1l-0.2,-0.1l-0.1,-0.2l0.5,-0.2l0.2,0.2l-0.3,0.2z",
    fill: "#cbd6f4",
    id: "svg_177"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Northern Mariana Islands",
    d: "m1804,406l-0.2,0l-0.3,-0.6l0.1,-0.3l0.3,0l0,0.3l0.2,0.2l-0.1,0.4z",
    fill: "#cbd6f4",
    id: "svg_178"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Northern Mariana Islands",
    d: "m1804.5,404.4l-0.2,0.2l0.1,0.3l-0.4,0l0,-0.7l0.1,-0.2l0.4,-0.2l-0.1,0.5l0.1,0.1z",
    fill: "#cbd6f4",
    id: "svg_179"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Northern Mariana Islands",
    d: "m1802.6,396.9l-0.3,0l-0.1,-0.2l0.4,0l0,0.2z",
    fill: "#cbd6f4",
    id: "svg_180"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Northern Mariana Islands",
    d: "m1800.7,385.9l-0.1,-0.2l0,-0.5l0.3,-0.1l0.2,0.3l-0.4,0.5z",
    fill: "#cbd6f4",
    id: "svg_181"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Northern Mariana Islands",
    d: "m1799.5,381.6l-0.4,-0.1l0,-0.3l0.2,-0.1l0.2,0.2l0,0.3z",
    fill: "#cbd6f4",
    id: "svg_182"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m638.2,393.9l0.2,0.4l0,0.3l-0.2,0.2l-0.2,-0.1l-0.1,-0.3l0.3,-0.5z",
    fill: "#cbd6f4",
    id: "MS"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Mauritius",
    d: "m1307.7,630.8l0.4,0.9l-0.2,0.6l-0.4,0.4l0.1,0.3l-0.3,0.3l-0.5,0.2l-0.5,0l-0.6,-0.1l-0.1,0.1l-0.3,-0.3l0.2,-0.2l0.1,-0.4l0.1,-0.7l0.2,-0.4l0.5,-0.4l0.1,-0.2l0.2,-0.5l0.4,-0.3l0.4,0.1l0.2,0.6z",
    fill: "#cbd6f4",
    id: "svg_183"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Mauritius",
    d: "m1339.5,628.7l-0.3,-0.3l0.4,-0.2l0.3,-0.1l0.2,0.1l-0.1,0.2l-0.5,0.3z",
    fill: "#cbd6f4",
    id: "svg_184"
  }), /*#__PURE__*/React.createElement("path", {
    className: "New Caledonia",
    d: "m1915.2,646.9l-0.2,0.1l-0.2,0.4l-0.4,-0.2l0.2,-0.5l0.1,-0.2l0.3,0.1l0.2,0.3z",
    fill: "#cbd6f4",
    id: "svg_185"
  }), /*#__PURE__*/React.createElement("path", {
    className: "New Caledonia",
    d: "m1919.6,639.1l-0.1,0.1l0.2,0.4l0.3,0l0.4,-0.2l-0.1,0.6l-0.2,0.2l-0.1,0.4l-0.5,0.3l-0.4,-0.2l0,-0.1l-0.3,-0.3l0.1,-0.2l-0.2,-0.2l0.1,-0.4l-0.1,-0.4l0.1,0l0.4,0.1l0.4,-0.1z",
    fill: "#cbd6f4",
    id: "svg_186"
  }), /*#__PURE__*/React.createElement("path", {
    className: "New Caledonia",
    d: "m1916.9,634.8l-0.2,0.5l0,0.4l-0.2,0.3l0.3,0.2l0.2,0.1l0.1,0.2l-0.1,0.2l0.3,0.4l-0.2,0l-0.2,0.5l-0.2,0.2l-0.3,-0.1l-0.2,-0.3l-0.1,-0.2l-0.6,-0.1l-0.3,-0.5l0,-0.2l-0.1,-0.3l0.3,0l0.3,-0.2l0.4,-0.3l0.1,-0.3l-0.4,-0.2l-0.4,0.1l0.2,-0.4l0.3,-0.1l0.2,0.1l0.4,-0.3l0.4,0.3z",
    fill: "#cbd6f4",
    id: "svg_187"
  }), /*#__PURE__*/React.createElement("path", {
    className: "New Caledonia",
    d: "m1913.5,633.2l-0.3,0.6l-0.1,0.3l0.3,0l-0.5,0.5l-0.2,0.2l-0.1,-0.2l0.3,-0.4l0.2,-0.5l0.4,-0.5z",
    fill: "#cbd6f4",
    id: "svg_188"
  }), /*#__PURE__*/React.createElement("path", {
    className: "New Caledonia",
    d: "m1913.5,633.2l-0.2,-0.4l0.4,0l0.1,0.4l-0.3,0z",
    fill: "#cbd6f4",
    id: "svg_189"
  }), /*#__PURE__*/React.createElement("path", {
    className: "New Caledonia",
    d: "m1899.6,630.8l0.2,0.1l0.5,0.9l0.3,0.3l0.3,-0.1l0.2,-0.3l0.9,0.5l0.3,0.5l0.7,0.6l0.3,0.4l0.1,0.3l0.4,0.4l0.1,0.2l0.2,0l0.3,0.3l0.9,0.2l0.1,0.3l0,0.4l0.3,0.4l0.4,0.1l-0.3,0.5l0.1,0.2l0.4,0.5l0.1,0l0.4,0.5l-0.1,0.4l0.7,0.2l0.4,0.5l0.3,0l0.3,0.2l0.5,0.4l-0.1,0.3l0.3,0l0.4,0.5l0.6,0.4l0,0.2l0.3,0.1l0.3,0.3l0,0.2l0.3,0.6l0.4,0.4l0.1,-0.1l0.4,0.6l0.5,0.1l0.3,0.3l0,0.4l0.1,0.4l0.1,0.1l-0.2,0.6l-0.7,0.4l-0.1,-0.3l-0.3,0.1l-0.3,0.3l-0.6,-0.8l-0.4,0l-0.1,-0.2l-0.2,0l-0.2,0.3l-0.9,-0.9l-0.2,0l-0.4,-0.5l0.1,-0.8l-0.3,0l-0.4,0l-0.3,-0.2l-0.1,-0.2l-0.2,-0.1l-0.3,0l0,-0.3l-0.2,-0.5l-0.4,0.1l-0.8,-0.5l-0.1,-0.2l0,-0.3l-0.3,0.2l-0.6,-0.3l-0.1,-0.4l-0.4,-0.3l-0.2,-0.5l-0.5,-0.1l0.2,-0.2l-0.3,-0.3l-0.3,-0.1l-0.3,-0.7l0,-0.4l-0.2,-0.3l-0.3,0l-0.2,-0.6l0.1,-0.2l-0.7,-0.4l-0.3,-0.2l-0.4,-0.6l0.3,-0.2l-0.2,-0.2l-0.2,-0.3l0,-0.5l-0.5,-0.3l0,-0.6l-0.2,-0.3l0.3,0l0.1,-0.3l-0.1,-0.2l-0.6,0l-0.2,-0.3l0.5,-0.7l-0.3,-0.3l0.2,-0.1z",
    fill: "#cbd6f4",
    id: "svg_190"
  }), /*#__PURE__*/React.createElement("path", {
    className: "New Caledonia",
    d: "m1900.7,631.1l-0.3,-0.1l0.1,-0.4l0.2,0.5z",
    fill: "#cbd6f4",
    id: "svg_191"
  }), /*#__PURE__*/React.createElement("path", {
    className: "New Caledonia",
    d: "m1898.4,628.7l-0.2,0.2l-0.1,-0.4l0.2,-0.2l0.1,0.4z",
    fill: "#cbd6f4",
    id: "svg_192"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1933,505.3l-0.2,0l-0.1,-0.3l0.3,0l0,0.3z",
    fill: "#cbd6f4",
    id: "NR"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1747.7,453.1l-0.2,0.4l0.1,0.1l-0.2,0.6l0.1,0.2l-0.5,0.2l-0.2,-0.7l0.3,-0.2l-0.2,-0.2l0.3,-0.6l0.3,-0.1l0.2,0.3z",
    fill: "#cbd6f4",
    id: "PW"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Puerto Rico",
    d: "m607.1,385.9l-0.3,-0.2l0.1,-0.2l0.3,0l0.1,0.1l-0.2,0.3z",
    fill: "#cbd6f4",
    id: "svg_193"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Puerto Rico",
    d: "m621.7,385.4l-0.2,0l-0.9,0.3l-0.6,0l0.2,-0.2l0.4,-0.2l0.4,-0.1l0.6,0.1l0.1,0.1z",
    fill: "#cbd6f4",
    id: "svg_194"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Puerto Rico",
    d: "m612.2,383l0.6,0.1l0.6,0l0.3,0.1l0.6,-0.1l0.3,0.1l0.4,-0.1l0.2,0.1l0.5,-0.1l0.4,0.1l0.3,0l0.8,0.2l0,-0.2l0.6,0.2l0.1,-0.1l0.8,0.1l0.2,0.2l0.2,0l0.6,0.3l0.2,-0.1l-0.1,0.7l0.2,0.3l-0.9,0.3l-0.3,0.4l-0.3,0.6l-0.3,0.2l-0.3,0.1l-0.4,0l-0.6,0.1l-0.3,0.2l-0.7,-0.1l-0.2,-0.2l-0.5,0.2l-0.3,-0.3l-0.7,0.2l-0.9,-0.1l-0.3,0.1l-0.6,0.1l-0.2,0.1l-0.2,-0.2l-0.4,-0.1l-0.3,0.2l-0.6,-0.1l0.3,-0.7l0,-0.4l0.2,-0.4l-0.2,-0.6l-0.2,-0.1l-0.1,-0.4l0.4,-0.2l0.2,-0.1l0,-0.5l0.4,-0.2l0.5,0.1z",
    fill: "#cbd6f4",
    id: "svg_195"
  }), /*#__PURE__*/React.createElement("path", {
    className: "French Polynesia",
    d: "m195.3,679.3l-0.1,-0.1l-0.2,-0.3l0.1,-0.2l0.3,0.2l-0.1,0.4z",
    fill: "#cbd6f4",
    id: "svg_196"
  }), /*#__PURE__*/React.createElement("path", {
    className: "French Polynesia",
    d: "m205.6,641.2l-0.1,0.1l-0.3,-0.2l0.2,-0.2l0.2,0.3z",
    fill: "#cbd6f4",
    id: "svg_197"
  }), /*#__PURE__*/React.createElement("path", {
    className: "French Polynesia",
    d: "m199.4,616.5l-0.2,-0.1l0.2,-0.6l0.5,-0.4l0.3,0l0,0.2l-0.2,0.4l-0.6,0.5z",
    fill: "#cbd6f4",
    id: "svg_198"
  }), /*#__PURE__*/React.createElement("path", {
    className: "French Polynesia",
    d: "m151.7,615.5l0.7,0.2l0.3,0.4l0,0.3l-0.2,0.1l-0.5,-0.1l-0.4,-0.6l-0.1,-0.2l-0.6,0.2l-0.2,0l-0.6,-0.1l-0.2,-0.4l-0.3,-0.5l0,-0.3l0.1,-0.2l0.5,-0.1l0.5,0l0.5,0.2l0.2,0.4l0.1,0.6l0.2,0.1z",
    fill: "#cbd6f4",
    id: "svg_199"
  }), /*#__PURE__*/React.createElement("path", {
    className: "French Polynesia",
    d: "m148.7,614l-0.2,0.6l-0.5,-0.2l0.1,-0.3l0.5,-0.2l0.1,0.1z",
    fill: "#cbd6f4",
    id: "svg_200"
  }), /*#__PURE__*/React.createElement("path", {
    className: "French Polynesia",
    d: "m141.1,609.7l-0.2,0.1l-0.2,-0.3l0.3,-0.1l0.1,0.3z",
    fill: "#cbd6f4",
    id: "svg_201"
  }), /*#__PURE__*/React.createElement("path", {
    className: "French Polynesia",
    d: "m139,610.1l-0.3,0.2l-0.3,0l-0.2,-0.8l0.2,-0.2l0.7,0.8l-0.1,0z",
    fill: "#cbd6f4",
    id: "svg_202"
  }), /*#__PURE__*/React.createElement("path", {
    className: "French Polynesia",
    d: "m138,608.3l0.2,0.1l0,0.5l-0.4,-0.2l-0.1,-0.3l0.3,-0.1z",
    fill: "#cbd6f4",
    id: "svg_203"
  }), /*#__PURE__*/React.createElement("path", {
    className: "French Polynesia",
    d: "m166.3,605.4l-0.3,0.1l0.1,-0.3l0.2,0.2z",
    fill: "#cbd6f4",
    id: "svg_204"
  }), /*#__PURE__*/React.createElement("path", {
    className: "French Polynesia",
    d: "m204.3,569.5l-0.3,0l0,-0.4l-0.2,-0.3l0.4,0.1l0.1,0.4l0,0.2z",
    fill: "#cbd6f4",
    id: "svg_205"
  }), /*#__PURE__*/React.createElement("path", {
    className: "French Polynesia",
    d: "m201.2,566l-0.2,0l0,-0.4l0.2,-0.3l0.3,0.2l-0.2,0.2l-0.1,0.3z",
    fill: "#cbd6f4",
    id: "svg_206"
  }), /*#__PURE__*/React.createElement("path", {
    className: "French Polynesia",
    d: "m202.4,564.4l0,0.3l-0.4,0.1l-0.6,0l0,0.3l-0.4,-0.1l-0.2,-0.2l-0.1,-0.3l0.7,-0.4l0.3,0l0.2,0.2l0.5,0.1z",
    fill: "#cbd6f4",
    id: "svg_207"
  }), /*#__PURE__*/React.createElement("path", {
    className: "French Polynesia",
    d: "m195.5,561.8l0,0.4l0,0.2l-0.3,0l-0.3,-0.4l0.3,-0.3l0.3,0.1z",
    fill: "#cbd6f4",
    id: "svg_208"
  }), /*#__PURE__*/React.createElement("path", {
    className: "French Polynesia",
    d: "m197.9,558.8l0.3,0.1l0.1,0.1l-0.6,0.2l-0.1,-0.3l0.3,-0.1z",
    fill: "#cbd6f4",
    id: "svg_209"
  }), /*#__PURE__*/React.createElement("path", {
    className: "French Polynesia",
    d: "m194.2,558.2l0.9,0.1l0.3,0.3l0,0.2l-0.4,0.3l-0.8,0l-0.1,-0.5l-0.1,-0.4l0.2,0z",
    fill: "#cbd6f4",
    id: "svg_210"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Solomon Islands",
    d: "m1926.8,576.2l0.3,0.2l-0.1,0.4l0.3,0l0,0.2l-0.8,0l-0.3,-0.5l0.2,-0.3l0.4,0z",
    fill: "#cbd6f4",
    id: "svg_211"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Solomon Islands",
    d: "m1888.5,575.6l0.2,0l1,0.8l0.5,0.3l0.9,0.7l-0.1,0.3l-0.2,0l-0.2,0.2l-0.2,-0.3l-0.1,0l-0.2,-0.2l-0.1,-0.4l-0.4,-0.1l0,-0.3l-0.3,-0.1l-0.1,0.1l-0.2,0l-0.9,-0.4l-0.2,-0.4l0.3,-0.4l0.3,0.2z",
    fill: "#cbd6f4",
    id: "svg_212"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Solomon Islands",
    d: "m1925.4,574.1l-0.2,0.3l-0.3,-0.2l0,-0.2l0.3,-0.2l0.2,0.3z",
    fill: "#cbd6f4",
    id: "svg_213"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Solomon Islands",
    d: "m1923.1,570.2l0.1,0.1l0.3,0l-0.1,0.4l-0.5,0.2l-0.3,0l-0.4,0.1l-0.4,0.6l-0.1,-0.3l-0.3,0.1l-0.2,-0.2l0,-0.3l0.5,-0.1l0,-0.2l0.3,-0.4l0.7,0.1l0.4,-0.1z",
    fill: "#cbd6f4",
    id: "svg_214"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Solomon Islands",
    d: "m1896.8,567.4l0.3,-0.1l0.6,0.3l0.5,0.5l0.3,0.3l0.2,0l0.2,0.2l0.2,0l0.3,0.3l0.3,-0.1l0.4,0.1l0.2,0.2l0.4,0l0.3,-0.1l0.2,0.3l0.2,0.8l0.3,0.3l0,0.5l-0.2,0.2l0.1,0.3l-0.4,-0.2l-0.3,0.2l-0.3,-0.1l-0.5,-0.3l-0.2,0l-0.6,-0.2l-0.4,-0.1l-0.2,-0.3l-0.3,-0.2l-0.3,-0.1l-0.2,-0.3l-0.4,-0.2l0.2,-0.4l-0.1,-0.4l0,-0.4l-0.2,-0.1l-0.6,-0.2l-0.3,0.1l-0.1,-0.2l0.1,-0.3l0.1,-0.3l0.2,0z",
    fill: "#cbd6f4",
    id: "svg_215"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Solomon Islands",
    d: "m1900.8,564l-0.1,0.2l0,0.7l-0.2,-0.2l0,-0.5l0.3,-0.2z",
    fill: "#cbd6f4",
    id: "svg_216"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Solomon Islands",
    d: "m1897.9,562.2l0.3,0.9l0.2,0.4l0,0.4l0.1,0.5l-0.2,0.3l-0.4,-0.7l-0.1,0.3l-0.3,-0.5l0.1,-1l0.1,-0.2l0,-0.3l0.2,-0.1z",
    fill: "#cbd6f4",
    id: "svg_217"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Solomon Islands",
    d: "m1889.5,562.4l0.3,0l0.3,-0.1l0.4,0.1l0.1,-0.1l0.5,0l0.8,0l0.2,0.3l0.3,0.1l0.2,0.3l0.2,0l0.2,0.1l0.4,0.4l0,0.6l0.2,0l0.4,0.2l0.1,0.3l0,0.6l-0.1,0.1l-0.7,0.2l-0.2,0.1l-0.4,-0.1l-0.4,-0.2l-0.4,0l-0.1,-0.2l-0.5,-0.3l-0.6,0l-0.5,0.1l-0.5,0l-0.5,-0.1l-0.3,-0.2l-0.3,0.1l-0.3,-0.4l-0.3,-0.2l-0.3,-0.8l-0.2,-0.4l0.2,-0.2l-0.1,-0.2l0,-0.7l0.1,-0.3l0.6,-0.3l0.4,0.2l0.4,0.5l0.1,0.3l0.3,0.2z",
    fill: "#cbd6f4",
    id: "svg_218"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Solomon Islands",
    d: "m1891.8,560l0.5,0.5l-0.3,0.3l-0.3,-0.2l0,-0.1l0.1,-0.5z",
    fill: "#cbd6f4",
    id: "svg_219"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Solomon Islands",
    d: "m1891.8,560l-0.2,0.4l-0.1,0l-0.4,-0.3l-0.3,0.1l-0.2,-0.1l-0.1,-0.2l0.3,-0.1l0.2,-0.2l0.5,0.1l0.3,0.3z",
    fill: "#cbd6f4",
    id: "svg_220"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Solomon Islands",
    d: "m1885.2,559.5l0.1,0.2l0.2,0.1l-0.2,0.4l-0.4,0.2l-0.3,-0.4l0.6,-0.5z",
    fill: "#cbd6f4",
    id: "svg_221"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Solomon Islands",
    d: "m1876.7,557.7l0.2,0.3l-0.1,0.3l-0.8,-0.4l0.5,-0.3l0.2,0.1z",
    fill: "#cbd6f4",
    id: "svg_222"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Solomon Islands",
    d: "m1880.1,558.5l-0.3,-0.2l0.1,-0.3l0.3,-0.3l0,0.5l0.1,0.2l-0.2,0.1z",
    fill: "#cbd6f4",
    id: "svg_223"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Solomon Islands",
    d: "m1879.2,556.7l0.2,-0.1l0.4,0l0,0.2l-0.4,0.3l0.2,0.2l0,0.3l-0.4,0.4l-0.2,0.1l-0.3,-0.1l-0.4,-0.4l0.1,-0.6l0.3,-0.1l0.2,-0.4l0.3,-0.1l0,0.3z",
    fill: "#cbd6f4",
    id: "svg_224"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Solomon Islands",
    d: "m1875.6,556.8l-0.2,0.1l-0.2,0.5l0.4,0.5l-0.5,-0.2l0,-0.2l-0.1,-0.3l-0.4,-0.4l0,-0.2l0.4,-0.2l0.1,-0.3l0.4,-0.3l0.3,0.2l0,0.4l-0.2,0.4z",
    fill: "#cbd6f4",
    id: "svg_225"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Solomon Islands",
    d: "m1888.5,556.3l0.2,0.2l-0.1,0.2l-0.2,-0.1l-0.6,-0.5l0.2,-0.4l0.3,-0.1l0.2,0.2l-0.1,0.3l0.1,0.2z",
    fill: "#cbd6f4",
    id: "svg_226"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Solomon Islands",
    d: "m1895,555.5l0.4,0.8l0.6,0.8l0,0.3l-0.4,0.2l0,0.5l0,0.3l0.1,0.2l0.2,0l0.2,0.3l0.5,0.4l0.1,0.5l0.1,0.3l0.2,0.2l-0.2,0.2l0.3,0.3l-0.1,0.1l0.1,0.5l-0.2,0.2l0.3,0.3l0.1,0.5l0.2,0.5l0,0.6l-0.1,0.1l-0.3,-0.3l-0.3,-0.5l0,-0.3l-0.3,-0.4l-0.4,-0.3l-0.3,-0.3l-0.5,-0.6l-0.4,-0.3l-0.3,-0.9l-0.2,-1l-0.2,-0.7l0,-0.5l-0.1,-0.4l0.4,-0.4l-0.1,-0.3l-0.5,-0.7l-0.1,-0.3l0.1,-0.1l0.4,0.1l0.2,0.1l0.3,-0.3l0.2,0.3z",
    fill: "#cbd6f4",
    id: "svg_227"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Solomon Islands",
    d: "m1874.3,555.2l-0.2,-0.4l-0.3,-0.3l0.4,0l0.1,0.7z",
    fill: "#cbd6f4",
    id: "svg_228"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Solomon Islands",
    d: "m1874.2,554.2l0.4,0.1l0.1,0.1l0.1,0.5l-0.2,0l-0.2,-0.4l-0.2,-0.3z",
    fill: "#cbd6f4",
    id: "svg_229"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Solomon Islands",
    d: "m1877.3,554.4l-0.1,0.3l0.2,0l0.5,0l0.4,0.7l0,0.2l0.2,0.3l0.1,0.5l-0.2,0.2l0,0.3l-0.6,-0.2l-0.2,-0.2l-0.3,0l-0.4,-0.3l-0.1,-0.2l-0.1,-0.3l0.4,0.1l-0.3,-0.8l-0.1,-0.2l-0.5,0.1l-0.2,0.1l-0.4,0l-0.3,0.4l-0.4,-0.2l0,-0.6l0.2,-0.2l0.4,0l0,-0.4l0.4,-0.6l0.4,-0.3l0.3,-0.2l0.4,0.3l0.2,0.4l-0.1,0.7l0.2,0.1z",
    fill: "#cbd6f4",
    id: "svg_230"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Solomon Islands",
    d: "m1871.4,554.4l-0.1,0l-0.2,-0.8l0.1,-0.3l0,-0.4l0.2,0.1l0.1,0.4l0,0.7l-0.1,0.3z",
    fill: "#cbd6f4",
    id: "svg_231"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Solomon Islands",
    d: "m1874.8,553.9l-0.3,0.2l-0.1,-0.1l-0.4,0l-0.3,-0.3l-0.1,-0.3l-0.1,-0.3l0.1,-0.3l0.3,-0.4l0.5,-0.2l0.2,0.2l0.3,0.5l0,0.6l-0.1,0.4z",
    fill: "#cbd6f4",
    id: "svg_232"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Solomon Islands",
    d: "m1871.8,550.4l0.4,0.5l0,0.1l0.7,0.4l-0.1,0.3l-0.6,0.7l0,0.3l-0.3,0.1l0,-0.4l-0.2,0l0,-0.4l-0.2,-0.4l-0.3,-0.2l-0.1,-0.3l0.1,-0.3l0.2,-0.2l0.2,-0.2l0.2,0z",
    fill: "#cbd6f4",
    id: "svg_233"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Solomon Islands",
    d: "m1882.1,550.5l0.3,0.2l-0.2,0.1l-0.5,0.1l-0.1,-0.3l0.2,-0.2l0.3,0.1z",
    fill: "#cbd6f4",
    id: "svg_234"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Solomon Islands",
    d: "m1883,550.5l0.2,-0.1l0.5,0.3l0.3,0.1l0.2,0.2l0.3,0.5l0.3,0.1l0.3,0.3l0,0.3l0.5,0.1l0,0.3l0.3,0.1l0.3,-0.1l0.1,0.1l0.4,0.2l0.1,0.2l0.3,-0.1l0.3,0.1l0.1,0.3l0.4,0.3l0.3,0.3l0.4,0.3l1,1l-0.3,0.4l0.3,0.5l0.1,0.6l-0.3,-0.1l-0.3,-0.4l-0.7,-0.8l-0.4,-0.1l-0.5,-0.4l-0.6,-0.1l-0.1,-0.3l-0.6,-0.2l-0.5,-0.5l-0.2,0l-0.8,-0.6l-0.5,-0.3l0,-0.2l-0.4,-0.2l-0.2,-0.2l-0.2,-0.4l-0.4,-0.3l-0.1,-0.2l0,-0.4l-0.4,-0.5l-0.2,-0.1l0,-0.3l0.7,0.3z",
    fill: "#cbd6f4",
    id: "svg_235"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Solomon Islands",
    d: "m1881.5,549.9l0.2,0.2l0.2,-0.1l0.3,0.2l-0.1,0.2l-0.3,-0.1l-0.3,-0.4z",
    fill: "#cbd6f4",
    id: "svg_236"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Solomon Islands",
    d: "m1877,549.3l0.5,0l-0.2,0.2l-0.3,-0.1l0,-0.1z",
    fill: "#cbd6f4",
    id: "svg_237"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Solomon Islands",
    d: "m1881.3,549.3l-0.2,0.5l-0.1,-0.2l0.3,-0.3z",
    fill: "#cbd6f4",
    id: "svg_238"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Solomon Islands",
    d: "m1878.6,549.7l-0.5,0.1l-0.2,-0.2l0.3,-0.4l0.3,0.1l0.1,0.4z",
    fill: "#cbd6f4",
    id: "svg_239"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Solomon Islands",
    d: "m1866.1,548.8l0.2,0.3l-0.2,0.2l-0.3,-0.1l-0.1,-0.1l0.4,-0.3z",
    fill: "#cbd6f4",
    id: "svg_240"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Solomon Islands",
    d: "m1867.6,546.9l0.3,0.2l-0.1,0.3l-0.7,0.2l-0.3,-0.3l0.3,-0.6l0.2,-0.1l0.3,0.3z",
    fill: "#cbd6f4",
    id: "svg_241"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Solomon Islands",
    d: "m1869.3,546l0,0.5l-0.2,-0.2l0,-0.2l0.2,-0.1z",
    fill: "#cbd6f4",
    id: "svg_242"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Solomon Islands",
    d: "m1872.2,544.5l0.3,0.1l0.4,0.5l0.3,0.2l0.3,0.1l0.3,0.3l0.8,0.4l0.4,0.5l0,0.4l0.1,0.6l0.2,0.2l0.3,0.3l0.2,0l0.1,0.4l0.7,0.3l0.4,-0.1l0.1,0.1l0,0.3l-0.3,0.1l-0.2,0.3l-0.5,-0.2l-0.8,-0.4l-0.5,0l-0.3,-0.4l-0.7,-0.4l-0.6,-1l-0.6,-1l-0.5,-0.3l-0.7,-0.7l0,-0.5l0,-0.2l0.3,-0.2l0.3,0.1l0.2,0.2z",
    fill: "#cbd6f4",
    id: "svg_243"
  }), /*#__PURE__*/React.createElement("path", {
    className: "S\\xE3o Tom\\xE9 and Principe",
    d: "m1023.9,501.3l-0.2,0l-0.2,0.3l-0.2,0l-0.1,-0.4l-0.2,-0.8l0,-0.3l0.4,-0.5l0.3,-0.1l0.3,-0.3l0.4,0.1l0.2,0.4l0.1,0.3l-0.1,0.4l-0.2,0.3l-0.3,0.4l-0.2,0.2z",
    fill: "#cbd6f4",
    id: "svg_244"
  }), /*#__PURE__*/React.createElement("path", {
    className: "S\\xE3o Tom\\xE9 and Principe",
    d: "m1028.5,491.5l-0.1,0.3l-0.2,0.1l-0.3,-0.1l0,-0.3l0.2,-0.1l0,-0.3l0.2,-0.2l0.3,0.1l-0.1,0.5z",
    fill: "#cbd6f4",
    id: "svg_245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m634.2,386l0,0.1l-0.4,-0.1l0,-0.1l0.4,0.1z",
    fill: "#cbd6f4",
    id: "SX"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Seychelles",
    d: "m1249,562.1l-0.3,0.2l-0.5,0l-0.4,0.2l-0.4,0l0,-0.2l0.5,0l0.4,-0.1l0.4,-0.3l0.2,0l0.1,0.2z",
    fill: "#cbd6f4",
    id: "svg_246"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Seychelles",
    d: "m1248.5,561.8l-0.2,0.1l-0.4,0l0,-0.2l0.6,0.1z",
    fill: "#cbd6f4",
    id: "svg_247"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Seychelles",
    d: "m1300.4,531.5l0.4,0.4l-0.2,0.3l-0.2,-0.3l-0.3,-0.2l0.2,-0.5l0.1,0.3z",
    fill: "#cbd6f4",
    id: "svg_248"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Turks and Caicos Islands",
    d: "m587.7,361.6l0.7,0l0.3,0.4l-0.3,0l-0.3,-0.1l-0.5,0.1l-0.1,-0.3l0.2,-0.1z",
    fill: "#cbd6f4",
    id: "svg_249"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Turks and Caicos Islands",
    d: "m585,361.5l0.3,0.4l0.6,-0.1l-0.2,0.2l-0.6,0l-0.4,-0.2l0.3,-0.3z",
    fill: "#cbd6f4",
    id: "svg_250"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Turks and Caicos Islands",
    d: "m587.2,360.9l0,0.5l-0.5,-0.2l-0.1,-0.3l0.1,-0.1l0.5,0.1z",
    fill: "#cbd6f4",
    id: "svg_251"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Tonga",
    d: "m14.7,639.5l-0.5,-0.3l0,-0.2l0.3,-0.2l0.2,0.7z",
    fill: "#cbd6f4",
    id: "svg_252"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Tonga",
    d: "m11.9,637.4l0.3,0l0.4,0.3l0.3,0.1l0.2,-0.4l0.3,0.3l-0.3,0.3l0.1,0.2l-0.1,0.2l-0.2,-0.1l-0.3,-0.3l-0.7,-0.2l0,-0.4z",
    fill: "#cbd6f4",
    id: "svg_253"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Tonga",
    d: "m11.1,628.8l-0.2,0.1l-0.1,-0.5l0.2,0.1l0.1,0.3z",
    fill: "#cbd6f4",
    id: "svg_254"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Tonga",
    d: "m15.5,621.3l-0.5,0.3l-0.2,0l-0.1,-0.1l0.3,-0.5l0.3,0.1l0.2,0.2z",
    fill: "#cbd6f4",
    id: "svg_255"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Tonga",
    d: "m1.4,602l-0.1,0.1l-0.3,-0.1l0.1,-0.2l0.3,0l0,0.2z",
    fill: "#cbd6f4",
    id: "svg_256"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Trinidad and Tobago",
    d: "m642.8,432.2l-0.2,0.5l-0.3,0.4l-0.2,0.1l-0.1,0.4l0.2,0.6l-0.2,0.1l0,0.7l0.2,0.3l0.2,0.2l-0.2,0.2l-0.1,0.3l0,0.7l-0.2,0.1l-0.4,0.2l-0.5,0.1l-0.3,0l-0.5,0.1l-0.5,-0.1l-0.4,0.1l-0.3,-0.1l-0.5,0.2l-0.4,-0.2l-0.6,0l-0.3,0.2l-0.3,-0.1l0.5,-0.2l0.3,-0.3l0.4,-0.1l0.4,-0.3l0.2,-0.3l0.6,0.1l0.3,-0.4l-0.2,-0.8l0.2,-0.4l0,-0.5l0,-0.2l-0.3,-0.4l-0.3,-0.1l-0.4,-0.1l-0.1,-0.1l0.4,-0.3l1.1,-0.1l0.2,-0.2l1.1,0l0.1,-0.1l1.2,-0.2l0.2,0z",
    fill: "#cbd6f4",
    id: "svg_257"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Trinidad and Tobago",
    d: "m645.2,429l-0.1,0.5l-0.3,0.1l-0.4,0.3l-0.2,0l-0.7,0.4l-0.2,-0.2l0.3,-0.3l0.7,-0.5l0.9,-0.3z",
    fill: "#cbd6f4",
    id: "svg_258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1998.9,556.6l0,-0.2l0.1,0l0,0.1l-0.1,0.1z",
    fill: "#cbd6f4",
    id: "TV"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m642.2,417.4l-0.1,0.1l-0.5,-0.3l0,-0.4l0.2,-0.3l0.2,-0.5l0.4,0l0.1,0.4l-0.1,0.8l-0.2,0.2z",
    fill: "#cbd6f4",
    id: "VC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m626.1,383.4l-0.4,0.2l-0.1,0l-0.3,0.2l-0.1,-0.1l0.1,-0.3l0.6,-0.1l0.2,0.1z",
    fill: "#cbd6f4",
    id: "VG"
  }), /*#__PURE__*/React.createElement("path", {
    className: "United States Virgin Islands",
    d: "m624.5,387.8l0.3,0.3l-1.1,0.2l-0.1,-0.5l0.7,-0.2l0.2,0.2z",
    fill: "#cbd6f4",
    id: "svg_259"
  }), /*#__PURE__*/React.createElement("path", {
    className: "United States Virgin Islands",
    d: "m625.2,384l-0.2,0.2l-0.5,0l0,-0.2l0.3,-0.1l0.4,0.1z",
    fill: "#cbd6f4",
    id: "svg_260"
  }), /*#__PURE__*/React.createElement("path", {
    className: "United States Virgin Islands",
    d: "m623.8,383.8l0.4,0.3l-0.2,0.2l-0.3,-0.2l-0.5,0l0.2,-0.2l0.4,-0.1z",
    fill: "#cbd6f4",
    id: "svg_261"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vanuatu",
    d: "m1931.8,631.8l-0.5,-0.2l0.2,-0.4l0.5,-0.1l0.2,0.4l-0.1,0.2l-0.3,0.1z",
    fill: "#cbd6f4",
    id: "svg_262"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vanuatu",
    d: "m1930.6,628l-0.2,0l-0.3,-0.1l-0.4,-0.5l-0.1,-0.4l0,-0.4l0.2,-0.2l0.1,-0.4l0.3,-0.1l0.4,0l-0.2,0.3l0,0.5l0.7,0.5l-0.3,0.3l-0.2,0.5z",
    fill: "#cbd6f4",
    id: "svg_263"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vanuatu",
    d: "m1930.6,622.1l0.3,0l0.1,0.2l-0.5,0.1l0.1,0.3l0.4,0.2l0.1,0.3l-0.1,0.4l-0.4,0.1l-0.4,-0.3l-0.4,0l-0.2,-0.2l-0.3,-0.2l0.1,-0.4l0,-0.3l0.2,-0.5l0.3,-0.4l0.5,0l0.2,0.1l-0.1,0.4l0.1,0.2z",
    fill: "#cbd6f4",
    id: "svg_264"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vanuatu",
    d: "m1927.6,614.5l0.6,-0.1l0.1,0.1l0.2,0.6l0.2,0.3l0.1,0.1l-0.4,0.6l-0.8,0.2l-0.3,-0.3l-0.1,-0.5l-0.3,-0.1l-0.4,0.3l-0.1,-0.1l0.2,-0.4l0.4,-0.3l0.4,-0.5l0.2,0.1z",
    fill: "#cbd6f4",
    id: "svg_265"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vanuatu",
    d: "m1929.9,610.6l-0.1,-0.3l0.3,0l-0.2,0.3z",
    fill: "#cbd6f4",
    id: "svg_266"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vanuatu",
    d: "m1928.3,608.2l0.1,0.5l0,0.2l0.4,0.1l0.2,0.5l0.5,0l0,0.4l-0.1,0.1l-0.3,-0.3l-0.3,-0.1l-0.6,0.2l-0.3,-0.1l-0.1,-0.2l-0.1,-0.4l0.2,-0.5l0.2,-0.3l0.2,-0.1z",
    fill: "#cbd6f4",
    id: "svg_267"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vanuatu",
    d: "m1929.2,608l-0.1,0l-0.1,-0.3l0.2,0l0,0.3z",
    fill: "#cbd6f4",
    id: "svg_268"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vanuatu",
    d: "m1929.4,606.6l-0.2,0.2l-0.6,0l-0.3,0.1l-0.2,-0.2l-0.4,-0.1l-0.5,-0.4l0.1,-0.2l0.5,-0.2l0.4,-0.1l0.4,-0.3l0.1,-0.3l0.2,0l0.1,0.3l0,0.6l0.5,0.4l-0.1,0.2z",
    fill: "#cbd6f4",
    id: "svg_269"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vanuatu",
    d: "m1924.7,605.3l0.2,0.3l0.6,0.4l0.7,0.7l0.1,0.1l0,0.4l0.2,0.3l-0.3,0.2l-0.4,0.4l0,-0.2l-0.3,-0.1l-0.4,0l-0.2,0.1l0,0.2l-0.4,0.2l-0.3,-0.1l0,-0.7l-0.1,-0.6l0.1,-0.6l0.1,-0.5l-0.2,-0.5l-0.6,0.3l-0.2,-0.2l-0.1,-0.3l0,-0.3l0.3,-0.3l0,-0.4l0.1,-0.3l0.3,-0.1l0.6,0.3l-0.1,0.2l0.2,0.5l-0.1,0.2l0.2,0.4z",
    fill: "#cbd6f4",
    id: "svg_270"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vanuatu",
    d: "m1924.1,602.9l-0.3,0l-0.5,-0.3l0,-0.1l0.2,-0.3l0.2,-0.1l0.5,0.1l-0.1,0.4l0,0.3z",
    fill: "#cbd6f4",
    id: "svg_271"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vanuatu",
    d: "m1923.6,601.9l0.4,-0.3l0.1,0.1l0.1,0.3l-0.5,0l-0.1,-0.1z",
    fill: "#cbd6f4",
    id: "svg_272"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vanuatu",
    d: "m1929.3,604.5l-0.2,-0.1l0.1,-1.2l-0.1,-0.3l0.1,-0.5l0.3,-0.8l0.1,-0.5l0.2,0.6l-0.1,0.3l0,0.6l0,1l-0.1,0.6l-0.3,0.3z",
    fill: "#cbd6f4",
    id: "svg_273"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vanuatu",
    d: "m1928,601.2l-0.7,0l-0.3,-0.1l0,-0.2l0.9,-0.7l0.5,-0.2l0.5,-0.1l0,0.2l-0.3,0.4l-0.2,0.3l-0.4,0.4z",
    fill: "#cbd6f4",
    id: "svg_274"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vanuatu",
    d: "m1929.9,600.5l0,0.2l-0.3,0l0.1,-0.3l0.2,-1.3l0,-0.1l0.1,-1.2l0.2,0.1l-0.1,1.3l0.1,0.3l-0.1,0.5l-0.2,0.5z",
    fill: "#cbd6f4",
    id: "svg_275"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vanuatu",
    d: "m1923.6,601.9l-0.9,-0.1l-0.6,0.3l-0.1,0.2l-0.2,0l-0.1,-0.6l-0.2,-0.1l-0.4,-1l0.4,-0.8l0,-0.4l-0.1,-0.2l0,-1.4l-0.1,-0.3l0,-0.5l0.2,-0.3l0,-0.3l0.2,-0.3l0,-0.2l0.3,-0.1l0.1,0.5l0.2,0.4l0.2,0.3l0.1,1.3l-0.1,0.8l0,0.1l0.6,-0.1l0.3,-0.3l0.2,-0.8l0,-0.2l0.3,-0.2l0.3,0.1l-0.1,0.4l0,0.9l0.3,0.1l0,0.5l-0.2,0.1l0.3,0.4l-0.2,0.2l0,0.5l0.2,0.5l-0.1,0.2l-0.3,0l-0.5,0.4z",
    fill: "#cbd6f4",
    id: "svg_276"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vanuatu",
    d: "m1927.8,592.6l0.4,0.3l-0.1,0.4l-0.3,0.3l-0.2,0.2l-0.6,0l0,-0.4l0.1,-0.4l0.2,-0.3l0.5,-0.1z",
    fill: "#cbd6f4",
    id: "svg_277"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vanuatu",
    d: "m1928.4,590.7l-0.3,0.2l-0.2,0.1l0,0.2l-0.2,0.1l0,-0.3l-0.2,-0.2l-0.1,-0.3l0.1,-0.4l0.2,-0.1l0.4,-0.2l0.1,0.2l0.1,0.4l0,0.1l0.1,0.2z",
    fill: "#cbd6f4",
    id: "svg_278"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Vanuatu",
    d: "m1923.4,586.5l-0.1,-0.1l0.1,-0.5l0.2,0.2l-0.2,0.4z",
    fill: "#cbd6f4",
    id: "svg_279"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Samoa",
    d: "m21.9,591.3l0.3,0.1l0.3,0.1l0.3,0.2l-0.1,0.3l-1,0l-0.3,-0.1l-0.3,0.1l-0.2,-0.1l-0.4,-0.2l-0.3,0.1l-0.3,-0.2l-0.2,-0.2l-0.6,-0.3l0.1,-0.4l0.4,-0.2l0.4,0l0.5,0l0.9,0.4l0.5,0.1l0,0.3z",
    fill: "#cbd6f4",
    id: "svg_280"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Samoa",
    d: "m17.4,588.5l0.6,0.6l0.2,0.7l-0.1,0.3l0.1,0.3l-0.3,0l-0.3,-0.2l-0.3,0.2l-0.9,0.1l-0.3,-0.3l-0.2,-0.4l-0.2,-0.1l-0.3,-0.3l-0.5,-0.4l-0.2,-0.2l0,-0.2l0.4,0.1l0.3,-0.1l0.6,-0.2l0.4,0l0.5,-0.1l0.3,0l0.2,0.2z",
    fill: "#cbd6f4",
    id: "svg_281"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m602,424.6l-0.2,0l-0.1,-0.5l0.1,-0.3l-0.1,-0.3l-0.4,-0.1l-0.3,-0.3l0.1,-0.3l1.2,0.6l-0.1,0.2l0,0.4l-0.2,0.2l0,0.4z",
    fill: "#cbd6f4",
    id: "BQBO"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m634.3,389.6l-0.2,0.1l0,-0.2l0.1,-0.1l0.1,0.2z",
    fill: "#cbd6f4",
    id: "BQSE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m632.8,388.7l-0.1,0l0.1,-0.2l0.1,0.1l-0.1,0.1z",
    fill: "#cbd6f4",
    id: "BQSA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m644,406.9l0,0.2l0.4,-0.1l-0.2,0.5l0.2,0.2l0,0.2l0.2,0.2l0.2,0.9l-0.3,0.3l-0.1,-0.4l-0.1,0.1l-0.6,-0.1l-0.4,0l-0.2,-0.3l0.6,-0.5l-0.4,0l-0.4,-0.4l-0.1,-0.5l-0.2,-0.5l0.3,-0.4l0.4,0.1l0.5,0.3l0.2,0.2z",
    fill: "#cbd6f4",
    id: "MQ"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canary Islands (Spain)",
    d: "m888.4,323.4l-0.3,0.5l-0.4,0.5l-0.3,-0.4l-0.4,0l-0.2,-0.2l0.2,-0.3l0.4,0.1l0.4,-0.4l0.3,-0.2l0.2,0.1l0.1,0.3z",
    fill: "#cbd6f4",
    id: "svg_282"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canary Islands (Spain)",
    d: "m902,321.1l0,0.5l0.2,0.4l-0.2,0.7l0.1,0.3l-0.4,0.4l-0.5,0.2l-0.2,0.2l-0.6,-0.2l-0.5,-0.5l-0.2,-0.4l0,-0.6l0.6,-0.4l0.1,-0.5l0,-0.2l0.6,0.1l0.4,0l0.3,0.1l0.3,-0.1z",
    fill: "#cbd6f4",
    id: "svg_283"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canary Islands (Spain)",
    d: "m892.1,321.9l-0.2,0l-0.3,-0.2l-0.2,-0.3l0.1,-0.4l0.1,-0.3l0.3,0l0.3,0l0.5,0.4l0.1,0.3l-0.5,0.5l-0.2,0z",
    fill: "#cbd6f4",
    id: "svg_284"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canary Islands (Spain)",
    d: "m898.2,318.4l0,0.2l-0.6,0.3l-0.4,0.5l-0.3,0.2l0,0.4l-0.4,0.7l-0.1,0.4l-0.5,0.6l-0.1,0.2l-0.2,0l-0.6,0.2l-0.1,-0.1l-0.1,-0.4l-0.3,-0.4l-0.1,-0.2l-0.2,-0.3l0,-0.3l-0.4,-0.6l0.5,-0.3l0.3,0.2l0.6,-0.2l0.4,0l0.5,-0.2l0.5,-0.4l0,-0.2l0.6,-0.3l0.6,0l0.3,-0.1l0.1,0.1z",
    fill: "#cbd6f4",
    id: "svg_285"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canary Islands (Spain)",
    d: "m908.4,321.2l-0.3,0.4l-0.4,0.1l-0.3,-0.1l-0.4,0l0,-0.2l0.3,0l0.6,-0.2l0.4,-0.3l0.3,-0.3l0.1,-0.5l0.1,-0.3l0.2,-0.5l0.3,-0.4l0.3,-0.6l0.2,-0.8l0.2,-0.2l0.4,-0.1l0.3,0.3l0.1,0.5l-0.1,0.5l-0.1,0.5l0,0.5l-0.1,0.1l-0.3,0.7l-0.3,0.3l-0.6,0.1l-0.7,0.3l-0.2,0.2z",
    fill: "#cbd6f4",
    id: "svg_286"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canary Islands (Spain)",
    d: "m888.8,316.7l0.3,-0.1l0.2,0.3l0.2,0.5l-0.2,0.3l0.1,0.4l-0.6,1l-0.1,-0.1l-0.1,-0.4l-0.4,-0.9l-0.1,-0.3l-0.1,-0.2l0.2,-0.4l0.3,-0.2l0.3,0.1z",
    fill: "#cbd6f4",
    id: "svg_287"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Canary Islands (Spain)",
    d: "m912.9,314.7l0,0.4l-0.2,0.5l-0.7,0.5l-0.5,0.1l-0.4,0.5l-0.5,-0.2l0,-0.1l0.2,-0.4l0,-0.4l0.2,-0.3l0.3,-0.2l0.3,0l0.3,-0.3l0.5,0l0.1,-0.1l0.2,-0.5l0.2,-0.1l0.2,0.2l-0.2,0.4z",
    fill: "#cbd6f4",
    id: "svg_288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1240.2,583.1l0.2,0.3l0.5,0.2l0,0.3l-0.2,0.2l0.1,0.2l-0.3,0.6l0.1,0.2l-0.3,0.1l-0.2,-0.3l0,-0.3l0.2,-0.2l-0.2,-0.7l-0.1,-0.1l-0.1,-0.2l0.3,-0.3z",
    fill: "#cbd6f4",
    id: "YT"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1295,635.8l0.4,0l0.4,0.2l0.3,0.3l0,0.3l0.1,0.5l0.3,0.2l0.2,0.2l0.1,0.2l-0.2,0.6l-0.1,0.4l-0.2,0.2l-0.4,0.1l-0.9,0l-0.2,-0.2l-0.8,-0.4l-0.3,-0.5l0,-0.3l-0.3,-0.6l0.1,-0.4l0.2,-0.2l0.2,-0.4l0.1,0l0.5,-0.2l0.5,0z",
    fill: "#cbd6f4",
    id: "RE"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Guadeloupe",
    d: "m643,399.9l-0.3,0l-0.2,-0.4l0.1,-0.2l0.3,-0.3l0.3,0.2l0.1,0.3l0,0.2l-0.3,0.2z",
    fill: "#cbd6f4",
    id: "svg_289"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Guadeloupe",
    d: "m641.2,397.3l0.3,0l0,0.2l0,0.1l-0.2,0.1l0,0.8l0,0.4l-0.2,0.2l-0.6,0.3l0,-0.2l-0.2,-0.2l-0.1,-0.5l0,-0.5l-0.1,-0.5l0,-0.3l0.2,-0.3l0.3,-0.1l0.5,0.3l0.1,0.2z",
    fill: "#cbd6f4",
    id: "svg_290"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Guadeloupe",
    d: "m642.6,396.9l0.4,0.1l0.5,0.4l-1.3,0.3l-0.3,0.1l-0.4,-0.3l0.1,-0.6l0.2,-0.1l-0.1,-0.6l0.1,-0.2l0.3,-0.2l0.3,0.4l0,0.4l0.2,0.3z",
    fill: "#cbd6f4",
    id: "svg_291"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Fiji",
    d: "m1989.1,624.9l-0.3,0.1l0.1,-0.4l0.2,0.3z",
    fill: "#cbd6f4",
    id: "svg_292"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Fiji",
    d: "m1981.6,623.3l0.2,0.2l0.3,0.1l0,0.3l-0.5,0.2l-0.5,-0.3l-0.5,0.3l-0.3,0l-0.2,0.3l0.1,0.3l-0.4,-0.1l-0.1,0.2l-0.4,-0.1l-0.1,0.1l-0.4,-0.2l0.3,-0.1l0.2,-0.1l0.2,-0.2l0.4,0.1l0.3,-0.3l0.2,-0.3l0.5,-0.1l0.5,-0.3l0.2,0z",
    fill: "#cbd6f4",
    id: "svg_293"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Fiji",
    d: "m1982.5,623.2l-0.2,0.1l-0.2,-0.1l0.2,-0.2l0.2,0.2z",
    fill: "#cbd6f4",
    id: "svg_294"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Fiji",
    d: "m1988.4,617.1l0.1,0.5l-0.2,0.6l-0.1,-0.2l-0.1,-0.4l-0.2,0l0.1,-0.5l0.2,-0.1l0.2,0.1z",
    fill: "#cbd6f4",
    id: "svg_295"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Fiji",
    d: "m1985.8,615.7l-0.1,0l-0.1,-0.4l0.2,-0.2l0.4,-0.1l0,0.4l-0.2,0.2l-0.2,0.1z",
    fill: "#cbd6f4",
    id: "svg_296"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Fiji",
    d: "m1983.6,613.2l-0.1,0.4l0.3,0.2l0.1,0.3l0.3,0.4l0.3,0.1l0.1,0.3l0.2,0l0.1,0.4l-0.3,0.5l0.1,0.2l0.1,0.5l-0.3,0.2l0,0.5l0.2,0l0.1,0.5l-0.3,0.3l-0.6,0.2l-0.1,-0.2l-0.3,0.1l-0.1,0.2l-0.3,-0.3l-0.8,0.3l-0.8,0.7l-0.3,-0.1l-0.4,0.2l-0.3,-0.1l-0.6,0.1l-0.3,-0.2l-0.9,-0.3l-0.3,-0.1l-0.6,-0.1l-0.2,-0.1l-0.5,-0.2l-0.2,-1l0.3,-0.7l0.3,0l0.3,-0.1l0.1,-0.5l0.3,-0.1l0.1,-0.4l-0.2,-0.2l0.6,-0.4l0.4,-0.5l0.1,0.1l0.6,-0.5l0.2,0l0.9,-0.4l0.6,0.2l0.3,-0.1l0.5,-0.2l0.6,-0.1l0.3,-0.3l0.4,0.3z",
    fill: "#cbd6f4",
    id: "svg_297"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Fiji",
    d: "m1989.9,613.4l-0.2,0.1l0.2,-0.9l0.4,0l-0.1,0.4l-0.3,0.4z",
    fill: "#cbd6f4",
    id: "svg_298"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Fiji",
    d: "m1978.5,611.4l-0.2,0.3l-0.5,0.3l0,-0.3l0.4,-0.4l0.3,0.1z",
    fill: "#cbd6f4",
    id: "svg_299"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Fiji",
    d: "m1993.4,611l-0.2,-0.2l0.1,-0.2l0.5,-0.5l0.3,-0.5l-0.3,1.1l-0.4,0.3z",
    fill: "#cbd6f4",
    id: "svg_300"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Fiji",
    d: "m1994.4,606l-0.4,0.4l-0.8,1.1l-0.3,0.1l-0.7,0.4l-0.2,0.6l-0.4,0.2l-0.2,0.3l-0.1,0.2l0.3,0.1l0.6,-0.3l0.1,-0.1l0.3,-0.3l0.2,-0.3l0.6,-0.3l0.3,-0.3l0.6,-0.3l0,0.3l-0.5,0.7l-0.2,0.1l0.1,0.6l-0.3,0.3l-0.3,-0.3l-0.4,0l-0.5,0.1l-0.4,0.3l-0.7,0.1l-1,0l0.5,-0.5l-0.4,-0.2l-0.6,0.2l-0.4,0.2l0,0.2l-0.3,0.1l-0.2,0.1l-0.1,0.4l-0.2,0.3l-0.3,-0.1l0,-0.2l-0.4,-0.1l-0.4,0.2l-0.2,0.5l-0.3,0.2l-0.3,0l0,-0.3l0,-0.4l-0.2,-0.4l0.1,-0.2l-0.1,-0.1l-0.6,0.2l0,-0.4l0.4,-0.3l0.1,0l-0.1,-0.5l0.3,-0.1l0.5,0.3l0.6,-0.4l0.2,0l0.3,-0.3l0.2,0l0.3,-0.3l0,-0.2l0.8,-0.1l0.9,-0.3l0.3,-0.1l0.4,0.1l0.5,-0.2l0.2,-0.4l0.2,0l0.2,-0.4l0.4,0.1l0.1,-0.2l0.2,0.1l1,-0.5l0.1,0.3l0.2,-0.1l0.2,0.1l0.3,-0.3l0.5,-0.2l0.1,0.1l-0.5,0.4l-0.2,0z",
    fill: "#cbd6f4",
    id: "svg_301"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 997.9,
    cy: 189.1,
    fill: "#cbd6f4",
    id: 0
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 673.5,
    cy: 724.1,
    fill: "#cbd6f4",
    id: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1798.2,
    cy: 719.3,
    fill: "#cbd6f4",
    id: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld5);
export default __webpack_public_path__ + "static/media/world5.fc8893be6ac390eb66576ce7d0d7f808.svg";
export { ForwardRef as ReactComponent };